/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version null on 2025-05-23 16:31:27.

export interface TokenResponse {
  token: string;
  lastName: string;
  firstName: string;
}

export interface AlignmentSimilarity extends ApiObject {
  '@type': 'CourseSimilarity' | 'ProgramSimilarity';
  ctrlNumberMatches: boolean;
  matchQuality: number;
}

export interface ICourseSimilarity extends AlignmentSimilarity {
  '@type': 'CourseSimilarity';
  titleSimilarity: number;
  subjectAndNumberSimilarity: SubjectAndNumberSimilarity;
}

export interface ICourseSummaryForAlignment extends EntitySummaryForAlignment {
  '@type': 'CourseSummaryForAlignment';
}

export interface CourseSimilarity extends ICourseSimilarity {
  '@type': 'CourseSimilarity';
}

export interface CourseSummaryForAlignment extends ICourseSummaryForAlignment {
  '@type': 'CourseSummaryForAlignment';
  subjectAndNumber: string;
  title?: string;
  cccControlNumber?: string;
  description?: string;
}

export interface EntitySummaryForAlignment extends ApiObject {
  '@type': 'CourseSummaryForAlignment' | 'ProgramSummaryForAlignment';
  active: boolean;
}

export interface IProgramSimilarity extends AlignmentSimilarity {
  '@type': 'ProgramSimilarity';
  titleSimilarity: number;
  awardTypeSimilarity: AwardTypeSimilarity;
}

export interface IProgramSummaryForAlignment extends EntitySummaryForAlignment {
  '@type': 'ProgramSummaryForAlignment';
}

export interface ProgramSimilarity extends IProgramSimilarity {
  '@type': 'ProgramSimilarity';
}

export interface ProgramSummaryForAlignment extends IProgramSummaryForAlignment {
  '@type': 'ProgramSummaryForAlignment';
  title: string;
  awardType: AwardType;
  cccControlNumber?: string;
  description?: string;
}

export interface BadgeRowWithNumber extends IBadgeRowWithNumber {
  '@type': 'BadgeRowWithNumber';
}

export interface BaseAmendRow extends ApiObject {
  '@type': 'CourseActiveAmendHandler$CourseActiveAmendRow' | 'CourseDescriptionAmendHandler$CourseDescriptionAmendRow' | 'CourseRequisitesAmendHandler$CourseRequisitesAmendRow' | 'CourseUnitsAmendHandler$CourseUnitsAmendRow' | 'ProgramActiveAmendHandler$ProgramActiveAmendRow' | 'ProgramBadgeClassAmendHandler$ProgramBadgeClassAmendRow' | 'ProgramDescriptionAmendHandler$ProgramDescriptionAmendRow' | 'ProgramLearningOutcomesAmendHandler$ProgramOutcomesAmendRow' | 'ProgramVideoAmendHandler$ProgramVideoAmendRow';
}

export interface IBadgeRowWithNumber extends RowWithNumber {
  '@type': 'BadgeRowWithNumber';
  row: IImportedBadgeRow;
}

export interface CourseActiveAmendRow extends CourseAmendRow {
  '@type': 'CourseActiveAmendHandler$CourseActiveAmendRow';
  active: string;
}

export interface CourseAmendRow extends BaseAmendRow {
  '@type': 'CourseActiveAmendHandler$CourseActiveAmendRow' | 'CourseDescriptionAmendHandler$CourseDescriptionAmendRow' | 'CourseRequisitesAmendHandler$CourseRequisitesAmendRow' | 'CourseUnitsAmendHandler$CourseUnitsAmendRow';
  subjectAndNumber: string;
  cccControlNumber: string;
  title: string;
}

export interface CourseDescriptionAmendRow extends CourseAmendRow {
  '@type': 'CourseDescriptionAmendHandler$CourseDescriptionAmendRow';
  description: string;
}

export interface CourseRequisitesAmendRow extends CourseAmendRow {
  '@type': 'CourseRequisitesAmendHandler$CourseRequisitesAmendRow';
  coreqs: string[];
  prereqs: string[];
}

export interface CourseRowWithNumber extends ICourseRowWithNumber {
  '@type': 'CourseRowWithNumber';
}

export interface CourseUnitsAmendRow extends CourseAmendRow {
  '@type': 'CourseUnitsAmendHandler$CourseUnitsAmendRow';
  minUnits: string;
  maxUnits: string;
}

export interface ICourseRowWithNumber extends RowWithNumber {
  '@type': 'CourseRowWithNumber';
  row: CourseAmendRow;
}

export interface ProgramActiveAmendRow extends ProgramAmendRow {
  '@type': 'ProgramActiveAmendHandler$ProgramActiveAmendRow';
  active: string;
}

export interface IProgramRowWithNumber extends RowWithNumber {
  '@type': 'ProgramRowWithNumber';
  row: ProgramAmendRow;
}

export interface ProgramAmendRow extends BaseAmendRow {
  '@type': 'ProgramActiveAmendHandler$ProgramActiveAmendRow' | 'ProgramBadgeClassAmendHandler$ProgramBadgeClassAmendRow' | 'ProgramDescriptionAmendHandler$ProgramDescriptionAmendRow' | 'ProgramLearningOutcomesAmendHandler$ProgramOutcomesAmendRow' | 'ProgramVideoAmendHandler$ProgramVideoAmendRow';
  cccControlNumber: string;
  awardType: string;
  title: string;
}

export interface ProgramBadgeClassAmendRow extends ProgramAmendRow {
  '@type': 'ProgramBadgeClassAmendHandler$ProgramBadgeClassAmendRow';
  badgeClassUrl: string;
}

export interface ProgramDescriptionAmendRow extends ProgramAmendRow {
  '@type': 'ProgramDescriptionAmendHandler$ProgramDescriptionAmendRow';
  description: string;
}

export interface ProgramOutcomesAmendRow extends ProgramAmendRow {
  '@type': 'ProgramLearningOutcomesAmendHandler$ProgramOutcomesAmendRow';
  learningOutcomes: string[];
}

export interface ProgramRowWithNumber extends IProgramRowWithNumber {
  '@type': 'ProgramRowWithNumber';
}

export interface ProgramVideoAmendRow extends ProgramAmendRow {
  '@type': 'ProgramVideoAmendHandler$ProgramVideoAmendRow';
  youtubeVideoId: string;
}

export interface ApiRequestMessage<TResponse> extends ApiObject {
  '@type': 'ApiEntityRequest';
  '@response'?: TResponse;
}

export interface ApiEntity<TId> extends ApiObject {
  '@type': 'EntityAliasApiEntity' | 'EntitySetApiEntity';
  id?: TId;
}

export interface ApiEntityAction<TResponse> extends ApiObject {
  '@type': 'FindCoursesAction' | 'FindProgramsAction' | 'AcceptAlignmentSuggestion' | 'AggregateAlignmentCounts' | 'AggregateCleanCounts' | 'AggregateNoticeCounts' | 'AggregateSourceCounts' | 'ArchiveCurriculumYearAction' | 'CourseListAddRequest' | 'CourseListByIdAction' | 'CreateCurriculumYearAction' | 'CreateHighSchoolAction' | 'CurriculumEntityDetailAction' | 'DeleteCourseListAction' | 'EditCurriculumNotesAction' | 'EditHighSchoolAction' | 'FindCipCodesAction' | 'FindCollegeBySlugAction' | 'FindCourseListsAction' | 'FindCurriculumYearAction' | 'FindCurriculumYearsForCollegeAction' | 'FindGenEdPatternsAction' | 'FindImportedBadgesAction' | 'FindPickableCollegesAction' | 'FindPickableCoursesAction' | 'FindTopCodesAction' | 'GenerateCollegeReportAction' | 'GetCoursesByHighSchoolAction' | 'GetCurriculumYearHistoryAction' | 'GetDuplicateImportedCoursesAction' | 'GetGenEdPatternAction' | 'GetImportedCoursesAction' | 'GetImportedProgramsAction' | 'GetImportedProgramsMissingTitleAndAwardAction' | 'MarkPublishedAction' | 'PublishCurriculumAction' | 'PublishPreviewAction' | 'RecordMutationAction' | 'RejectSuggestions' | 'SearchHighSchoolsByCollegeAction' | 'SourceRecordDetailAction' | 'UpdateCourseListAction' | 'UpdateGenEdAction' | 'ListCoursesWithAlignmentSuggestions' | 'ListProgramsWithAlignmentSuggestions' | 'SearchCourseAlignmentCandidates' | 'SearchProgramAlignmentCandidates';
  '@response'?: TResponse;
}

export interface ApiEntityId extends ApiObject {
  '@type': 'DummyEntityAliasApiEntityId' | 'DummyEntitySetApiEntityId' | 'DummyApiEntityId';
}

export interface ApiEntityRequest extends ApiRequestMessage<ApiEntityResponse> {
  '@type': 'ApiEntityRequest';
  actions: ApiEntityAction<any>[];
  requestedIds: ApiEntityId[];
  currentIds: ApiEntityId[];
  '@response'?: ApiEntityResponse;
}

export interface ApiEntityResponse extends ApiObject {
  '@type': 'ApiEntityResponse';
  actionResponses: ApiObject[];
  entities: ApiEntity<any>[];
  invalidatedIds: ApiEntityId[];
}

export interface EntityAliasApiEntity<TAliasId, TTargetId> extends ApiEntity<TAliasId> {
  '@type': 'EntityAliasApiEntity';
  id?: TAliasId;
  targetId: TTargetId;
}

export interface EntityAliasApiEntityId extends ApiEntityId {
  '@type': 'DummyEntityAliasApiEntityId';
}

export interface EntitySetApiEntity<TSetId, TEntityId> extends ApiEntity<TSetId> {
  '@type': 'EntitySetApiEntity';
  id?: TSetId;
  entityIds: TEntityId[];
}

export interface EntitySetApiEntityId extends ApiEntityId {
  '@type': 'DummyEntitySetApiEntityId';
}

export interface AcceptAlignmentSuggestion extends IAcceptAlignmentSuggestion {
  '@type': 'AcceptAlignmentSuggestion';
}

export interface AcceptSuggestionResult extends IAcceptSuggestionResult {
  '@type': 'AcceptSuggestionResult';
}

export interface AddCorrectionsAction extends IAddCorrectionsAction {
  '@type': 'AddCorrectionsAction';
}

export interface AddLocalCourseAction extends IAddLocalCourseAction {
  '@type': 'AddLocalCourseAction';
}

export interface AddLocalProgramAction extends IAddLocalProgramAction {
  '@type': 'AddLocalProgramAction';
}

export interface AggregateAlignmentCounts extends IAggregateAlignmentCounts {
  '@type': 'AggregateAlignmentCounts';
  collegeSlug: string;
  curriculumYear: number;
  entityType: PipelineEntityType;
}

export interface AggregateCleanCounts extends IAggregateCleanCounts {
  '@type': 'AggregateCleanCounts';
  collegeSlug: string;
  curriculumYear: number;
  entityType: PipelineEntityType;
  customGroups: { [index: string]: string[] };
}

export interface AggregateNoticeCounts extends IAggregateNoticeCounts {
  '@type': 'AggregateNoticeCounts';
  collegeSlug: string;
  curriculumYear: number;
  entityType: CurriculumEntityType;
  customGroups: { [index: string]: string[] };
}

export interface AggregateSourceCounts extends IAggregateSourceCounts {
  '@type': 'AggregateSourceCounts';
  collegeSlug: string;
  curriculumYear: number;
  entityType: PipelineEntityType;
}

export interface ArchiveCurriculumYearAction extends IArchiveCurriculumYearAction {
  '@type': 'ArchiveCurriculumYearAction';
}

export interface BulkAmendCorrectionsAction extends IBulkAmendCorrectionsAction {
  '@type': 'BulkAmendCorrectionsAction';
}

export interface BulkAmendTypeApiObject extends IBulkAmendTypeApiObject {
  '@type': 'BulkAmendTypeApiObject';
}

export interface CleanCounts extends ICleanCounts {
  '@type': 'CleanCounts';
}

export interface CollegeNotFound extends ICollegeNotFound {
  '@type': 'CollegeNotFound';
}

export interface CorrectMultipleRecords extends ICorrectMultipleRecords {
  '@type': 'CorrectMultipleRecords';
}

export interface CourseApiObject extends ICourseApiObject {
  '@type': 'CourseApiObject';
}

export interface CourseForPublishPreview extends ICourseForPublishPreview {
  '@type': 'CourseForPublishPreview';
}

export interface CourseForSearchResult extends ICourseForSearchResult {
  '@type': 'CourseForSearchResult';
}

export interface CourseListAddRequest extends ICourseListAddRequest {
  '@type': 'CourseListAddRequest';
}

export interface CourseListApiObject extends ICourseListApiObject {
  '@type': 'CourseListApiObject';
}

export interface CourseListByIdAction extends ICourseListByIdAction {
  '@type': 'CourseListByIdAction';
}

export interface CourseListForPublishPreview extends ICourseListForPublishPreview {
  '@type': 'CourseListForPublishPreview';
}

export interface CourseListId extends ICourseListId {
  '@type': 'CourseListId';
}

export interface CourseSourceRecordSummary extends ICourseSourceRecordSummary {
  '@type': 'CourseSourceRecordSummary';
}

export interface CreateCurriculumYearAction extends ICreateCurriculumYearAction {
  '@type': 'CreateCurriculumYearAction';
}

export interface CreateHighSchoolAction extends ICreateHighSchoolAction {
  '@type': 'CreateHighSchoolAction';
}

export interface CreateHighSchoolResponse extends ICreateHighSchoolResponse {
  '@type': 'CreateHighSchoolResponse';
}

export interface CurriculumEntityDetailAction extends ICurriculumEntityDetailAction {
  '@type': 'CurriculumEntityDetailAction';
}

export interface CurriculumEntityDetailApiObject extends ApiObject {
  '@type': 'CourseApiObject' | 'ProgramApiObject';
}

export interface CurriculumEntityDetailMissing extends ICurriculumEntityDetailMissing {
  '@type': 'CurriculumEntityDetailMissing';
}

export interface CurriculumEntityForSearchResult extends ApiObject {
  '@type': 'CourseForSearchResult' | 'ProgramForSearchResult';
  clean: boolean;
}

export interface CurriculumEntityId extends ICurriculumEntityId {
  '@type': 'CurriculumEntityId';
}

export interface CurriculumEntitySummary extends ICurriculumEntitySummary {
  '@type': 'CurriculumEntitySummary';
}

export interface CurriculumRevisionApiObject extends ICurriculumRevisionApiObject {
  '@type': 'CurriculumRevisionApiObject';
}

export interface CurriculumYearCreationError extends ICurriculumYearCreationError {
  '@type': 'CurriculumYearCreationError';
}

export interface CurriculumYearCreationSuccess extends ICurriculumYearCreationSuccess {
  '@type': 'CurriculumYearCreationSuccess';
}

export interface CurriculumYearHistoryResponse extends ICurriculumYearHistoryResponse {
  '@type': 'CurriculumYearHistoryResponse';
}

export interface CurriculumYearNotFoundError extends ICurriculumYearNotFoundError {
  '@type': 'CurriculumYearNotFoundError';
}

export interface CurriculumYearsForCollegeResponse extends ApiObject {
  '@type': 'CurriculumYearsForCollegeResponse';
  years: number[];
}

export interface DeactivateSourceSystemAction extends IDeactivateSourceSystemAction {
  '@type': 'DeactivateSourceSystemAction';
}

export interface DeleteCourseListAction extends IDeleteCourseListAction {
  '@type': 'DeleteCourseListAction';
}

export interface DummyApiEntityId extends ApiEntityId {
  '@type': 'DummyApiEntityId';
}

export interface DummyEntityAliasApiEntityId extends EntityAliasApiEntityId {
  '@type': 'DummyEntityAliasApiEntityId';
}

export interface DummyEntitySetApiEntityId extends EntitySetApiEntityId {
  '@type': 'DummyEntitySetApiEntityId';
}

export interface DuplicateImportedCoursesResponse extends IDuplicateImportedCoursesResponse {
  '@type': 'DuplicateImportedCoursesResponse';
}

export interface EditCurriculumNotesAction extends IEditCurriculumNotesAction {
  '@type': 'EditCurriculumNotesAction';
}

export interface EditHighSchoolAction extends IEditHighSchoolAction {
  '@type': 'EditHighSchoolAction';
}

export interface EditHighSchoolResponse extends IEditHighSchoolResponse {
  '@type': 'EditHighSchoolResponse';
}

export interface EntityIsAlignedError extends IEntityIsAlignedError {
  '@type': 'EntityIsAlignedError';
}

export interface EntityIsMissingCriticalDataError extends IEntityIsMissingCriticalDataError {
  '@type': 'EntityIsMissingCriticalDataError';
}

export interface FetchAndImportSourceFileAction extends IFetchAndImportSourceFileAction {
  '@type': 'FetchAndImportSourceFileAction';
}

export interface FindCipCodesAction extends IFindCipCodesAction {
  '@type': 'FindCipCodesAction';
}

export interface FindCipCodesResponse extends IFindCipCodesResponse {
  '@type': 'FindCipCodesResponse';
}

export interface FindCollegeBySlugAction extends IFindCollegeBySlugAction {
  '@type': 'FindCollegeBySlugAction';
}

export interface FindCourseListsAction extends IFindCourseListsAction {
  '@type': 'FindCourseListsAction';
}

export interface FindCoursesAction extends IFindCoursesAction {
  '@type': 'FindCoursesAction';
}

export interface FindCurriculumEntitiesAction<TResponse> extends ApiEntityAction<TResponse>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'FindCoursesAction' | 'FindProgramsAction';
}

export interface FindCurriculumYearAction extends IFindCurriculumYearAction {
  '@type': 'FindCurriculumYearAction';
}

export interface FindCurriculumYearsForCollegeAction extends IFindCurriculumYearsForCollegeAction {
  '@type': 'FindCurriculumYearsForCollegeAction';
}

export interface FindGenEdPatternsAction extends IFindGenEdPatternsAction {
  '@type': 'FindGenEdPatternsAction';
}

export interface FindGenEdPatternsResponse extends IFindGenEdPatternsResponse {
  '@type': 'FindGenEdPatternsResponse';
}

export interface FindImportedBadgesAction extends IFindImportedBadgesAction {
  '@type': 'FindImportedBadgesAction';
}

export interface FindImportedBadgesResponse extends IFindImportedBadgesResponse {
  '@type': 'FindImportedBadgesResponse';
}

export interface FindPickableCollegesAction extends IFindPickableCollegesAction {
  '@type': 'FindPickableCollegesAction';
}

export interface FindPickableCollegesResponse extends IFindPickableCollegesResponse {
  '@type': 'FindPickableCollegesResponse';
}

export interface FindPickableCoursesAction extends IFindPickableCoursesAction {
  '@type': 'FindPickableCoursesAction';
}

export interface FindPickableCoursesResponse extends IFindPickableCoursesResponse {
  '@type': 'FindPickableCoursesResponse';
}

export interface FindProgramsAction extends IFindProgramsAction {
  '@type': 'FindProgramsAction';
}

export interface FindTopCodesAction extends IFindTopCodesAction {
  '@type': 'FindTopCodesAction';
}

export interface FindTopCodesResponse extends IFindTopCodesResponse {
  '@type': 'FindTopCodesResponse';
}

export interface GenEdPatternApiObject extends IGenEdPatternApiObject {
  '@type': 'GenEdPatternApiObject';
}

export interface GenEdPatternArea extends IGenEdPatternArea {
  '@type': 'GenEdPatternArea';
}

export interface GenEdPatternForPublishPreview extends IGenEdPatternForPublishPreview {
  '@type': 'GenEdPatternForPublishPreview';
}

export interface GenEdPatternNode extends ApiObject {
  '@type': 'GenEdPatternArea' | 'GenEdPatternSubArea';
  id: string;
  longDescription: string;
  title: string;
  area: string;
  shortDescription: string;
}

export interface IGenEdPatternArea extends WithGenEdPatternArea, GenEdPatternNode {
  '@type': 'GenEdPatternArea';
  pickedCourses?: IPickedCourse[];
  subAreas?: GenEdPatternSubArea[];
}

export interface IGenEdPatternSubArea extends GenEdPatternNode {
  '@type': 'GenEdPatternSubArea';
  pickedCourses: IPickedCourse[];
}

export interface GenEdPatternSubArea extends IGenEdPatternSubArea {
  '@type': 'GenEdPatternSubArea';
}

export interface GenerateCollegeReportAction extends IGenerateCollegeReportAction {
  '@type': 'GenerateCollegeReportAction';
}

export interface GetAlignmentSuggestionsError extends ApiObject {
  '@type': 'EntityIsAlignedError' | 'EntityIsMissingCriticalDataError' | 'NoSuchEntityAlignmentError';
}

export interface IEntityIsAlignedError extends GetAlignmentSuggestionsError {
  '@type': 'EntityIsAlignedError';
}

export interface IEntityIsMissingCriticalDataError extends GetAlignmentSuggestionsError {
  '@type': 'EntityIsMissingCriticalDataError';
}

export interface INoSuchEntityAlignmentError extends GetAlignmentSuggestionsError {
  '@type': 'NoSuchEntityAlignmentError';
}

export interface GetCoursesByHighSchoolAction extends IGetCoursesByHighSchoolAction {
  '@type': 'GetCoursesByHighSchoolAction';
}

export interface GetCoursesByHighSchoolResponse extends IGetCoursesByHighSchoolResponse {
  '@type': 'GetCoursesByHighSchoolResponse';
}

export interface GetCurriculumYearHistoryAction extends IGetCurriculumYearHistoryAction {
  '@type': 'GetCurriculumYearHistoryAction';
}

export interface GetDuplicateImportedCoursesAction extends IGetDuplicateImportedCoursesAction {
  '@type': 'GetDuplicateImportedCoursesAction';
}

export interface GetGenEdPatternAction extends IGetGenEdPatternAction {
  '@type': 'GetGenEdPatternAction';
}

export interface GetImportedCoursesAction extends IGetImportedCoursesAction {
  '@type': 'GetImportedCoursesAction';
}

export interface GetImportedProgramsAction extends IGetImportedProgramsAction {
  '@type': 'GetImportedProgramsAction';
}

export interface GetImportedProgramsMissingTitleAndAwardAction extends IGetImportedProgramsMissingTitleAndAwardAction {
  '@type': 'GetImportedProgramsMissingTitleAndAwardAction';
}

export interface HighSchoolCoursesApiObject extends IHighSchoolCoursesApiObject {
  '@type': 'HighSchoolCoursesApiObject';
}

export interface IAcceptAlignmentSuggestion extends ApiEntityAction<ApiEither<EnumWrapper<AlignmentError>, Nothing>>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'AcceptAlignmentSuggestion';
  collegeSlug: string;
  curriculumYear: number;
  entityKey: string;
  suggestionKey: string;
  alignToIdentifiers: IdentifyingValues<any>;
  '@response'?: ApiEither<EnumWrapper<AlignmentError>, Nothing>;
}

export interface IAcceptSuggestionResult extends ApiObject {
  '@type': 'AcceptSuggestionResult';
}

export interface IAddCorrectionsAction extends RecordMutationApiAction<Nothing> {
  '@type': 'AddCorrectionsAction';
  recordKey: RecordKey;
  corrections: Correction<any, any>[];
  '@response'?: Nothing;
}

export interface IAddLocalCourseAction extends RecordMutationApiAction<ApiEither<IdentifyingAttributesMissing, MasterRecordKey>> {
  '@type': 'AddLocalCourseAction';
  subjectAndNumber: string;
  curriculumEntityCorrections: Correction<IRichCourseRecord, any>[];
  '@response'?: ApiEither<IdentifyingAttributesMissing, MasterRecordKey>;
}

export interface IAddLocalProgramAction extends RecordMutationApiAction<ApiEither<IdentifyingAttributesMissing, MasterRecordKey>> {
  '@type': 'AddLocalProgramAction';
  title: string;
  awardType: AwardType;
  curriculumEntityCorrections: Correction<IRichProgramRecord, any>[];
  '@response'?: ApiEither<IdentifyingAttributesMissing, MasterRecordKey>;
}

export interface IAggregateAlignmentCounts extends ApiEntityAction<AlignmentCountSummary>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'AggregateAlignmentCounts';
  '@response'?: AlignmentCountSummary;
}

export interface IAggregateCleanCounts extends ApiEntityAction<CleanCounts>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'AggregateCleanCounts';
  '@response'?: CleanCounts;
}

export interface IAggregateNoticeCounts extends ApiEntityAction<NoticeCountSummary>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'AggregateNoticeCounts';
  '@response'?: NoticeCountSummary;
}

export interface IAggregateSourceCounts extends ApiEntityAction<SourceCountSummaries>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'AggregateSourceCounts';
  '@response'?: SourceCountSummaries;
}

export interface IArchiveCurriculumYearAction extends ApiEntityAction<Nothing>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'ArchiveCurriculumYearAction';
  curriculumYear: number;
  collegeSlug: string;
  '@response'?: Nothing;
}

export interface IBulkAmendCorrectionsAction extends RecordMutationApiAction<ApiEither<BulkAmendErrors, BulkAmendResult>> {
  '@type': 'BulkAmendCorrectionsAction';
  amendType: BulkAmendType;
  importCorrectionsByRow?: { [index: string]: ImportCorrections };
  fileContents: string;
  '@response'?: ApiEither<BulkAmendErrors, BulkAmendResult>;
}

export interface IBulkAmendTypeApiObject extends ApiObject {
  '@type': 'BulkAmendTypeApiObject';
  bulkAmendType: BulkAmendType;
  title: string;
}

export interface ICleanCounts extends ApiObject {
  '@type': 'CleanCounts';
  fieldCleanCounts: { [index: string]: number };
}

export interface ICollegeNotFound extends ApiObject {
  '@type': 'CollegeNotFound';
}

export interface ICorrectMultipleRecords extends RecordMutationApiAction<Nothing> {
  '@type': 'CorrectMultipleRecords';
  correctionsByRecordKey: { [index: string]: Correction<any, any>[] };
  '@response'?: Nothing;
}

export interface ICourseApiObject extends CurriculumEntityDetailApiObject {
  '@type': 'CourseApiObject';
  id: CurriculumEntityId;
  entityType: PipelineEntityType;
  label: string;
  mergeKey?: string;
  persistentId?: string;
  notices: INotices;
  include: RichValue<boolean>;
  title: RichValue<string>;
  cccControlNumber: RichValue<string>;
  description: RichValue<string>;
  subjectAndNumber: RichValue<string>;
  minUnits: RichValue<number>;
  maxUnits: RichValue<number>;
  transferability: RichValue<CourseTransferability[]>;
  labHours: RichValue<number>;
  lectureHours: RichValue<number>;
  materialsFee: RichValue<number>;
  prerequisitesHistory: RichValue<string[]>;
  prerequisites: PickedCourse[];
  prerequisiteText: RichValue<string>;
  corequisitesHistory: RichValue<string[]>;
  corequisites: PickedCourse[];
  badgeClassHistory: RichValue<string[]>;
  pickedBadges: IPickedBadge[];
  sourceRecords: CourseSourceRecordSummary[];
  instructionMethod: RichValue<InstructionMethod>;
}

export interface ICourseForPublishPreview extends ApiObject {
  '@type': 'CourseForPublishPreview';
  publishability: Publishability;
  label: string;
  nonFieldPublishabilityNotices: Notice[];
}

export interface ICourseForSearchResult extends CurriculumEntityForSearchResult {
  '@type': 'CourseForSearchResult';
  id: CurriculumEntityId;
  title?: string;
  controlNumber?: string;
  minUnits?: number;
  maxUnits?: number;
  description?: string;
  active: boolean;
  hasErrors: boolean;
  hasWarnings: boolean;
  notices: INotices;
  subjectAndNumber?: string;
  labHours?: number;
  lectureHours?: number;
  materialsFee?: number;
  prerequisites: IPickedCourse[];
  corequisites: IPickedCourse[];
  pickedBadges: IPickedBadge[];
  isClean: boolean;
}

export interface ICourseListAddRequest extends ApiEntityAction<AddCourseListApiResponse>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'CourseListAddRequest';
  collegeSlug: string;
  curriculumYear: number;
  title: string;
  shortDescription: string;
  longDescription: string;
  pickedSlugs: string[];
  '@response'?: AddCourseListApiResponse;
}

export interface ICourseListApiObject extends ApiObject {
  '@type': 'CourseListApiObject';
  id: string;
  lockVersion: number;
  title: string;
  shortDescription: string;
  longDescription: string;
  pickedCourses: PickedCourse[];
  notices: INotices;
  isActive: boolean;
}

export interface ICourseListByIdAction extends ApiEntityAction<ApiEither<NotFound, CourseListApiObject>>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'CourseListByIdAction';
  collegeSlug: string;
  curriculumYear: number;
  id: CourseListId;
  '@response'?: ApiEither<NotFound, CourseListApiObject>;
}

export interface ICourseListForPublishPreview extends ApiObject {
  '@type': 'CourseListForPublishPreview';
  publishability: Publishability;
  label: string;
  nonFieldPublishabilityNotices: Notice[];
}

export interface ICourseListId extends ApiObject {
  '@type': 'CourseListId';
  uuid: string;
}

export interface ICourseSourceRecordSummary extends ApiObject {
  '@type': 'CourseSourceRecordSummary';
  id: string;
  source: SourceSystem;
  sourceRecordKey: string;
  controlNumber?: string;
  subjectAndNumber: RichValue<string>;
  active: RichValue<boolean>;
  selected: boolean;
  contributing: boolean;
}

export interface ICreateCurriculumYearAction extends ApiEntityAction<ApiEither<CurriculumYearCreationError, CurriculumYearCreationSuccess>>, HasCollegeSlug {
  '@type': 'CreateCurriculumYearAction';
  collegeSlug: string;
  year: number;
  yearToCopyFrom?: number;
  '@response'?: ApiEither<CurriculumYearCreationError, CurriculumYearCreationSuccess>;
}

export interface ICreateHighSchoolAction extends ApiEntityAction<CreateHighSchoolResponse>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'CreateHighSchoolAction';
  curriculumYear: number;
  collegeSlug: string;
  highSchool: CreateHighSchoolApiObject;
  '@response'?: CreateHighSchoolResponse;
}

export interface ICreateHighSchoolResponse extends ApiObject {
  '@type': 'CreateHighSchoolResponse';
  highSchoolId: string;
}

export interface ICurriculumEntityDetailAction extends ApiEntityAction<ApiEither<ICurriculumEntityDetailMissing, CurriculumEntityDetailApiObject>>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'CurriculumEntityDetailAction';
  collegeSlug: string;
  curriculumYear: number;
  entityId: string;
  '@response'?: ApiEither<ICurriculumEntityDetailMissing, CurriculumEntityDetailApiObject>;
}

export interface ICurriculumEntityDetailMissing extends ApiObject {
  '@type': 'CurriculumEntityDetailMissing';
}

export interface ICurriculumEntityId extends ApiObject {
  '@type': 'CurriculumEntityId';
  id: string;
}

export interface ICurriculumEntitySummary extends ApiObject {
  '@type': 'CurriculumEntitySummary';
  id: CurriculumEntityId;
  label: string;
  mergeKey?: string;
  persistentId?: string;
  sourceSystems: SourceSystem[];
  notices: INotices;
}

export interface ICurriculumRevisionApiObject extends ApiObject {
  '@type': 'CurriculumRevisionApiObject';
  revision: number;
  notes?: string;
  publishedDate?: string;
}

export interface ICurriculumYearCreationError extends ApiObject {
  '@type': 'CurriculumYearCreationError';
}

export interface ICurriculumYearCreationSuccess extends ApiObject {
  '@type': 'CurriculumYearCreationSuccess';
  curriculumYearId: string;
}

export interface ICurriculumYearHistoryResponse extends ApiObject {
  '@type': 'CurriculumYearHistoryResponse';
  curriculumRevisions: CurriculumRevisionApiObject[];
}

export interface ICurriculumYearNotFoundError extends ApiObject {
  '@type': 'CurriculumYearNotFoundError';
}

export interface IDeactivateSourceSystemAction extends RecordMutationApiAction<Nothing> {
  '@type': 'DeactivateSourceSystemAction';
  sourceSystem: SourceSystem;
  '@response'?: Nothing;
}

export interface IDeleteCourseListAction extends ApiEntityAction<Nothing>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'DeleteCourseListAction';
  curriculumYear: number;
  collegeSlug: string;
  courseListUuid: string;
  '@response'?: Nothing;
}

export interface IDuplicateImportedCoursesResponse extends ApiObject {
  '@type': 'DuplicateImportedCoursesResponse';
  unresolvedDuplicatesBySubjectAndNumber: { [index: string]: ImportedCourseApiObject[] };
}

export interface IEditCurriculumNotesAction extends ApiEntityAction<Nothing>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'EditCurriculumNotesAction';
  curriculumYear: number;
  collegeSlug: string;
  notes?: string;
  '@response'?: Nothing;
}

export interface IEditHighSchoolAction extends ApiEntityAction<EditHighSchoolResponse>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'EditHighSchoolAction';
  curriculumYear: number;
  collegeSlug: string;
  highSchool: EditHighSchoolApiObject;
  '@response'?: EditHighSchoolResponse;
}

export interface IEditHighSchoolResponse extends ApiObject {
  '@type': 'EditHighSchoolResponse';
  highSchoolId: string;
}

export interface IFetchAndImportSourceFileAction extends RecordMutationApiAction<ApiEither<ParseErrorApiObject, Nothing>> {
  '@type': 'FetchAndImportSourceFileAction';
  sourceSystem: SourceSystem;
  '@response'?: ApiEither<ParseErrorApiObject, Nothing>;
}

export interface IFindCipCodesAction extends ApiEntityAction<FindCipCodesResponse>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'FindCipCodesAction';
  collegeSlug: string;
  curriculumYear: number;
  page: number;
  itemsPerPage: number;
  searchTerm?: string;
  '@response'?: FindCipCodesResponse;
}

export interface IFindCipCodesResponse extends ApiObject {
  '@type': 'FindCipCodesResponse';
  paginatedResults: ICipCode[];
  totalResultCount: number;
}

export interface IFindCollegeBySlugAction extends ApiEntityAction<ApiEither<CollegeNotFound, CollegeApiEntity>>, HasCollegeSlug {
  '@type': 'FindCollegeBySlugAction';
  collegeSlug: string;
  '@response'?: ApiEither<CollegeNotFound, CollegeApiEntity>;
}

export interface IFindCourseListsAction extends ApiEntityAction<PaginatedCourseListSearchResults>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'FindCourseListsAction';
  collegeSlug: string;
  curriculumYear: number;
  page: number;
  itemsPerPage: number;
  criteria: ICurriculumEntitySearchCriteria;
  '@response'?: PaginatedCourseListSearchResults;
}

export interface IFindCoursesAction extends FindCurriculumEntitiesAction<PaginatedFilteredCourseSearchResults> {
  '@type': 'FindCoursesAction';
  collegeSlug: string;
  curriculumYear: number;
  page: number;
  itemsPerPage: number;
  criteria: ICurriculumEntitySearchCriteria;
  '@response'?: PaginatedFilteredCourseSearchResults;
}

export interface IFindCurriculumYearAction extends ApiEntityAction<ApiEither<CurriculumYearNotFoundError, CurriculumYearApiObject>>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'FindCurriculumYearAction';
  collegeSlug: string;
  curriculumYear: number;
  '@response'?: ApiEither<CurriculumYearNotFoundError, CurriculumYearApiObject>;
}

export interface IFindCurriculumYearsForCollegeAction extends ApiEntityAction<CurriculumYearsForCollegeResponse>, HasCollegeSlug {
  '@type': 'FindCurriculumYearsForCollegeAction';
  collegeSlug: string;
  '@response'?: CurriculumYearsForCollegeResponse;
}

export interface IFindGenEdPatternsAction extends ApiEntityAction<FindGenEdPatternsResponse>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'FindGenEdPatternsAction';
  collegeSlug: string;
  curriculumYear: number;
  '@response'?: FindGenEdPatternsResponse;
}

export interface IFindGenEdPatternsResponse extends ApiObject {
  '@type': 'FindGenEdPatternsResponse';
  genEdPatternSummaries: GenEdPatternSummary[];
}

export interface IFindImportedBadgesAction extends ApiEntityAction<FindImportedBadgesResponse>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'FindImportedBadgesAction';
  collegeSlug: string;
  curriculumYear: number;
  page: number;
  itemsPerPage: number;
  searchTerm?: string;
  '@response'?: FindImportedBadgesResponse;
}

export interface IFindImportedBadgesResponse extends ApiObject {
  '@type': 'FindImportedBadgesResponse';
  paginatedResults: IImportedBadge[];
  totalResultCount: number;
}

export interface IFindPickableCollegesAction extends ApiEntityAction<FindPickableCollegesResponse> {
  '@type': 'FindPickableCollegesAction';
  '@response'?: FindPickableCollegesResponse;
}

export interface IFindPickableCollegesResponse extends ApiObject {
  '@type': 'FindPickableCollegesResponse';
  colleges: PickableCollege[];
}

export interface IFindPickableCoursesAction extends ApiEntityAction<FindPickableCoursesResponse>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'FindPickableCoursesAction';
  collegeSlug: string;
  curriculumYear: number;
  page: number;
  itemsPerPage: number;
  searchTerm?: string;
  showInactive: boolean;
  showInvalid: boolean;
  '@response'?: FindPickableCoursesResponse;
}

export interface IFindPickableCoursesResponse extends ApiObject {
  '@type': 'FindPickableCoursesResponse';
  paginatedResults: PickableCourse[];
  totalResultCount: number;
}

export interface IFindProgramsAction extends FindCurriculumEntitiesAction<PaginatedFilteredProgramSearchResults> {
  '@type': 'FindProgramsAction';
  collegeSlug: string;
  curriculumYear: number;
  page: number;
  itemsPerPage: number;
  criteria: ICurriculumEntitySearchCriteria;
  '@response'?: PaginatedFilteredProgramSearchResults;
}

export interface IFindTopCodesAction extends ApiEntityAction<FindTopCodesResponse>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'FindTopCodesAction';
  collegeSlug: string;
  curriculumYear: number;
  page: number;
  itemsPerPage: number;
  searchTerm?: string;
  '@response'?: FindTopCodesResponse;
}

export interface IFindTopCodesResponse extends ApiObject {
  '@type': 'FindTopCodesResponse';
  paginatedResults: ITopCode[];
  totalResultCount: number;
}

export interface IGenEdPatternApiObject extends WithGenEdPatternApiObject, ApiObject {
  '@type': 'GenEdPatternApiObject';
  id: string;
  title: string;
  description: string;
  deprecated: boolean;
  partOfCurriculum: boolean;
  nodes: IGenEdPatternArea[];
  notices: INotices;
  active: boolean;
}

export interface IGenEdPatternForPublishPreview extends ApiObject {
  '@type': 'GenEdPatternForPublishPreview';
  publishability: Publishability;
  label: string;
  nonFieldPublishabilityNotices: Notice[];
}

export interface IGenerateCollegeReportAction extends ApiEntityAction<CollegeReport>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'GenerateCollegeReportAction';
  curriculumYear: number;
  collegeSlug: string;
  '@response'?: CollegeReport;
}

export interface IGetCoursesByHighSchoolAction extends ApiEntityAction<GetCoursesByHighSchoolResponse>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'GetCoursesByHighSchoolAction';
  curriculumYear: number;
  collegeSlug: string;
  highSchoolId: string;
  '@response'?: GetCoursesByHighSchoolResponse;
}

export interface IGetCoursesByHighSchoolResponse extends ApiObject {
  '@type': 'GetCoursesByHighSchoolResponse';
  courses: CurriculumEntityDetailApiObject[];
}

export interface IGetCurriculumYearHistoryAction extends ApiEntityAction<CurriculumYearHistoryResponse>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'GetCurriculumYearHistoryAction';
  curriculumYear: number;
  collegeSlug: string;
  '@response'?: CurriculumYearHistoryResponse;
}

export interface IGetDuplicateImportedCoursesAction extends ApiEntityAction<DuplicateImportedCoursesResponse>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'GetDuplicateImportedCoursesAction';
  curriculumYear: number;
  collegeSlug: string;
  sourceSystem: SourceSystem;
  '@response'?: DuplicateImportedCoursesResponse;
}

export interface IGetGenEdPatternAction extends ApiEntityAction<GenEdPatternApiObject>, HasCollegeSlug, HasCurriculumYear {
  '@type': 'GetGenEdPatternAction';
  collegeSlug: string;
  curriculumYear: number;
  genEdId: string;
  '@response'?: GenEdPatternApiObject;
}

export interface IGetImportedCoursesAction extends ApiEntityAction<ImportedCoursesResponse>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'GetImportedCoursesAction';
  curriculumYear: number;
  collegeSlug: string;
  sourceSystem: SourceSystem;
  '@response'?: ImportedCoursesResponse;
}

export interface IGetImportedProgramsAction extends ApiEntityAction<ImportedProgramsResponse>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'GetImportedProgramsAction';
  curriculumYear: number;
  collegeSlug: string;
  sourceSystem: SourceSystem;
  '@response'?: ImportedProgramsResponse;
}

export interface IGetImportedProgramsMissingTitleAndAwardAction extends ApiEntityAction<ImportedProgramsMissingTitleAndAwardResponse>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'GetImportedProgramsMissingTitleAndAwardAction';
  curriculumYear: number;
  collegeSlug: string;
  sourceSystem: SourceSystem;
  '@response'?: ImportedProgramsMissingTitleAndAwardResponse;
}

export interface IHighSchoolCoursesApiObject extends ApiObject {
  '@type': 'HighSchoolCoursesApiObject';
  courses?: PickedCourse[];
}

export interface IImportBadgeFileAction extends RecordMutationApiAction<ApiEither<ParseErrorApiObject, Nothing>> {
  '@type': 'ImportBadgeFileAction';
  fileContents: string;
  '@response'?: ApiEither<ParseErrorApiObject, Nothing>;
}

export interface IImportCorrections extends ApiObject {
  '@type': 'ImportCorrections';
  row: number;
  fieldCorrections?: { [index: string]: ImportCorrection };
  exclude: boolean;
}

export interface IImportSourceFileAction extends RecordMutationApiAction<ApiEither<ParseErrorApiObject, Nothing>> {
  '@type': 'ImportSourceFileAction';
  sourceSystem: SourceSystem;
  fileContents: string;
  '@response'?: ApiEither<ParseErrorApiObject, Nothing>;
}

export interface IImportedCoursesResponse extends ApiObject {
  '@type': 'ImportedCoursesResponse';
  importedCourses: ImportedCourseApiObject[];
}

export interface IImportedProgramsMissingTitleAndAwardResponse extends ApiObject {
  '@type': 'ImportedProgramsMissingTitleAndAwardResponse';
  missingTitleAndAward: ImportedProgramApiObject[];
}

export interface IImportedProgramsResponse extends ApiObject {
  '@type': 'ImportedProgramsResponse';
  importedPrograms: ImportedProgramApiObject[];
}

export interface IInvalidateAllAction extends RecordMutationApiAction<Nothing> {
  '@type': 'InvalidateAllAction';
  '@response'?: Nothing;
}

export interface IMarkPublishedAction extends ApiEntityAction<Nothing>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'MarkPublishedAction';
  curriculumYear: number;
  collegeSlug: string;
  '@response'?: Nothing;
}

export interface INotFound extends ApiObject {
  '@type': 'NotFound';
}

export interface INoticeCountSummary extends ApiObject {
  '@type': 'NoticeCountSummary';
  nonFieldNoticeCounts: { [index: string]: number };
  fieldNoticeCounts: { [index: string]: { [index: string]: number } };
}

export interface IPaginatedCourseListSearchResults extends ApiObject {
  '@type': 'PaginatedCourseListSearchResults';
  paginatedResults: CourseListForSearchResult[];
  totalResultCount: number;
}

export interface IPaginatedFilteredCourseSearchResults extends IPaginatedFilteredCurriculumEntitySearchResults {
  '@type': 'PaginatedFilteredCourseSearchResults';
  totalSearchResultCount: number;
  unfilteredNoticeCounts: INoticeCounts;
  courses: CourseForSearchResult[];
}

export interface IPaginatedFilteredCurriculumEntitySearchResults extends ApiObject {
  '@type': 'PaginatedFilteredCourseSearchResults' | 'PaginatedFilteredProgramSearchResults';
}

export interface IPaginatedFilteredProgramSearchResults extends IPaginatedFilteredCurriculumEntitySearchResults {
  '@type': 'PaginatedFilteredProgramSearchResults';
  totalSearchResultCount: number;
  unfilteredNoticeCounts: INoticeCounts;
  programs: ProgramForSearchResult[];
}

export interface IPaginatedResults<T> extends ApiObject {
  '@type': 'PaginatedResults';
  results: T[];
  totalCount: number;
}

export interface IPickableCourse extends PickableEntity {
  '@type': 'PickableCourse';
  title?: string;
  label: string;
  active: boolean;
  publishErrors: boolean;
}

export interface IPickableProgram extends PickableEntity {
  '@type': 'PickableProgram';
  title?: string;
  awardType?: AwardType;
  label: string;
  active: boolean;
  publishErrors: boolean;
}

export interface IPickedCipCode extends ApiObject {
  '@type': 'PickedCipCode';
  cipCode: string;
  cipCodeTitle?: string;
  standardOccupations: IStandardOccupation[];
  missing: boolean;
}

export interface IPickedCourse extends ApiObject {
  '@type': 'PickedCourse';
  title?: string;
  label: string;
  slug: string;
  inActive: boolean;
  publishErrors: boolean;
  missing: boolean;
}

export interface IPickedTopCode extends ApiObject {
  '@type': 'PickedTopCode';
  topCode: string;
  topCodeTitle?: string;
  standardOccupations: IStandardOccupation[];
  missing: boolean;
}

export interface IProgramApiObject extends CurriculumEntityDetailApiObject {
  '@type': 'ProgramApiObject';
  id: CurriculumEntityId;
  entityType: PipelineEntityType;
  label: string;
  mergeKey?: string;
  persistentId?: string;
  notices: INotices;
  sourceRecords: ProgramSourceRecordSummary[];
  include: RichValue<boolean>;
  title: RichValue<string>;
  cccControlNumber: RichValue<string>;
  description: RichValue<string>;
  awardType: RichValue<AwardType>;
  transferability: RichValue<CourseTransferability[]>;
  topCodeHistory: RichValue<string>;
  topCode?: PickedTopCode;
  cipCodeHistory: RichValue<string>;
  cipCode?: PickedCipCode;
  badgeHistory: RichValue<string>;
  badge?: IPickedBadge;
  minUnits: RichValue<number>;
  maxUnits: RichValue<number>;
  additionalRequirements: RichValue<string>;
  tty: RichValue<string>;
  youtubeVideoId: RichValue<string>;
  learningOutcomes: RichValue<string[]>;
  instructionMethod: RichValue<InstructionMethod>;
}

export interface IProgramForPublishPreview extends ApiObject {
  '@type': 'ProgramForPublishPreview';
  publishability: Publishability;
  label: string;
  nonFieldPublishabilityNotices: Notice[];
}

export interface IProgramForSearchResult extends CurriculumEntityForSearchResult {
  '@type': 'ProgramForSearchResult';
  id: CurriculumEntityId;
  title?: string;
  controlNumber?: string;
  minUnits?: number;
  maxUnits?: number;
  description?: string;
  active: boolean;
  hasErrors: boolean;
  hasWarnings: boolean;
  notices: INotices;
  awardType?: AwardType;
  learningOutcomes: string[];
  topCode?: PickedTopCode;
  cipCode?: PickedCipCode;
  youtubeVideoId?: string;
  pickedBadge?: IPickedBadge;
  isClean: boolean;
}

export interface IProgramSourceRecordSummary extends ApiObject {
  '@type': 'ProgramSourceRecordSummary';
  id: string;
  source: SourceSystem;
  sourceRecordKey: string;
  controlNumber?: string;
  title: RichValue<string>;
  awardType: RichValue<AwardType>;
  active: RichValue<boolean>;
  selected: boolean;
  contributing: boolean;
}

export interface IPublishCurriculumAction extends ApiEntityAction<PublishCurriculumApiResponse>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'PublishCurriculumAction';
  curriculumYear: number;
  collegeSlug: string;
  '@response'?: PublishCurriculumApiResponse;
}

export interface IPublishPreview extends ApiObject {
  '@type': 'PublishPreview';
  inactiveCourses: CourseForPublishPreview[];
  errorCourses: CourseForPublishPreview[];
  warningCourses: CourseForPublishPreview[];
  cleanCourses: CourseForPublishPreview[];
  inactivePrograms: ProgramForPublishPreview[];
  errorPrograms: ProgramForPublishPreview[];
  warningPrograms: ProgramForPublishPreview[];
  cleanPrograms: ProgramForPublishPreview[];
  inactiveCourseLists: CourseListForPublishPreview[];
  errorCourseLists: CourseListForPublishPreview[];
  warningCourseLists: CourseListForPublishPreview[];
  cleanCourseLists: CourseListForPublishPreview[];
  errorGenEdPattern: GenEdPatternForPublishPreview[];
  inactiveGenEdPattern: GenEdPatternForPublishPreview[];
  warningGenEdPattern: GenEdPatternForPublishPreview[];
  cleanGenEdPattern: GenEdPatternForPublishPreview[];
  highSchools: SavedHighSchoolApiObject[];
}

export interface IPublishPreviewAction extends ApiEntityAction<PublishPreview>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'PublishPreviewAction';
  curriculumYear: number;
  collegeSlug: string;
  '@response'?: PublishPreview;
}

export interface IRecordMutationAction extends ApiEntityAction<ApiObject>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'RecordMutationAction';
  curriculumYear: number;
  collegeSlug: string;
  pipelineEntityType: PipelineEntityType;
  action: RecordMutationApiAction<any>;
  '@response'?: ApiObject;
}

export interface IRejectSuggestions extends ApiEntityAction<Nothing>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'RejectSuggestions';
  '@response'?: Nothing;
}

export interface IRemapPersistentIdAction extends RecordMutationApiAction<Nothing> {
  '@type': 'RemapPersistentIdAction';
  mergeKey: string;
  persistentId: string;
  '@response'?: Nothing;
}

export interface IRenameEntityAction extends RecordMutationApiAction<ApiEither<EnumWrapper<RenameEntityError>, Nothing>> {
  '@type': 'RenameEntityAction';
  recordKey: IMasterRecordKey;
  target: IdentifyingValues<any>;
  '@response'?: ApiEither<EnumWrapper<RenameEntityError>, Nothing>;
}

export interface IRenameEntityErrors extends ApiObject {
  '@type': 'RenameEntityErrors';
  errorsByRecordKey: { [index: string]: RenameEntityError };
}

export interface IRenameMultipleRecords extends RecordMutationApiAction<ApiEither<IRenameEntityErrors, Nothing>> {
  '@type': 'RenameMultipleRecords';
  targetsByRecordKey: { [index: string]: IdentifyingValues<any> };
  '@response'?: ApiEither<IRenameEntityErrors, Nothing>;
}

export interface ISearchHighSchoolsByCollegeAction extends ApiEntityAction<SearchHighSchoolsResponse>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'SearchHighSchoolsByCollegeAction';
  curriculumYear: number;
  collegeSlug: string;
  collegeId: string;
  '@response'?: SearchHighSchoolsResponse;
}

export interface ISearchHighSchoolsResponse extends ApiObject {
  '@type': 'SearchHighSchoolsResponse';
  highSchools: SavedHighSchoolApiObject[];
}

export interface ISourceCountSummaries extends ApiObject {
  '@type': 'SourceCountSummaries';
  summaries: { [P in SourceSystem]?: ISourceCountSummary };
}

export interface ISourceRecordDetailAction extends ApiEntityAction<SourceRecordDetailApiObject<RichRecord>>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'SourceRecordDetailAction';
  curriculumYear: number;
  collegeSlug: string;
  curriculumEntityId: string;
  id: string;
  '@response'?: SourceRecordDetailApiObject<RichRecord>;
}

export interface ISourceRecordDetailApiObject<TRecord> extends ApiObject {
  '@type': 'SourceRecordDetailApiObject';
  selected: boolean;
  source: SourceSystem;
  sourceRecordId: string;
  record: TRecord;
  notices: INotices;
}

export interface IUpdateCourseListAction extends ApiEntityAction<CourseListId>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'UpdateCourseListAction';
  curriculumYear: number;
  collegeSlug: string;
  id: string;
  lockVersion: number;
  title: string;
  shortDescription: string;
  longDescription: string;
  pickedCourseSlugs: string[];
  isActive: boolean;
  '@response'?: CourseListId;
}

export interface IUpdateGenEdAction extends ApiEntityAction<GenEdPatternApiObject>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'UpdateGenEdAction';
  curriculumYear: number;
  collegeSlug: string;
  genEdPatternId: string;
  courseSlugsByNode: { [index: string]: string[] };
  '@response'?: GenEdPatternApiObject;
}

export interface ImportBadgeFileAction extends IImportBadgeFileAction {
  '@type': 'ImportBadgeFileAction';
}

export interface ImportCorrections extends IImportCorrections {
  '@type': 'ImportCorrections';
}

export interface ImportSourceFileAction extends IImportSourceFileAction {
  '@type': 'ImportSourceFileAction';
}

export interface ImportedCoursesResponse extends IImportedCoursesResponse {
  '@type': 'ImportedCoursesResponse';
}

export interface ImportedProgramsMissingTitleAndAwardResponse extends IImportedProgramsMissingTitleAndAwardResponse {
  '@type': 'ImportedProgramsMissingTitleAndAwardResponse';
}

export interface ImportedProgramsResponse extends IImportedProgramsResponse {
  '@type': 'ImportedProgramsResponse';
}

export interface InvalidateAllAction extends IInvalidateAllAction {
  '@type': 'InvalidateAllAction';
}

export interface ListCoursesWithAlignmentSuggestions extends IListCoursesWithAlignmentSuggestions {
  '@type': 'ListCoursesWithAlignmentSuggestions';
}

export interface ListEntitiesWithAlignmentSuggestions<TSummary, TSimilarity> extends ApiEntityAction<PaginatedResults<IAlignmentSuggestionsForEntity<TSummary, TSimilarity>>>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'ListCoursesWithAlignmentSuggestions' | 'ListProgramsWithAlignmentSuggestions';
  '@response'?: PaginatedResults<IAlignmentSuggestionsForEntity<TSummary, TSimilarity>>;
}

export interface IListCoursesWithAlignmentSuggestions extends ListEntitiesWithAlignmentSuggestions<ICourseSummaryForAlignment, CourseSimilarity> {
  '@type': 'ListCoursesWithAlignmentSuggestions';
  curriculumYear: number;
  collegeSlug: string;
  page: number;
  itemsPerPage: number;
  searchTerm?: string;
  presentSystem: SourceSystem;
  '@response'?: PaginatedResults<IAlignmentSuggestionsForEntity<ICourseSummaryForAlignment, CourseSimilarity>>;
}

export interface IListProgramsWithAlignmentSuggestions extends ListEntitiesWithAlignmentSuggestions<IProgramSummaryForAlignment, ProgramSimilarity> {
  '@type': 'ListProgramsWithAlignmentSuggestions';
  curriculumYear: number;
  collegeSlug: string;
  page: number;
  itemsPerPage: number;
  searchTerm?: string;
  presentSystem: SourceSystem;
  '@response'?: PaginatedResults<IAlignmentSuggestionsForEntity<IProgramSummaryForAlignment, ProgramSimilarity>>;
}

export interface ListProgramsWithAlignmentSuggestions extends IListProgramsWithAlignmentSuggestions {
  '@type': 'ListProgramsWithAlignmentSuggestions';
}

export interface MarkPublishedAction extends IMarkPublishedAction {
  '@type': 'MarkPublishedAction';
}

export interface NoSuchEntityAlignmentError extends INoSuchEntityAlignmentError {
  '@type': 'NoSuchEntityAlignmentError';
}

export interface NotFound extends INotFound {
  '@type': 'NotFound';
}

export interface NoticeCountSummary extends INoticeCountSummary {
  '@type': 'NoticeCountSummary';
}

export interface PaginatedCourseListSearchResults extends IPaginatedCourseListSearchResults {
  '@type': 'PaginatedCourseListSearchResults';
}

export interface PaginatedFilteredCourseSearchResults extends IPaginatedFilteredCourseSearchResults {
  '@type': 'PaginatedFilteredCourseSearchResults';
}

export interface PaginatedFilteredProgramSearchResults extends IPaginatedFilteredProgramSearchResults {
  '@type': 'PaginatedFilteredProgramSearchResults';
}

export interface PaginatedResults<T> extends IPaginatedResults<T> {
  '@type': 'PaginatedResults';
}

export interface PickableCourse extends IPickableCourse {
  '@type': 'PickableCourse';
}

export interface PickableEntity extends ApiObject {
  '@type': 'PickableCourse' | 'PickableProgram';
  slug: string;
}

export interface PickableProgram extends IPickableProgram {
  '@type': 'PickableProgram';
}

export interface PickedCipCode extends IPickedCipCode {
  '@type': 'PickedCipCode';
}

export interface PickedCourse extends IPickedCourse {
  '@type': 'PickedCourse';
}

export interface PickedTopCode extends IPickedTopCode {
  '@type': 'PickedTopCode';
}

export interface ProgramApiObject extends IProgramApiObject {
  '@type': 'ProgramApiObject';
}

export interface ProgramForPublishPreview extends IProgramForPublishPreview {
  '@type': 'ProgramForPublishPreview';
}

export interface ProgramForSearchResult extends IProgramForSearchResult {
  '@type': 'ProgramForSearchResult';
}

export interface ProgramSourceRecordSummary extends IProgramSourceRecordSummary {
  '@type': 'ProgramSourceRecordSummary';
}

export interface PublishCurriculumAction extends IPublishCurriculumAction {
  '@type': 'PublishCurriculumAction';
}

export interface PublishPreview extends IPublishPreview {
  '@type': 'PublishPreview';
}

export interface PublishPreviewAction extends IPublishPreviewAction {
  '@type': 'PublishPreviewAction';
}

export interface RecordMutationAction extends IRecordMutationAction {
  '@type': 'RecordMutationAction';
}

export interface RecordMutationApiAction<TResponse> extends ApiObject {
  '@type': 'AddCorrectionsAction' | 'AddLocalCourseAction' | 'AddLocalProgramAction' | 'BulkAmendCorrectionsAction' | 'CorrectMultipleRecords' | 'DeactivateSourceSystemAction' | 'FetchAndImportSourceFileAction' | 'ImportBadgeFileAction' | 'ImportSourceFileAction' | 'InvalidateAllAction' | 'RemapPersistentIdAction' | 'RenameEntityAction' | 'RenameMultipleRecords';
  '@response'?: TResponse;
}

export interface RejectSuggestions extends IRejectSuggestions {
  '@type': 'RejectSuggestions';
  curriculumYear: number;
  collegeSlug: string;
  rejectedPairs: Pair<string, string>[];
}

export interface RemapPersistentIdAction extends IRemapPersistentIdAction {
  '@type': 'RemapPersistentIdAction';
}

export interface RenameEntityAction extends IRenameEntityAction {
  '@type': 'RenameEntityAction';
}

export interface RenameEntityErrors extends IRenameEntityErrors {
  '@type': 'RenameEntityErrors';
}

export interface RenameMultipleRecords extends IRenameMultipleRecords {
  '@type': 'RenameMultipleRecords';
}

export interface SearchAlignmentCandidates<TSummary, TSimilarity> extends ApiEntityAction<ISearchAlignmentCandidatesResults<TSummary, TSimilarity>>, HasCurriculumYear, HasCollegeSlug {
  '@type': 'SearchCourseAlignmentCandidates' | 'SearchProgramAlignmentCandidates';
  '@response'?: ISearchAlignmentCandidatesResults<TSummary, TSimilarity>;
}

export interface ISearchCourseAlignmentCandidates extends SearchAlignmentCandidates<ICourseSummaryForAlignment, CourseSimilarity> {
  '@type': 'SearchCourseAlignmentCandidates';
  curriculumYear: number;
  collegeSlug: string;
  similarityBasis: ICourseSummaryForAlignment;
  presentSystems: SourceSystem[];
  missingSystems: SourceSystem[];
  searchTerm: string;
  '@response'?: ISearchAlignmentCandidatesResults<ICourseSummaryForAlignment, CourseSimilarity>;
}

export interface ISearchProgramAlignmentCandidates extends SearchAlignmentCandidates<IProgramSummaryForAlignment, ProgramSimilarity> {
  '@type': 'SearchProgramAlignmentCandidates';
  curriculumYear: number;
  collegeSlug: string;
  similarityBasis: IProgramSummaryForAlignment;
  presentSystems: SourceSystem[];
  missingSystems: SourceSystem[];
  searchTerm: string;
  '@response'?: ISearchAlignmentCandidatesResults<IProgramSummaryForAlignment, ProgramSimilarity>;
}

export interface SearchCourseAlignmentCandidates extends ISearchCourseAlignmentCandidates {
  '@type': 'SearchCourseAlignmentCandidates';
}

export interface SearchHighSchoolsByCollegeAction extends ISearchHighSchoolsByCollegeAction {
  '@type': 'SearchHighSchoolsByCollegeAction';
}

export interface SearchHighSchoolsResponse extends ISearchHighSchoolsResponse {
  '@type': 'SearchHighSchoolsResponse';
}

export interface SearchProgramAlignmentCandidates extends ISearchProgramAlignmentCandidates {
  '@type': 'SearchProgramAlignmentCandidates';
}

export interface SourceCountSummaries extends ISourceCountSummaries {
  '@type': 'SourceCountSummaries';
}

export interface SourceRecordDetailAction extends ISourceRecordDetailAction {
  '@type': 'SourceRecordDetailAction';
}

export interface SourceRecordDetailApiObject<TRecord> extends ISourceRecordDetailApiObject<TRecord> {
  '@type': 'SourceRecordDetailApiObject';
}

export interface UpdateCourseListAction extends IUpdateCourseListAction {
  '@type': 'UpdateCourseListAction';
}

export interface UpdateGenEdAction extends IUpdateGenEdAction {
  '@type': 'UpdateGenEdAction';
}

export interface CollegeReportCourseSummary extends ICollegeReportCourseSummary {
  '@type': 'CollegeReportCourseSummary';
}

export interface CollegeReportEntitySummary extends ApiObject {
  '@type': 'CollegeReportCourseSummary' | 'CollegeReportProgramSummary';
  fields: { [index: string]: ReportField<any> };
  notices: INotices;
}

export interface CollegeReportProgramSummary extends ICollegeReportProgramSummary {
  '@type': 'CollegeReportProgramSummary';
}

export interface ICollegeReportCourseSummary extends CollegeReportEntitySummary {
  '@type': 'CollegeReportCourseSummary';
  subjectAndNumber?: string;
  courseTitle?: string;
}

export interface ICollegeReportProgramSummary extends CollegeReportEntitySummary {
  '@type': 'CollegeReportProgramSummary';
  programTitle?: string;
  programAwardType?: AwardType;
}

export interface IReportField<TValue> extends ApiObject {
  '@type': 'ReportField';
  value?: TValue;
  sources: SourceSystem[];
}

export interface ReportField<TValue> extends IReportField<TValue> {
  '@type': 'ReportField';
}

export interface AddCourseListApiResponse extends ApiObject {
  '@type': 'AddCourseListApiResponse$CourseListAdded' | 'CurriculumYearMissing';
}

export interface CourseListAdded extends AddCourseListApiResponse {
  '@type': 'AddCourseListApiResponse$CourseListAdded';
  courseListId: CourseListId;
}

export interface AddCurriculumYearApiResponse extends ApiObject {
  '@type': 'AddCurriculumYearApiResponse$YearAdded' | 'AddCurriculumYearApiResponse$YearAlreadyExists';
}

export interface YearAdded extends AddCurriculumYearApiResponse {
  '@type': 'AddCurriculumYearApiResponse$YearAdded';
  curriculumUuid: string;
}

export interface YearAlreadyExists extends AddCurriculumYearApiResponse {
  '@type': 'AddCurriculumYearApiResponse$YearAlreadyExists';
}

export interface ApiEither<L, R> extends ApiObject {
  '@type': 'ApiEither$Failure' | 'ApiEither$Success';
  success: boolean;
}

export interface EnumWrapper<TEnum> extends ApiObject {
  '@type': 'ApiEither$EnumWrapper';
  value: TEnum;
}

export interface Failure<L, R> extends ApiEither<L, R> {
  '@type': 'ApiEither$Failure';
  value: L;
}

export interface Success<L, R> extends ApiEither<L, R> {
  '@type': 'ApiEither$Success';
  value: R;
}

export interface BulkAmendErrors extends IBulkAmendErrors {
  '@type': 'BulkAmendErrors';
}

export interface BulkAmendResult extends IBulkAmendResult {
  '@type': 'BulkAmendResult';
}

export interface CollegeReport extends ICollegeReport {
  '@type': 'CollegeReport';
}

export interface DuplicateRow extends IDuplicateRow {
  '@type': 'DuplicateRow';
}

export interface IBulkAmendErrors extends ApiObject {
  '@type': 'BulkAmendErrors';
  errors: RowWithNumber[];
  unrecognizedFormat: boolean;
  missingFields: string[];
  pickableEntities: PickableEntity[];
  duplicateRowNumbersByMergeKey: { [index: string]: number[] };
}

export interface IBulkAmendResult extends ApiObject {
  '@type': 'BulkAmendResult';
  notices: { [index: string]: ImportNotices };
}

export interface ICollegeReport extends ApiObject {
  '@type': 'CollegeReport';
  programSummaries: ICollegeReportProgramSummary[];
  courseSummaries: ICollegeReportCourseSummary[];
}

export interface IDuplicateRow extends ImportErrorNotice {
  '@type': 'DuplicateRow';
  duplicateRowNumbers: number[];
}

export interface IInvalidCollege extends ImportErrorNotice {
  '@type': 'InvalidCollege';
  message: string;
}

export interface IMergeKeyNotFound extends ImportErrorNotice {
  '@type': 'MergeKeyNotFound';
}

export interface IValueNotImportable extends ImportErrorNotice {
  '@type': 'ValueNotImportable';
  field: string;
  message: string;
}

export interface ImportErrorNotice extends ImportNotice {
  '@type': 'DuplicateRow' | 'InvalidCollege' | 'MergeKeyNotFound' | 'ValueNotImportable';
}

export interface ImportNotice extends ApiObject {
  '@type': 'DuplicateRow' | 'InvalidCollege' | 'MergeKeyNotFound' | 'ValueNotImportable';
}

export interface IMergeSummary extends ApiObject {
  '@type': 'MergeSummary';
  create: string[];
  update: string[];
  isPreview: boolean;
}

export interface InvalidCollege extends IInvalidCollege {
  '@type': 'InvalidCollege';
}

export interface MergeKeyNotFound extends IMergeKeyNotFound {
  '@type': 'MergeKeyNotFound';
}

export interface MergeSummary extends IMergeSummary {
  '@type': 'MergeSummary';
}

export interface Nothing extends ApiObject {
  '@type': 'Nothing';
}

export interface PublishCurriculumApiResponse extends ApiObject {
  '@type': 'PublishCurriculumApiResponse$PublishConflict' | 'PublishCurriculumApiResponse$RemoteServerPublishError' | 'PublishCurriculumApiResponse$SuccessfulPublish';
}

export interface PublishConflict extends PublishCurriculumApiResponse {
  '@type': 'PublishCurriculumApiResponse$PublishConflict';
}

export interface RemoteServerPublishError extends PublishCurriculumApiResponse {
  '@type': 'PublishCurriculumApiResponse$RemoteServerPublishError';
  correlationId: string;
}

export interface SuccessfulPublish extends PublishCurriculumApiResponse {
  '@type': 'PublishCurriculumApiResponse$SuccessfulPublish';
}

export interface RowWithNumber extends ApiObject {
  '@type': 'BadgeRowWithNumber' | 'CourseRowWithNumber' | 'ProgramRowWithNumber' | 'ImportRowWithNumber';
  duplicateGroupId: string;
  importNotices: ImportNotices;
  rowNumber: number;
}

export interface SaveEntityApiResponse extends ApiObject {
  '@type': 'SaveEntityApiResponse$EntitySaved' | 'SaveEntityApiResponse$SlugConflict';
}

export interface EntitySaved extends SaveEntityApiResponse {
  '@type': 'SaveEntityApiResponse$EntitySaved';
  entityId: string;
}

export interface SlugConflict extends SaveEntityApiResponse {
  '@type': 'SaveEntityApiResponse$SlugConflict';
}

export interface ValueNotImportable extends IValueNotImportable {
  '@type': 'ValueNotImportable';
}

export interface CurriculumYearMissing extends AddCourseListApiResponse {
  '@type': 'CurriculumYearMissing';
}

export interface AuthenticatedUser extends IAuthenticatedUser {
  '@type': 'AuthenticatedUser';
}

export interface ForgotPasswordRequest extends IForgotPasswordRequest {
  '@type': 'ForgotPasswordRequest';
}

export interface IAuthenticatedUser extends ApiObject {
  '@type': 'AuthenticatedUser';
  email: string;
  firstName: string;
  lastName: string;
}

export interface IForgotPasswordRequest extends ApiObject {
  '@type': 'ForgotPasswordRequest';
  email: string;
}

export interface IResetPasswordRequest extends ApiObject {
  '@type': 'ResetPasswordRequest';
  password: string;
  resetToken: string;
}

export interface IUserTokenCreateRequest extends ApiObject {
  '@type': 'UserTokenCreateRequest';
  username: string;
  password: string;
}

export interface ResetPasswordRequest extends IResetPasswordRequest {
  '@type': 'ResetPasswordRequest';
}

export interface UserTokenCreateRequest extends IUserTokenCreateRequest {
  '@type': 'UserTokenCreateRequest';
}

export interface CurriculumEntitySearchCriteria extends ICurriculumEntitySearchCriteria {
  '@type': 'CurriculumEntitySearchCriteria';
}

export interface NoActor extends INoActor {
  '@type': 'NoActor';
}

export interface OperationActor extends ApiObject {
  '@type': 'NoActor' | 'PreAuthUser';
}

export interface INoActor extends OperationActor {
  '@type': 'NoActor';
}

export interface IPreAuthUser extends OperationActor {
  '@type': 'PreAuthUser';
}

export interface PreAuthUser extends IPreAuthUser {
  '@type': 'PreAuthUser';
}

export interface ICurriculumEntitySearchCriteria extends ApiObject {
  '@type': 'CurriculumEntitySearchCriteria';
  searchTerm?: string;
  matchingSlugs?: string[];
  showActive: boolean;
  showInactive: boolean;
  anyOfPublishabilities: Publishability[];
  noneOfPublishabilities: Publishability[];
  treatInactiveAsActiveForPublishabilityFilter: boolean;
  anyOfNoticeTypes: NoticeTypeFilter[];
  noneOfNonFieldNoticeTypes: string[];
}

export interface CourseIdentifyingValues extends ICourseIdentifyingValues {
  '@type': 'CourseIdentifyingValues';
}

export interface CourseRecord extends ICourseRecord {
  '@type': 'CourseRecord';
}

export interface ICourseIdentifyingValues extends IdentifyingValues<RichCourseRecord> {
  '@type': 'CourseIdentifyingValues';
  subjectAndNumber: string;
}

export interface ICourseRecord extends Record<RichCourseRecord> {
  '@type': 'CourseRecord';
  courseId?: string;
  include: boolean;
  title?: string;
  cccControlNumber?: string;
  description?: string;
  courseSubject?: string;
  courseNumber?: string;
  subjectAndNumber?: string;
  topCode?: string;
  minUnits?: number;
  maxUnits?: number;
  transferability?: CourseTransferability[];
  labHours?: number;
  lectureHours?: number;
  materialsFee?: number;
  prerequisites?: string[];
  prerequisiteText?: string;
  corequisites?: string[];
  instructionMethod?: InstructionMethod;
  badgeClassUrls?: string[];
  highSchools?: string[];
}

export interface IRichCourseRecord extends RichRecord {
  '@type': 'RichCourseRecord';
  include: RichValue<boolean>;
  title: RichValue<string>;
  cccControlNumber: RichValue<string>;
  description: RichValue<string>;
  subjectAndNumber: RichValue<string>;
  topCode: RichValue<string>;
  minUnits: RichValue<number>;
  maxUnits: RichValue<number>;
  transferability: RichValue<CourseTransferability[]>;
  labHours: RichValue<number>;
  lectureHours: RichValue<number>;
  materialsFee: RichValue<number>;
  restrictions?: RichValue<string>;
  prerequisites: RichValue<string[]>;
  prerequisiteText: RichValue<string>;
  corequisites: RichValue<string[]>;
  instructionMethod: RichValue<InstructionMethod>;
  highSchools: RichValue<string[]>;
  badgeClassUrls: RichValue<string[]>;
}

export interface RichCourseRecord extends IRichCourseRecord {
  '@type': 'RichCourseRecord';
}

export interface ParseErrorApiObject extends ApiObject {
  '@type': 'ParseErrorApiObject$BadgeSystemNotReachableError' | 'ParseErrorApiObject$CociNotReachableError' | 'ParseErrorApiObject$NoSourceConfiguredError' | 'ParseErrorApiObject$NotParsableError' | 'ParseErrorApiObject$ParseValidationError' | 'ParseErrorApiObject$SourceNotFetchableError';
}

export interface BadgeSystemNotReachableError extends ParseErrorApiObject {
  '@type': 'ParseErrorApiObject$BadgeSystemNotReachableError';
  urlCalled: string;
}

export interface CociNotReachableError extends ParseErrorApiObject {
  '@type': 'ParseErrorApiObject$CociNotReachableError';
  urlCalled: string;
}

export interface NoSourceConfiguredError extends ParseErrorApiObject {
  '@type': 'ParseErrorApiObject$NoSourceConfiguredError';
}

export interface NotParsableError extends ParseErrorApiObject {
  '@type': 'ParseErrorApiObject$NotParsableError';
}

export interface ParseValidationError extends ParseErrorApiObject {
  '@type': 'ParseErrorApiObject$ParseValidationError';
  minimumRequirementErrors: RowWithNumber[];
}

export interface SourceNotFetchableError extends ParseErrorApiObject {
  '@type': 'ParseErrorApiObject$SourceNotFetchableError';
}

export interface AbsentValue<T> extends AbstractRichValue<T> {
  '@type': 'AbsentValue';
}

export interface AbstractRichValue<T> extends RichValue<T> {
  '@type': 'AbsentValue' | 'MergedValue' | 'PatchedValue' | 'SourceValue';
}

export interface IMergedValue<T> extends AbstractRichValue<T> {
  '@type': 'MergedValue';
  valueSources: SourceSystem[];
}

export interface IPatchedValue<T> extends AbstractRichValue<T> {
  '@type': 'PatchedValue';
  originalField: RichValue<T>;
  patchField: IPatchValue<T>;
  valuesDiffer: boolean;
}

export interface ISourceValue<T> extends AbstractRichValue<T> {
  '@type': 'SourceValue';
  initDate?: string;
  source: SourceSystem;
  actor?: OperationActor;
}

export interface MergedValue<T> extends IMergedValue<T> {
  '@type': 'MergedValue';
}

export interface PatchedValue<T> extends IPatchedValue<T> {
  '@type': 'PatchedValue';
}

export interface RichValue<T> extends ApiObject {
  '@type': 'AbsentValue' | 'MergedValue' | 'PatchedValue' | 'SourceValue';
  value?: T;
}

export interface SourceValue<T> extends ISourceValue<T> {
  '@type': 'SourceValue';
}

export interface HighSchool extends IHighSchool {
  '@type': 'HighSchool';
}

export interface IHighSchool extends ApiObject {
  '@type': 'HighSchool';
  id: string;
  title: string;
  url: string;
  lineOne: string;
  lineTwo?: string;
  city: string;
  state: string;
  zip: string;
  date?: string;
  courses?: string[];
  collegeId: string;
  curriculumIri: string;
}

export interface AlignmentSuggestion<TSummary, TSimilarity> extends IAlignmentSuggestion<TSummary, TSimilarity> {
  '@type': 'AlignmentSuggestion';
}

export interface AlignmentSuggestionsForEntity<TSummary, TSimilarity> extends IAlignmentSuggestionsForEntity<TSummary, TSimilarity> {
  '@type': 'AlignmentSuggestionsForEntity';
  masterRecordKey: IMasterRecordKey;
  presentSystems: SourceSystem[];
  missingSystems: SourceSystem[];
  activeSuggestions: IAlignmentSuggestion<TSummary, TSimilarity>[];
  inactiveSuggestions: IAlignmentSuggestion<TSummary, TSimilarity>[];
  entityKey: string;
  summary: TSummary;
}

export interface IAlignmentSuggestion<TSummary, TSimilarity> extends ApiObject {
  '@type': 'AlignmentSuggestion';
  entityKey: string;
  summary: TSummary;
  presentSystems: SourceSystem[];
  similarity: TSimilarity;
  isRejected: boolean;
}

export interface IAlignmentSuggestionsForEntity<TSummary, TSimilarity> extends ApiObject {
  '@type': 'AlignmentSuggestionsForEntity';
}

export interface ISearchAlignmentCandidatesResults<TSummary, TSimilarity> extends ApiObject {
  '@type': 'SearchAlignmentCandidatesResults';
  activeSuggestions: IAlignmentSuggestion<TSummary, TSimilarity>[];
  inactiveSuggestions: IAlignmentSuggestion<TSummary, TSimilarity>[];
}

export interface ISourceCountSummary extends ApiObject {
  '@type': 'SourceCountSummary';
  distinct: number;
  unusable: number;
  missingIdentifyingAttributes: number;
  hasUnresolvedDuplicates: number;
}

export interface IStandardOccupation extends ApiObject {
  '@type': 'StandardOccupation';
  socCode: string;
  title: string;
}

export interface SearchAlignmentCandidatesResults<TSummary, TSimilarity> extends ISearchAlignmentCandidatesResults<TSummary, TSimilarity> {
  '@type': 'SearchAlignmentCandidatesResults';
}

export interface SourceCountSummary extends ISourceCountSummary {
  '@type': 'SourceCountSummary';
}

export interface StandardOccupation extends IStandardOccupation {
  '@type': 'StandardOccupation';
}

export interface MasterRecordKey extends IMasterRecordKey {
  '@type': 'MasterRecordKey';
}

export interface RecordKey extends ApiObject {
  '@type': 'MasterRecordKey' | 'SourceRecordKey';
}

export interface IMasterRecordKey extends RecordKey {
  '@type': 'MasterRecordKey';
  persistentId: string;
}

export interface ISourceRecordKey extends RecordKey {
  '@type': 'SourceRecordKey';
  sourceSystem: SourceSystem;
  sourceRecordId: string;
}

export interface SourceRecordKey extends ISourceRecordKey {
  '@type': 'SourceRecordKey';
}

export interface ActiveSourceRecordExcluded extends IActiveSourceRecordExcluded {
  '@type': 'ActiveSourceRecordExcluded';
}

export interface CipCodeWithoutSOCs extends ICipCodeWithoutSOCs {
  '@type': 'CipCodeWithoutSOCs';
}

export interface CourseDescriptionSameAsSubjectAndNumber extends ICourseDescriptionSameAsSubjectAndNumber {
  '@type': 'CourseDescriptionSameAsSubjectAndNumber';
}

export interface CourseTitleSameAsSubjectAndNumber extends ICourseTitleSameAsSubjectAndNumber {
  '@type': 'CourseTitleSameAsSubjectAndNumber';
}

export interface CyclicCourseRequisite extends ICyclicCourseRequisite {
  '@type': 'CyclicCourseRequisite';
}

export interface DataAddedManually<TRichRecord, TValue> extends IDataAddedManually<TRichRecord, TValue> {
  '@type': 'DataAddedManually';
}

export interface DataCorrectedManually<TRichRecord, TValue> extends IDataCorrectedManually<TRichRecord, TValue> {
  '@type': 'DataCorrectedManually';
}

export interface DeprecatedPattern extends IDeprecatedPattern {
  '@type': 'DeprecatedPattern';
}

export interface DescriptionSameAsTitle extends IDescriptionSameAsTitle {
  '@type': 'DescriptionSameAsTitle';
}

export interface DuplicatesAutoResolved extends IDuplicatesAutoResolved {
  '@type': 'DuplicatesAutoResolved';
}

export interface HasNoPublishableCourses extends IHasNoPublishableCourses {
  '@type': 'HasNoPublishableCourses';
}

export interface ErrorNotice extends Notice {
  '@type': 'HasNoPublishableCourses' | 'InvalidRequiredData' | 'InvalidRequiredFields' | 'MissingRequiredData' | 'MissingRequiredFields' | 'NonPublishableAwardType' | 'UnmergeableRecord' | 'UnresolvedDuplicates';
}

export interface IDeprecatedPattern extends WarningNotice {
  '@type': 'DeprecatedPattern';
}

export interface IHasNoPublishableCourses extends ErrorNotice {
  '@type': 'HasNoPublishableCourses';
}

export interface ISomeInactiveCourses extends WarningNotice {
  '@type': 'SomeInactiveCourses';
  inactiveCourseSlugs: string[];
}

export interface ISomeMissingCourses extends WarningNotice {
  '@type': 'SomeMissingCourses';
  missingCourseSlugs: string[];
}

export interface ISomeNonPublishableCourses extends WarningNotice {
  '@type': 'SomeNonPublishableCourses';
  nonPublishableCourseSlugs: string[];
}

export interface ISomePublishableCourses extends InfoNotice {
  '@type': 'SomePublishableCourses';
  publishableCoursesCount: number;
}

export interface InfoNotice extends Notice {
  '@type': 'SomePublishableCourses' | 'ActiveSourceRecordExcluded' | 'DataAddedManually' | 'DataCorrectedManually' | 'DuplicatesAutoResolved' | 'InactiveSourceRecordIncluded' | 'InconsistentDataFromSource' | 'InconsistentFields' | 'ManuallyAddedFields' | 'ManuallyCorrectedFields' | 'MissingDataFromSource' | 'SourceDuplicates';
}

export interface Notice extends ApiObject {
  '@type': 'HasNoPublishableCourses' | 'InvalidRequiredData' | 'InvalidRequiredFields' | 'MissingRequiredData' | 'MissingRequiredFields' | 'NonPublishableAwardType' | 'UnmergeableRecord' | 'UnresolvedDuplicates' | 'SomePublishableCourses' | 'ActiveSourceRecordExcluded' | 'DataAddedManually' | 'DataCorrectedManually' | 'DuplicatesAutoResolved' | 'InactiveSourceRecordIncluded' | 'InconsistentDataFromSource' | 'InconsistentFields' | 'ManuallyAddedFields' | 'ManuallyCorrectedFields' | 'MissingDataFromSource' | 'SourceDuplicates' | 'DeprecatedPattern' | 'SomeInactiveCourses' | 'SomeMissingCourses' | 'SomeNonPublishableCourses' | 'CyclicCourseRequisite' | 'InvalidOptionalData' | 'InvalidOptionalFields' | 'MissingOptionalData' | 'MissingOptionalFields' | 'MissingSystems' | 'NonPublishableRequisites' | 'SpellingWarning' | 'SuspiciousDataFields' | 'CipCodeWithoutSOCs' | 'CourseDescriptionSameAsSubjectAndNumber' | 'CourseTitleSameAsSubjectAndNumber' | 'DescriptionSameAsTitle' | 'StartsWithNumber' | 'TopCodeWithoutSOCs' | 'UnusuallyShort';
}

export interface IActiveSourceRecordExcluded extends InfoNotice {
  '@type': 'ActiveSourceRecordExcluded';
  sourceSystem: SourceSystem;
  excludedId: string;
}

export interface ICipCodeWithoutSOCs extends SuspiciousNotice {
  '@type': 'CipCodeWithoutSOCs';
}

export interface ICourseDescriptionSameAsSubjectAndNumber extends SuspiciousNotice {
  '@type': 'CourseDescriptionSameAsSubjectAndNumber';
}

export interface ICourseTitleSameAsSubjectAndNumber extends SuspiciousNotice {
  '@type': 'CourseTitleSameAsSubjectAndNumber';
}

export interface ICyclicCourseRequisite extends WarningNotice {
  '@type': 'CyclicCourseRequisite';
  requisiteCycle: IRequisiteCycle[];
}

export interface IDataAddedManually<TRichRecord, TValue> extends InfoNotice, FieldNotice {
  '@type': 'DataAddedManually';
  correctedValue: IFieldWithOptionalValue<TRichRecord, TValue>;
  valueIsTruncated: boolean;
}

export interface IDataCorrectedManually<TRichRecord, TValue> extends InfoNotice, FieldNotice {
  '@type': 'DataCorrectedManually';
  correctedValue: IFieldWithOptionalValue<TRichRecord, TValue>;
  valueIsTruncated: boolean;
}

export interface IDescriptionSameAsTitle extends SuspiciousNotice {
  '@type': 'DescriptionSameAsTitle';
}

export interface IDuplicatesAutoResolved extends InfoNotice {
  '@type': 'DuplicatesAutoResolved';
  sourceSystem: SourceSystem;
  sourceIds: string[];
  selectedId: string;
  strategy: DuplicateResolutionStrategy;
}

export interface IInactiveSourceRecordIncluded extends InfoNotice {
  '@type': 'InactiveSourceRecordIncluded';
  sourceSystem: SourceSystem;
  includedId: string;
}

export interface IInconsistentDataFromSource<TRichRecord, TValue> extends InfoNotice, FieldNotice {
  '@type': 'InconsistentDataFromSource';
  sourceSystem: SourceSystem;
  sourceValue: IFieldWithOptionalValue<TRichRecord, TValue>;
  goldenValue: IFieldWithOptionalValue<TRichRecord, TValue>;
  goldenValueSource: SourceSystem[];
  valueIsTruncated: boolean;
}

export interface IInconsistentFields extends InfoNotice {
  '@type': 'InconsistentFields';
  fields: string[];
}

export interface IInvalidOptionalData extends WarningNotice {
  '@type': 'InvalidOptionalData';
  message: string;
}

export interface IInvalidOptionalFields extends WarningNotice {
  '@type': 'InvalidOptionalFields';
  fields: string[];
}

export interface IInvalidRequiredData extends ErrorNotice {
  '@type': 'InvalidRequiredData';
  message: string;
}

export interface IInvalidRequiredFields extends ErrorNotice {
  '@type': 'InvalidRequiredFields';
  fields: string[];
}

export interface IManuallyAddedFields extends InfoNotice {
  '@type': 'ManuallyAddedFields';
  fields: string[];
}

export interface IManuallyCorrectedFields extends InfoNotice {
  '@type': 'ManuallyCorrectedFields';
  fields: string[];
}

export interface IMissingDataFromSource<TRichRecord, TValue> extends InfoNotice, FieldNotice {
  '@type': 'MissingDataFromSource';
  sourceSystem: SourceSystem;
  goldenValue: IFieldWithOptionalValue<TRichRecord, TValue>;
  goldenValueSource: SourceSystem[];
  valueIsTruncated: boolean;
}

export interface IMissingOptionalData extends WarningNotice {
  '@type': 'MissingOptionalData';
  message: string;
}

export interface IMissingOptionalFields extends WarningNotice {
  '@type': 'MissingOptionalFields';
  fields: string[];
}

export interface IMissingRequiredData extends ErrorNotice {
  '@type': 'MissingRequiredData';
  message: string;
}

export interface IMissingRequiredFields extends ErrorNotice {
  '@type': 'MissingRequiredFields';
  fields: string[];
}

export interface IMissingSystems extends WarningNotice {
  '@type': 'MissingSystems';
  missingSystems: SourceSystem[];
}

export interface INonPublishableAwardType extends ErrorNotice {
  '@type': 'NonPublishableAwardType';
}

export interface INonPublishableRequisites extends WarningNotice {
  '@type': 'NonPublishableRequisites';
  empty: boolean;
  errors: string[];
  inactive: string[];
  nonExistent: string[];
}

export interface ISourceDuplicates extends InfoNotice {
  '@type': 'SourceDuplicates';
  sourceSystem: SourceSystem;
  sourceIds: string[];
}

export interface ISpellingWarning<TDocument> extends SuspiciousNotice, WarningNotice, FieldNotice {
  '@type': 'SpellingWarning';
}

export interface IStartsWithNumber extends SuspiciousNotice {
  '@type': 'StartsWithNumber';
}

export interface ISuspiciousDataFields extends WarningNotice {
  '@type': 'SuspiciousDataFields';
  fields: string[];
}

export interface ITopCodeWithoutSOCs extends SuspiciousNotice {
  '@type': 'TopCodeWithoutSOCs';
}

export interface IUnmergeableRecord extends ErrorNotice {
  '@type': 'UnmergeableRecord';
  sourceIds: string[];
}

export interface IUnresolvedDuplicates extends ErrorNotice {
  '@type': 'UnresolvedDuplicates';
  sourceSystem: SourceSystem;
}

export interface IUnusuallyShort extends SuspiciousNotice {
  '@type': 'UnusuallyShort';
  message: string;
}

export interface SuspiciousNotice extends WarningNotice {
  '@type': 'CipCodeWithoutSOCs' | 'CourseDescriptionSameAsSubjectAndNumber' | 'CourseTitleSameAsSubjectAndNumber' | 'DescriptionSameAsTitle' | 'SpellingWarning' | 'StartsWithNumber' | 'TopCodeWithoutSOCs' | 'UnusuallyShort';
}

export interface WarningNotice extends Notice {
  '@type': 'DeprecatedPattern' | 'SomeInactiveCourses' | 'SomeMissingCourses' | 'SomeNonPublishableCourses' | 'CyclicCourseRequisite' | 'InvalidOptionalData' | 'InvalidOptionalFields' | 'MissingOptionalData' | 'MissingOptionalFields' | 'MissingSystems' | 'NonPublishableRequisites' | 'SpellingWarning' | 'SuspiciousDataFields' | 'CipCodeWithoutSOCs' | 'CourseDescriptionSameAsSubjectAndNumber' | 'CourseTitleSameAsSubjectAndNumber' | 'DescriptionSameAsTitle' | 'StartsWithNumber' | 'TopCodeWithoutSOCs' | 'UnusuallyShort';
}

export interface InactiveSourceRecordIncluded extends IInactiveSourceRecordIncluded {
  '@type': 'InactiveSourceRecordIncluded';
}

export interface InconsistentDataFromSource<TRichRecord, TValue> extends IInconsistentDataFromSource<TRichRecord, TValue> {
  '@type': 'InconsistentDataFromSource';
}

export interface InconsistentFields extends IInconsistentFields {
  '@type': 'InconsistentFields';
}

export interface InvalidOptionalData extends IInvalidOptionalData {
  '@type': 'InvalidOptionalData';
}

export interface InvalidOptionalFields extends IInvalidOptionalFields {
  '@type': 'InvalidOptionalFields';
}

export interface InvalidRequiredData extends IInvalidRequiredData {
  '@type': 'InvalidRequiredData';
}

export interface InvalidRequiredFields extends IInvalidRequiredFields {
  '@type': 'InvalidRequiredFields';
}

export interface ManuallyAddedFields extends IManuallyAddedFields {
  '@type': 'ManuallyAddedFields';
}

export interface ManuallyCorrectedFields extends IManuallyCorrectedFields {
  '@type': 'ManuallyCorrectedFields';
}

export interface MissingDataFromSource<TRichRecord, TValue> extends IMissingDataFromSource<TRichRecord, TValue> {
  '@type': 'MissingDataFromSource';
}

export interface MissingOptionalData extends IMissingOptionalData {
  '@type': 'MissingOptionalData';
}

export interface MissingOptionalFields extends IMissingOptionalFields {
  '@type': 'MissingOptionalFields';
}

export interface MissingRequiredData extends IMissingRequiredData {
  '@type': 'MissingRequiredData';
}

export interface MissingRequiredFields extends IMissingRequiredFields {
  '@type': 'MissingRequiredFields';
}

export interface MissingSystems extends IMissingSystems {
  '@type': 'MissingSystems';
}

export interface NonPublishableAwardType extends INonPublishableAwardType {
  '@type': 'NonPublishableAwardType';
}

export interface NonPublishableRequisites extends INonPublishableRequisites {
  '@type': 'NonPublishableRequisites';
}

export interface SomeInactiveCourses extends ISomeInactiveCourses {
  '@type': 'SomeInactiveCourses';
}

export interface SomeMissingCourses extends ISomeMissingCourses {
  '@type': 'SomeMissingCourses';
}

export interface SomeNonPublishableCourses extends ISomeNonPublishableCourses {
  '@type': 'SomeNonPublishableCourses';
}

export interface SomePublishableCourses extends ISomePublishableCourses {
  '@type': 'SomePublishableCourses';
}

export interface SourceDuplicates extends ISourceDuplicates {
  '@type': 'SourceDuplicates';
}

export interface SpellingWarning<TDocument> extends ISpellingWarning<TDocument> {
  '@type': 'SpellingWarning';
}

export interface StartsWithNumber extends IStartsWithNumber {
  '@type': 'StartsWithNumber';
}

export interface SuspiciousDataFields extends ISuspiciousDataFields {
  '@type': 'SuspiciousDataFields';
}

export interface TopCodeWithoutSOCs extends ITopCodeWithoutSOCs {
  '@type': 'TopCodeWithoutSOCs';
}

export interface UnmergeableRecord extends IUnmergeableRecord {
  '@type': 'UnmergeableRecord';
}

export interface UnresolvedDuplicates extends IUnresolvedDuplicates {
  '@type': 'UnresolvedDuplicates';
}

export interface UnusuallyShort extends IUnusuallyShort {
  '@type': 'UnusuallyShort';
}

export interface IProgramIdentifyingValues extends IdentifyingValues<RichProgramRecord> {
  '@type': 'ProgramIdentifyingValues';
  title?: string;
  awardType?: AwardType;
}

export interface IProgramRecord extends Record<RichProgramRecord> {
  '@type': 'ProgramRecord';
  include: boolean;
  title?: string;
  cccControlNumber?: string;
  description?: string;
  awardType?: AwardType;
  areasOfEmphasis: string[];
  transferability?: CourseTransferability[];
  topCode?: string;
  cipCode?: string;
  minUnits?: number;
  maxUnits?: number;
  additionalRequirements?: string;
  tty?: string;
  youtubeVideoId?: string;
  learningOutcomes?: string[];
  instructionMethod?: InstructionMethod;
  badgeClassUrl?: string;
}

export interface IRichProgramRecord extends RichRecord {
  '@type': 'RichProgramRecord';
  include: RichValue<boolean>;
  title: RichValue<string>;
  cccControlNumber: RichValue<string>;
  description: RichValue<string>;
  awardType: RichValue<AwardType>;
  transferability: RichValue<CourseTransferability[]>;
  topCode: RichValue<string>;
  cipCode: RichValue<string>;
  minUnits: RichValue<number>;
  maxUnits: RichValue<number>;
  additionalRequirements: RichValue<string>;
  tty: RichValue<string>;
  youtubeVideoId: RichValue<string>;
  learningOutcomes: RichValue<string[]>;
  badgeClassUrl: RichValue<string>;
  instructionMethod: RichValue<InstructionMethod>;
}

export interface ProgramIdentifyingValues extends IProgramIdentifyingValues {
  '@type': 'ProgramIdentifyingValues';
}

export interface ProgramRecord extends IProgramRecord {
  '@type': 'ProgramRecord';
}

export interface RichProgramRecord extends IRichProgramRecord {
  '@type': 'RichProgramRecord';
}

export interface AlignmentCountSummary extends IAlignmentCountSummary {
  '@type': 'AlignmentCountSummary';
}

export interface IAlignmentCountSummary extends ApiObject {
  '@type': 'AlignmentCountSummary';
  alignedCount: number;
  unalignedCountByPresentSystem: { [P in SourceSystem]?: number };
}

export interface IIdentifyingAttributesMissing extends ApiObject {
  '@type': 'IdentifyingAttributesMissing';
}

export interface IdentifyingAttributesMissing extends IIdentifyingAttributesMissing {
  '@type': 'IdentifyingAttributesMissing';
}

export interface Correction<TDocument, TValue> extends ApiObject {
  '@type': 'SetValue';
}

export interface ISetValue<TDocument, TValue> extends Correction<TDocument, TValue> {
  '@type': 'SetValue';
  field: string;
  value?: TValue;
}

export interface IImportRowWithNumber extends RowWithNumber {
  '@type': 'ImportRowWithNumber';
}

export interface ISourceRecordDetail<TRecord> extends ApiObject {
  '@type': 'SourceRecordDetail';
  source: SourceSystem;
  sourceRecordId: string;
  record: TRecord;
  notices: INotices;
}

export interface IdentifyingValues<TDocument> extends ApiObject {
  '@type': 'CourseIdentifyingValues' | 'ProgramIdentifyingValues';
}

export interface ImportRowWithNumber extends IImportRowWithNumber {
  '@type': 'ImportRowWithNumber';
}

export interface Record<TRichRecord> extends ApiObject {
  '@type': 'CourseRecord' | 'ProgramRecord';
}

export interface RichRecord extends ApiObject {
  '@type': 'RichCourseRecord' | 'RichProgramRecord';
}

export interface SetValue<TDocument, TValue> extends ISetValue<TDocument, TValue> {
  '@type': 'SetValue';
}

export interface SourceRecordDetail<TRecord> extends ISourceRecordDetail<TRecord> {
  '@type': 'SourceRecordDetail';
}

export interface CourseGroup extends ICourseGroup {
  '@type': 'CourseGroup';
}

export interface CourseGroupContent extends ApiObject {
  '@type': 'CourseGroup';
  longDescription: string;
  title: string;
  shortDescription: string;
}

export interface ICourseGroup extends CourseGroupContent {
  '@type': 'CourseGroup';
  courseSlugs: string[];
}

export interface GenEdCurriculumBranch extends IGenEdCurriculumBranch {
  '@type': 'GenEdCurriculumBranch';
}

export interface GenEdCurriculumLeaf extends IGenEdCurriculumLeaf {
  '@type': 'GenEdCurriculumLeaf';
}

export interface GenEdCurriculumNode extends ApiObject {
  '@type': 'GenEdCurriculumBranch' | 'GenEdCurriculumLeaf';
  id: string;
  longDescription: string;
  title: string;
  area: string;
  shortDescription: string;
}

export interface IGenEdCurriculumBranch extends GenEdCurriculumNode {
  '@type': 'GenEdCurriculumBranch';
  groups: IGenEdCurriculumLeaf[];
}

export interface IGenEdCurriculumLeaf extends GenEdCurriculumNode {
  '@type': 'GenEdCurriculumLeaf';
}

export interface IPaginatedFilteredCipCodeSearchResults extends ApiObject {
  '@type': 'PaginatedFilteredCipCodeSearchResults';
  totalSearchResultCount: number;
  cipCodes: ICipCode[];
}

export interface IPaginatedFilteredTopCodeSearchResults extends ApiObject {
  '@type': 'PaginatedFilteredTopCodeSearchResults';
  totalSearchResultCount: number;
  topCodes: ITopCode[];
}

export interface IPaginatedFilteredImportedBadgesSearchResults extends ApiObject {
  '@type': 'PaginatedFilteredImportedBadgesSearchResults';
  totalSearchResultCount: number;
  importedBadges: IImportedBadge[];
}

export interface PaginatedFilteredCipCodeSearchResults extends IPaginatedFilteredCipCodeSearchResults {
  '@type': 'PaginatedFilteredCipCodeSearchResults';
}

export interface PaginatedFilteredImportedBadgesSearchResults extends IPaginatedFilteredImportedBadgesSearchResults {
  '@type': 'PaginatedFilteredImportedBadgesSearchResults';
}

export interface PaginatedFilteredTopCodeSearchResults extends IPaginatedFilteredTopCodeSearchResults {
  '@type': 'PaginatedFilteredTopCodeSearchResults';
}

export interface SourcesProvider extends ApiObject {
  '@type': 'COCISource' | 'CSUSupplementalSource' | 'ELumenSource' | 'GenericCollegeSource' | 'InternalSource' | 'PeopleSoftSource' | 'UCGenericCollegeSource';
}

export interface ApiObject {
  '@type': 'CourseSimilarity' | 'ProgramSimilarity' | 'CourseSummaryForAlignment' | 'ProgramSummaryForAlignment' | 'CourseActiveAmendHandler$CourseActiveAmendRow' | 'CourseDescriptionAmendHandler$CourseDescriptionAmendRow' | 'CourseRequisitesAmendHandler$CourseRequisitesAmendRow' | 'CourseUnitsAmendHandler$CourseUnitsAmendRow' | 'ProgramActiveAmendHandler$ProgramActiveAmendRow' | 'ProgramBadgeClassAmendHandler$ProgramBadgeClassAmendRow' | 'ProgramDescriptionAmendHandler$ProgramDescriptionAmendRow' | 'ProgramLearningOutcomesAmendHandler$ProgramOutcomesAmendRow' | 'ProgramVideoAmendHandler$ProgramVideoAmendRow' | 'ApiEntityRequest' | 'EntityAliasApiEntity' | 'EntitySetApiEntity' | 'FindCoursesAction' | 'FindProgramsAction' | 'AcceptAlignmentSuggestion' | 'AggregateAlignmentCounts' | 'AggregateCleanCounts' | 'AggregateNoticeCounts' | 'AggregateSourceCounts' | 'ArchiveCurriculumYearAction' | 'CourseListAddRequest' | 'CourseListByIdAction' | 'CreateCurriculumYearAction' | 'CreateHighSchoolAction' | 'CurriculumEntityDetailAction' | 'DeleteCourseListAction' | 'EditCurriculumNotesAction' | 'EditHighSchoolAction' | 'FindCipCodesAction' | 'FindCollegeBySlugAction' | 'FindCourseListsAction' | 'FindCurriculumYearAction' | 'FindCurriculumYearsForCollegeAction' | 'FindGenEdPatternsAction' | 'FindImportedBadgesAction' | 'FindPickableCollegesAction' | 'FindPickableCoursesAction' | 'FindTopCodesAction' | 'GenerateCollegeReportAction' | 'GetCoursesByHighSchoolAction' | 'GetCurriculumYearHistoryAction' | 'GetDuplicateImportedCoursesAction' | 'GetGenEdPatternAction' | 'GetImportedCoursesAction' | 'GetImportedProgramsAction' | 'GetImportedProgramsMissingTitleAndAwardAction' | 'MarkPublishedAction' | 'PublishCurriculumAction' | 'PublishPreviewAction' | 'RecordMutationAction' | 'RejectSuggestions' | 'SearchHighSchoolsByCollegeAction' | 'SourceRecordDetailAction' | 'UpdateCourseListAction' | 'UpdateGenEdAction' | 'ListCoursesWithAlignmentSuggestions' | 'ListProgramsWithAlignmentSuggestions' | 'SearchCourseAlignmentCandidates' | 'SearchProgramAlignmentCandidates' | 'DummyEntityAliasApiEntityId' | 'DummyEntitySetApiEntityId' | 'DummyApiEntityId' | 'ApiEntityResponse' | 'CourseApiObject' | 'ProgramApiObject' | 'CourseForSearchResult' | 'ProgramForSearchResult' | 'CurriculumYearsForCollegeResponse' | 'GenEdPatternArea' | 'GenEdPatternSubArea' | 'EntityIsAlignedError' | 'EntityIsMissingCriticalDataError' | 'NoSuchEntityAlignmentError' | 'AcceptSuggestionResult' | 'BulkAmendTypeApiObject' | 'CleanCounts' | 'CollegeNotFound' | 'CourseForPublishPreview' | 'CourseListApiObject' | 'CourseListForPublishPreview' | 'CourseListId' | 'CourseSourceRecordSummary' | 'CreateHighSchoolResponse' | 'CurriculumEntityDetailMissing' | 'CurriculumEntityId' | 'CurriculumEntitySummary' | 'CurriculumRevisionApiObject' | 'CurriculumYearCreationError' | 'CurriculumYearCreationSuccess' | 'CurriculumYearHistoryResponse' | 'CurriculumYearNotFoundError' | 'DuplicateImportedCoursesResponse' | 'EditHighSchoolResponse' | 'FindCipCodesResponse' | 'FindGenEdPatternsResponse' | 'FindImportedBadgesResponse' | 'FindPickableCollegesResponse' | 'FindPickableCoursesResponse' | 'FindTopCodesResponse' | 'GenEdPatternApiObject' | 'GenEdPatternForPublishPreview' | 'GetCoursesByHighSchoolResponse' | 'HighSchoolCoursesApiObject' | 'ImportCorrections' | 'ImportedCoursesResponse' | 'ImportedProgramsMissingTitleAndAwardResponse' | 'ImportedProgramsResponse' | 'NotFound' | 'NoticeCountSummary' | 'PaginatedCourseListSearchResults' | 'PaginatedFilteredCourseSearchResults' | 'PaginatedFilteredProgramSearchResults' | 'PaginatedResults' | 'PickedCipCode' | 'PickedCourse' | 'PickedTopCode' | 'ProgramForPublishPreview' | 'ProgramSourceRecordSummary' | 'PublishPreview' | 'RenameEntityErrors' | 'SearchHighSchoolsResponse' | 'SourceCountSummaries' | 'SourceRecordDetailApiObject' | 'PickableCourse' | 'PickableProgram' | 'AddCorrectionsAction' | 'AddLocalCourseAction' | 'AddLocalProgramAction' | 'BulkAmendCorrectionsAction' | 'CorrectMultipleRecords' | 'DeactivateSourceSystemAction' | 'FetchAndImportSourceFileAction' | 'ImportBadgeFileAction' | 'ImportSourceFileAction' | 'InvalidateAllAction' | 'RemapPersistentIdAction' | 'RenameEntityAction' | 'RenameMultipleRecords' | 'CollegeReportCourseSummary' | 'CollegeReportProgramSummary' | 'ReportField' | 'AddCourseListApiResponse$CourseListAdded' | 'CurriculumYearMissing' | 'AddCurriculumYearApiResponse$YearAdded' | 'AddCurriculumYearApiResponse$YearAlreadyExists' | 'ApiEither$Failure' | 'ApiEither$Success' | 'ApiEither$EnumWrapper' | 'BulkAmendErrors' | 'BulkAmendResult' | 'CollegeReport' | 'DuplicateRow' | 'InvalidCollege' | 'MergeKeyNotFound' | 'ValueNotImportable' | 'MergeSummary' | 'Nothing' | 'PublishCurriculumApiResponse$PublishConflict' | 'PublishCurriculumApiResponse$RemoteServerPublishError' | 'PublishCurriculumApiResponse$SuccessfulPublish' | 'BadgeRowWithNumber' | 'CourseRowWithNumber' | 'ProgramRowWithNumber' | 'ImportRowWithNumber' | 'SaveEntityApiResponse$EntitySaved' | 'SaveEntityApiResponse$SlugConflict' | 'AuthenticatedUser' | 'ForgotPasswordRequest' | 'ResetPasswordRequest' | 'UserTokenCreateRequest' | 'NoActor' | 'PreAuthUser' | 'CurriculumEntitySearchCriteria' | 'ParseErrorApiObject$BadgeSystemNotReachableError' | 'ParseErrorApiObject$CociNotReachableError' | 'ParseErrorApiObject$NoSourceConfiguredError' | 'ParseErrorApiObject$NotParsableError' | 'ParseErrorApiObject$ParseValidationError' | 'ParseErrorApiObject$SourceNotFetchableError' | 'AbsentValue' | 'MergedValue' | 'PatchedValue' | 'SourceValue' | 'HighSchool' | 'AlignmentSuggestion' | 'AlignmentSuggestionsForEntity' | 'SearchAlignmentCandidatesResults' | 'SourceCountSummary' | 'StandardOccupation' | 'MasterRecordKey' | 'SourceRecordKey' | 'HasNoPublishableCourses' | 'InvalidRequiredData' | 'InvalidRequiredFields' | 'MissingRequiredData' | 'MissingRequiredFields' | 'NonPublishableAwardType' | 'UnmergeableRecord' | 'UnresolvedDuplicates' | 'SomePublishableCourses' | 'ActiveSourceRecordExcluded' | 'DataAddedManually' | 'DataCorrectedManually' | 'DuplicatesAutoResolved' | 'InactiveSourceRecordIncluded' | 'InconsistentDataFromSource' | 'InconsistentFields' | 'ManuallyAddedFields' | 'ManuallyCorrectedFields' | 'MissingDataFromSource' | 'SourceDuplicates' | 'DeprecatedPattern' | 'SomeInactiveCourses' | 'SomeMissingCourses' | 'SomeNonPublishableCourses' | 'CyclicCourseRequisite' | 'InvalidOptionalData' | 'InvalidOptionalFields' | 'MissingOptionalData' | 'MissingOptionalFields' | 'MissingSystems' | 'NonPublishableRequisites' | 'SpellingWarning' | 'SuspiciousDataFields' | 'CipCodeWithoutSOCs' | 'CourseDescriptionSameAsSubjectAndNumber' | 'CourseTitleSameAsSubjectAndNumber' | 'DescriptionSameAsTitle' | 'StartsWithNumber' | 'TopCodeWithoutSOCs' | 'UnusuallyShort' | 'AlignmentCountSummary' | 'IdentifyingAttributesMissing' | 'SetValue' | 'SourceRecordDetail' | 'CourseIdentifyingValues' | 'ProgramIdentifyingValues' | 'CourseRecord' | 'ProgramRecord' | 'CourseSchema' | 'ProgramSchema' | 'RichCourseRecord' | 'RichProgramRecord' | 'CourseGroup' | 'GenEdCurriculumBranch' | 'GenEdCurriculumLeaf' | 'PaginatedFilteredCipCodeSearchResults' | 'PaginatedFilteredTopCodeSearchResults' | 'PaginatedFilteredImportedBadgesSearchResults' | 'COCISource' | 'CSUSupplementalSource' | 'ELumenSource' | 'GenericCollegeSource' | 'InternalSource' | 'PeopleSoftSource' | 'UCGenericCollegeSource' | 'CollegeApiEntity' | 'CurriculumYearApiObject';
}

export interface ImportNotices extends IImportNotices {
}

export interface IImportedBadgeRow {
}

export interface INotices {
  nonFieldNotices: Notice[];
  fieldNotices: { [index: string]: Notice[] };
  hasWarnings: boolean;
  hasErrors: boolean;
  hasInfos: boolean;
}

export interface IPickedBadge {
  badgeClassUrl: string;
  badgeTitle?: string;
  badgeClassImageUrl?: string;
  missing: boolean;
}

export interface CreateHighSchoolApiObject extends ICreateHighSchoolApiObject {
}

export interface CurriculumYearId {
  uuid: string;
}

export interface ImportedCourseApiObject extends IImportedCourseApiObject {
}

export interface EditHighSchoolApiObject extends IEditHighSchoolApiObject {
}

export interface ICipCode {
  cipCode: string;
  title: string;
  standardOccupations: IStandardOccupation[];
}

export interface HasCollegeSlug {
}

export interface HasCurriculumYear {
}

export interface GenEdPatternSummary extends IGenEdPatternSummary {
}

export interface IImportedBadge extends EntityWithId {
  lockVersion: number;
  curriculumYearId: string;
  badgeClassUrl: string;
  badgeTitle: string;
  badgeClassImageUrl: string;
  notices: INotices;
}

export interface PickableCollege extends IPickableCollege {
}

export interface ITopCode {
  topCode: string;
  title: string;
  standardOccupations: IStandardOccupation[];
}

export interface WithGenEdPatternArea {
}

export interface WithGenEdPatternApiObject {
}

export interface ImportCorrection extends IImportCorrection {
}

export interface ImportedProgramApiObject extends IImportedProgramApiObject {
}

export interface CourseListForSearchResult extends ICourseListForSearchResult {
}

export interface INoticeCounts {
  inactiveCount: number;
  activeCount: number;
  noticeSeverityCounts: { [P in Publishability]?: number };
  noticeTypeCounts: { [index: string]: number };
}

export interface SavedHighSchoolApiObject extends ISavedHighSchoolApiObject {
}

export interface Pair<A, B> extends Serializable {
}

export interface NoticeTypeFilter extends INoticeTypeFilter {
}

export interface IPatchValue<T> {
  originalValue?: T;
  value?: T;
  creationDate?: string;
  actor?: OperationActor;
}

export interface IRequisiteCycle {
  requisites: IRequisiteSummary[];
}

export interface IFieldWithOptionalValue<TDocument, TValue> {
  field: string;
  value?: TValue;
}

export interface FieldNotice {
}

export interface IImportNotices {
  notices: ImportNotice[];
  hasValueNotImportableNotice: boolean;
  hasDuplicateMergeKeyNotice: boolean;
  hasMergeKeyNotFoundNotice: boolean;
  hasErrors: boolean;
}

export interface ICreateHighSchoolApiObject {
  title: string;
  url: string;
  lineOne: string;
  lineTwo?: string;
  city: string;
  state: string;
  zip: string;
  advisingLink?: string;
  collegeId: string;
  curriculumIri: string;
}

export interface IImportedCourseApiObject {
  sourceRecordKey: ISourceRecordKey;
  title?: string;
  subjectAndNumber?: string;
  controlNumber?: string;
  active?: boolean;
}

export interface IEditHighSchoolApiObject {
  id: string;
  title: string;
  url: string;
  lineOne: string;
  lineTwo?: string;
  city: string;
  state: string;
  zip: string;
  advisingLink?: string;
  collegeId: string;
  coursesObject?: IHighSchoolCoursesApiObject;
  curriculumIri: string;
}

export interface IGenEdPatternSummary {
  hasWarnings: boolean;
  clean: boolean;
  hasErrors: boolean;
  id: string;
  partOfCurriculum: boolean;
  title: string;
  description: string;
  deprecated: boolean;
  notices: INotices;
}

export interface EntityWithId {
  _id: string;
}

export interface IPickableCollege {
  slug: string;
  name: string;
}

export interface IImportCorrection {
  overrideValue: string;
}

export interface IImportedProgramApiObject {
  sourceRecordKey: ISourceRecordKey;
  title?: string;
  awardType?: AwardType;
  controlNumber?: string;
  active?: boolean;
}

export interface ICourseListForSearchResult {
  id: CourseListId;
  title: string;
  active: boolean;
  notices: INotices;
}

export interface ISavedHighSchoolApiObject {
  id: string;
  title: string;
  url: string;
  lineOne: string;
  lineTwo?: string;
  city: string;
  state: string;
  zip: string;
  date?: string;
  advisingLink?: string;
  courses?: string[];
  collegeId: string;
  curriculumIri: string;
  coursesObject?: IHighSchoolCoursesApiObject;
}

export interface Serializable {
}

export interface INoticeTypeFilter {
  fields: string[];
  noticeType: string;
}

export interface IRequisiteSummary {
  entityId?: string;
  subjectAndNumber: string;
  slug: string;
}

export interface CollegeApiEntity extends ApiObject {
  '@type': 'CollegeApiEntity';
  id: string;
  slug: string;
  name: string;
  sources: { [P in SourceSystem]?: SourcesProvider };
  sourceSystemLabels: { [P in PipelineEntityType]?: { [P in SourceSystem]?: string } };
}

export interface CurriculumYearApiObject extends ApiObject {
  '@type': 'CurriculumYearApiObject';
  id: CurriculumYearId;
  templateDownloadUrls: { [P in BulkAmendType]?: string };
  collegeSlug: string;
  curriculumYear: number;
  currentRevision: number;
  programClassification: ProgramClassification;
  currentRevisionNotes?: string;
  systemsImported: { [P in PipelineEntityType]?: SourceSystem[] };
  publishabilityCounts: { [P in CurriculumEntityType]?: { [P in Publishability]?: number } };
}

export interface COCISource extends SourcesProvider {
  '@type': 'COCISource';
  numericalId: string;
  alphaId: string;
}

export interface CSUSupplementalSource extends SourcesProvider {
  '@type': 'CSUSupplementalSource';
}

export interface ELumenSource extends SourcesProvider {
  '@type': 'ELumenSource';
}

export interface GenericCollegeSource extends SourcesProvider {
  '@type': 'GenericCollegeSource';
}

export interface InternalSource extends SourcesProvider {
  '@type': 'InternalSource';
}

export interface PeopleSoftSource extends SourcesProvider {
  '@type': 'PeopleSoftSource';
}

export interface UCGenericCollegeSource extends SourcesProvider {
  '@type': 'UCGenericCollegeSource';
}

export enum CourseSchema {
  include = 'CourseSchema-include',
  title = 'CourseSchema-title',
  cccControlNumber = 'CourseSchema-cccControlNumber',
  description = 'CourseSchema-description',
  subjectAndNumber = 'CourseSchema-subjectAndNumber',
  errorThrowingWither = 'CourseSchema-errorThrowingWither',
  errorThrowingGetter = 'CourseSchema-errorThrowingGetter',
  courseSubject = 'CourseSchema-courseSubject',
  courseNumber = 'CourseSchema-courseNumber',
  topCode = 'CourseSchema-topCode',
  minUnits = 'CourseSchema-minUnits',
  maxUnits = 'CourseSchema-maxUnits',
  transferability = 'CourseSchema-transferability',
  labHours = 'CourseSchema-labHours',
  lectureHours = 'CourseSchema-lectureHours',
  materialsFee = 'CourseSchema-materialsFee',
  prerequisites = 'CourseSchema-prerequisites',
  prerequisiteText = 'CourseSchema-prerequisiteText',
  corequisites = 'CourseSchema-corequisites',
  instructionMethod = 'CourseSchema-instructionMethod',
  badgeClassUrls = 'CourseSchema-badgeClassUrls',
  metadata = 'CourseSchema-metadata',
  all = 'CourseSchema-all',
  valueClassByField = 'CourseSchema-valueClassByField',
}

export enum ProgramSchema {
  include = 'ProgramSchema-include',
  title = 'ProgramSchema-title',
  cccControlNumber = 'ProgramSchema-cccControlNumber',
  description = 'ProgramSchema-description',
  awardType = 'ProgramSchema-awardType',
  transferability = 'ProgramSchema-transferability',
  topCode = 'ProgramSchema-topCode',
  cipCode = 'ProgramSchema-cipCode',
  badgeClassUrl = 'ProgramSchema-badgeClassUrl',
  minUnits = 'ProgramSchema-minUnits',
  maxUnits = 'ProgramSchema-maxUnits',
  additionalRequirements = 'ProgramSchema-additionalRequirements',
  tty = 'ProgramSchema-tty',
  youtubeVideoId = 'ProgramSchema-youtubeVideoId',
  learningOutcomes = 'ProgramSchema-learningOutcomes',
  instructionMethod = 'ProgramSchema-instructionMethod',
  metadata = 'ProgramSchema-metadata',
  all = 'ProgramSchema-all',
  valueClassByField = 'ProgramSchema-valueClassByField',
}

export enum RecordSchema {
}

export enum Publishability {
  INACTIVE = 'INACTIVE',
  ERRORS = 'ERRORS',
  WARNINGS = 'WARNINGS',
  CLEAN = 'CLEAN',
}

export enum AlignmentError {
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  SUGGESTION_NOT_FOUND = 'SUGGESTION_NOT_FOUND',
  ENTITY_INACTIVE = 'ENTITY_INACTIVE',
  PRESENT_SYSTEMS_OVERLAP = 'PRESENT_SYSTEMS_OVERLAP',
  TARGET_ALREADY_EXISTS = 'TARGET_ALREADY_EXISTS',
}

export enum SubjectAndNumberSimilarity {
  DISSIMILAR = 'DISSIMILAR',
  SOMEWHAT_SIMILAR = 'SOMEWHAT_SIMILAR',
  VERY_SIMILAR = 'VERY_SIMILAR',
  IDENTICAL_AS_SIMPILFIED = 'IDENTICAL_AS_SIMPILFIED',
}

export enum AwardTypeSimilarity {
  DISSIMILAR = 'DISSIMILAR',
  SOMEWHAT_SIMILAR = 'SOMEWHAT_SIMILAR',
  VERY_SIMILAR = 'VERY_SIMILAR',
  SAME = 'SAME',
}

export enum AwardType {
  NON_CREDIT = 'NON_CREDIT',
  CERTIFICATE = 'CERTIFICATE',
  PROFICIENCY_AWARD = 'PROFICIENCY_AWARD',
  CERTIFICATE_OF_PROFICIENCY = 'CERTIFICATE_OF_PROFICIENCY',
  CERTIFICATE_OF_ACCOMPLISHMENT = 'CERTIFICATE_OF_ACCOMPLISHMENT',
  CERTIFICATE_OF_SPECIALIZATION = 'CERTIFICATE_OF_SPECIALIZATION',
  CERTIFICATE_OF_COMPLETION = 'CERTIFICATE_OF_COMPLETION',
  CERTIFICATE_OF_COMPETENCY = 'CERTIFICATE_OF_COMPETENCY',
  CERTIFICATE_OF_PERFORMANCE = 'CERTIFICATE_OF_PERFORMANCE',
  CERTIFICATE_OF_ARTS_AND_SCIENCES = 'CERTIFICATE_OF_ARTS_AND_SCIENCES',
  CERTIFICATE_OF_CAREER_PREPARATION = 'CERTIFICATE_OF_CAREER_PREPARATION',
  CAREER_CERTIFICATE = 'CAREER_CERTIFICATE',
  SKILLS_CERTIFICATE = 'SKILLS_CERTIFICATE',
  SKILLS_RECOGNITION = 'SKILLS_RECOGNITION',
  JOB_SKILLS_CERTIFICATE = 'JOB_SKILLS_CERTIFICATE',
  EMPLOYABLE_SKILLS_CERTIFICATE = 'EMPLOYABLE_SKILLS_CERTIFICATE',
  OTHER_CREDIT_AWARD = 'OTHER_CREDIT_AWARD',
  CERTIFICATE_OF_COMPLETION_CREDIT = 'CERTIFICATE_OF_COMPLETION_CREDIT',
  STATE_SHORT_EARLY_CHILDHOOD_EDUCATION_CERTIFICATE = 'STATE_SHORT_EARLY_CHILDHOOD_EDUCATION_CERTIFICATE',
  CERTIFICATE_OF_ACHIEVEMENT = 'CERTIFICATE_OF_ACHIEVEMENT',
  SHORT_TERM_CERTIFICATE = 'SHORT_TERM_CERTIFICATE',
  ASSOCIATE_IN_ARTS = 'ASSOCIATE_IN_ARTS',
  ASSOCIATE_IN_APPLIED_ARTS = 'ASSOCIATE_IN_APPLIED_ARTS',
  ASSOCIATE_IN_FINE_ARTS = 'ASSOCIATE_IN_FINE_ARTS',
  ASSOCIATE_IN_SCIENCE = 'ASSOCIATE_IN_SCIENCE',
  ASSOCIATE_IN_APPLIED_SCIENCE = 'ASSOCIATE_IN_APPLIED_SCIENCE',
  ASSOCIATE_IN_APPLIED_TECHNOLOGY = 'ASSOCIATE_IN_APPLIED_TECHNOLOGY',
  ASSOCIATE_IN_PRENURSING = 'ASSOCIATE_IN_PRENURSING',
  ASSOCIATE_OF_ARTS = 'ASSOCIATE_OF_ARTS',
  ASSOCIATE_OF_SCIENCE = 'ASSOCIATE_OF_SCIENCE',
  ASSOCIATE_IN_APPLIED_SCIENCE_TRANSFER = 'ASSOCIATE_IN_APPLIED_SCIENCE_TRANSFER',
  ASSOCIATE_OF_APPLIED_SCIENCE = 'ASSOCIATE_OF_APPLIED_SCIENCE',
  ASSOCIATE_IN_APPLIED_SCIENCE_FOR_TRANSFER = 'ASSOCIATE_IN_APPLIED_SCIENCE_FOR_TRANSFER',
  ASSOCIATE_IN_ARTS_FOR_TRANSFER = 'ASSOCIATE_IN_ARTS_FOR_TRANSFER',
  ASSOCIATE_OF_ARTS_FOR_TRANSFER = 'ASSOCIATE_OF_ARTS_FOR_TRANSFER',
  ASSOCIATE_IN_ARTS_DEGREE_FOR_UC_TRANSFER = 'ASSOCIATE_IN_ARTS_DEGREE_FOR_UC_TRANSFER',
  ASSOCIATE_IN_SCIENCE_FOR_TRANSFER = 'ASSOCIATE_IN_SCIENCE_FOR_TRANSFER',
  ASSOCIATE_OF_SCIENCE_FOR_TRANSFER = 'ASSOCIATE_OF_SCIENCE_FOR_TRANSFER',
  ASSOCIATE_IN_SCIENCE_DEGREE_FOR_UC_TRANSFER = 'ASSOCIATE_IN_SCIENCE_DEGREE_FOR_UC_TRANSFER',
  UNIVERSITY_OF_CALIFORNIA_TRANSFER_PATHWAY = 'UNIVERSITY_OF_CALIFORNIA_TRANSFER_PATHWAY',
  ASSOCIATE_IN_BIOLOGY_DIRECT_TRANSFER_AGREEMENT = 'ASSOCIATE_IN_BIOLOGY_DIRECT_TRANSFER_AGREEMENT',
  ASSOCIATE_IN_MATH_EDUCATION_DIRECT_TRANSFER_AGREEMENT = 'ASSOCIATE_IN_MATH_EDUCATION_DIRECT_TRANSFER_AGREEMENT',
  ASSOCIATE_IN_BUSINESS_DIRECT_TRANSFER_AGREEMENT = 'ASSOCIATE_IN_BUSINESS_DIRECT_TRANSFER_AGREEMENT',
  ASSOCIATE_IN_MUSIC_DIRECT_TRANSFER_AGREEMENT = 'ASSOCIATE_IN_MUSIC_DIRECT_TRANSFER_AGREEMENT',
  ASSOCIATE_IN_PRE_NURSING_DIRECT_TRANSFER_AGREEMENT = 'ASSOCIATE_IN_PRE_NURSING_DIRECT_TRANSFER_AGREEMENT',
  ASSOCIATE_IN_NURSING_DIRECT_TRANSFER_AGREEMENT = 'ASSOCIATE_IN_NURSING_DIRECT_TRANSFER_AGREEMENT',
  ASSOCIATE_IN_BIOENGINEERING_AND_CHEMICAL_PRE_ENGINEERING_DIRECT_TRANSFER_AGREEMENT = 'ASSOCIATE_IN_BIOENGINEERING_AND_CHEMICAL_PRE_ENGINEERING_DIRECT_TRANSFER_AGREEMENT',
  ASSOCIATE_IN_COMPUTER_AND_ELECTRICAL_ENGINEERING_DIRECT_TRANSFER_AGREEMENT = 'ASSOCIATE_IN_COMPUTER_AND_ELECTRICAL_ENGINEERING_DIRECT_TRANSFER_AGREEMENT',
  BACHELOR_OF_APPLIED_ARTS = 'BACHELOR_OF_APPLIED_ARTS',
  BACHELOR_OF_SCIENCE_IN_NURSING = 'BACHELOR_OF_SCIENCE_IN_NURSING',
  ASSOCIATE_IN_BUSINESS = 'ASSOCIATE_IN_BUSINESS',
  ASSOCIATE_IN_MATH_EDUCATION = 'ASSOCIATE_IN_MATH_EDUCATION',
  ASSOCIATE_IN_MUSIC = 'ASSOCIATE_IN_MUSIC',
  ASSOCIATE_IN_ARTS_AND_SCIENCES = 'ASSOCIATE_IN_ARTS_AND_SCIENCES',
  ASSOCIATE_IN_ARTS_AND_SCIENCES_FOR_TRANSFER = 'ASSOCIATE_IN_ARTS_AND_SCIENCES_FOR_TRANSFER',
  ASSOCIATE_IN_TECHNICAL_ARTS = 'ASSOCIATE_IN_TECHNICAL_ARTS',
  ASSOCIATE_OF_FINE_ARTS = 'ASSOCIATE_OF_FINE_ARTS',
  ASSOCIATE_IN_ARTS_DIRECT_TRANSFER_AGREEMENT = 'ASSOCIATE_IN_ARTS_DIRECT_TRANSFER_AGREEMENT',
  ASSOCIATE_IN_NURSING_DIRECT_TRANSFER_AGREEMENT_MRP = 'ASSOCIATE_IN_NURSING_DIRECT_TRANSFER_AGREEMENT_MRP',
  ASSOCIATE_IN_ARTS_DTA = 'ASSOCIATE_IN_ARTS_DTA',
  ASSOCIATE_IN_BIOLOGY_DTA_MRP = 'ASSOCIATE_IN_BIOLOGY_DTA_MRP',
  ASSOCIATE_IN_BUSINESS_DTA_MRP = 'ASSOCIATE_IN_BUSINESS_DTA_MRP',
  ASSOCIATE_IN_COMPUTER_SCIENCE_DTA_MRP = 'ASSOCIATE_IN_COMPUTER_SCIENCE_DTA_MRP',
  ASSOCIATE_IN_PRE_NURSING_DTA_MRP = 'ASSOCIATE_IN_PRE_NURSING_DTA_MRP',
  ASSOCIATE_OF_SCIENCE_TRANSFER_TRACK_1 = 'ASSOCIATE_OF_SCIENCE_TRANSFER_TRACK_1',
  ASSOCIATE_OF_SCIENCE_TRANSFER_TRACK_2 = 'ASSOCIATE_OF_SCIENCE_TRANSFER_TRACK_2',
  ASSOCIATE_OF_SCIENCE_TRANSFER_TRACK_2_MRP = 'ASSOCIATE_OF_SCIENCE_TRANSFER_TRACK_2_MRP',
  ASSOCIATE_OF_ARTS_DIRECT_TRANSFER_AGREEMENT = 'ASSOCIATE_OF_ARTS_DIRECT_TRANSFER_AGREEMENT',
  ASSOCIATE_IN_BIOLOGY_DIRECT_TRANSFER_AGREEMENT_MRP = 'ASSOCIATE_IN_BIOLOGY_DIRECT_TRANSFER_AGREEMENT_MRP',
  ASSOCIATE_IN_BUSINESS_DIRECT_TRANSFER_AGREEMENT_MRP = 'ASSOCIATE_IN_BUSINESS_DIRECT_TRANSFER_AGREEMENT_MRP',
  ASSOCIATE_IN_MUSIC_DIRECT_TRANSFER_AGREEMENT_MRP = 'ASSOCIATE_IN_MUSIC_DIRECT_TRANSFER_AGREEMENT_MRP',
  ASSOCIATE_OF_APPLIED_SCIENCE_FOR_TRANSFER = 'ASSOCIATE_OF_APPLIED_SCIENCE_FOR_TRANSFER',
  ASSOCIATE_IN_COMPUTER_SCIENCE_DIRECT_TRANSFER_AGREEMENT = 'ASSOCIATE_IN_COMPUTER_SCIENCE_DIRECT_TRANSFER_AGREEMENT',
  ASSOCIATE_IN_PRE_NURSING_DIRECT_TRANSFER_AGREEMENT_MRP = 'ASSOCIATE_IN_PRE_NURSING_DIRECT_TRANSFER_AGREEMENT_MRP',
  BACHELOR_OF_SCIENCE = 'BACHELOR_OF_SCIENCE',
  BACHELOR_OF_ARTS = 'BACHELOR_OF_ARTS',
  BACHELOR_OF_FINE_ARTS = 'BACHELOR_OF_FINE_ARTS',
  BACHELOR_OF_APPLIED_SCIENCE = 'BACHELOR_OF_APPLIED_SCIENCE',
  BACHELOR_OF_APPLIED_BEHAVIORAL_SCIENCE = 'BACHELOR_OF_APPLIED_BEHAVIORAL_SCIENCE',
  BACHELOR_OF_MUSIC = 'BACHELOR_OF_MUSIC',
  DOCTOR_OF_EDUCATION = 'DOCTOR_OF_EDUCATION',
  HIGH_SCHOOL_DIPLOMA = 'HIGH_SCHOOL_DIPLOMA',
  MASTER_OF_ARTS = 'MASTER_OF_ARTS',
  MASTER_OF_BUSINESS_ADMINISTRATION = 'MASTER_OF_BUSINESS_ADMINISTRATION',
  MASTER_OF_PUBLIC_ADMINISTRATION = 'MASTER_OF_PUBLIC_ADMINISTRATION',
  MASTER_OF_SCIENCE = 'MASTER_OF_SCIENCE',
  MASTER_OF_SOCIAL_WORK = 'MASTER_OF_SOCIAL_WORK',
  CERTIFICATE_OF_SKILLS = 'CERTIFICATE_OF_SKILLS',
  OCCUPATIONAL_SKILLS_AWARD = 'OCCUPATIONAL_SKILLS_AWARD',
}

export enum PipelineEntityType {
  PROGRAM = 'PROGRAM',
  COURSE = 'COURSE',
}

export enum CurriculumEntityType {
  PROGRAM = 'PROGRAM',
  COURSE = 'COURSE',
  COURSE_LIST = 'COURSE_LIST',
  GENERAL_EDUCATION_PATTERN = 'GENERAL_EDUCATION_PATTERN',
  BADGE = 'BADGE',
}

export enum BulkAmendType {
  PROGRAM_ACTIVE = 'PROGRAM_ACTIVE',
  PROGRAM_DESCRIPTIONS = 'PROGRAM_DESCRIPTIONS',
  PROGRAM_YOUTUBE_VIDEOS = 'PROGRAM_YOUTUBE_VIDEOS',
  PROGRAM_LEARNING_OUTCOMES = 'PROGRAM_LEARNING_OUTCOMES',
  PROGRAM_BADGE_CLASS = 'PROGRAM_BADGE_CLASS',
  COURSE_ACTIVE = 'COURSE_ACTIVE',
  COURSE_DESCRIPTIONS = 'COURSE_DESCRIPTIONS',
  COURSE_UNITS = 'COURSE_UNITS',
  COURSE_REQUISITES = 'COURSE_REQUISITES',
  COURSE_BADGE_CLASSES = 'COURSE_BADGE_CLASSES',
}

export enum SourceSystem {
  COLLEGE = 'COLLEGE',
  STATE = 'STATE',
  INTERNAL = 'INTERNAL',
}

export enum CourseTransferability {
  UNIVERSITY_OF_CALIFORNIA_SYSTEM = 'UNIVERSITY_OF_CALIFORNIA_SYSTEM',
  CALIFORNIA_STATE_UNIVERSITY_SYSTEM = 'CALIFORNIA_STATE_UNIVERSITY_SYSTEM',
  PRIVATE_UNIVERSITY = 'PRIVATE_UNIVERSITY',
}

export enum InstructionMethod {
  ONLINE = 'ONLINE',
  ON_SITE = 'ON_SITE',
  BOTH = 'BOTH',
}

export enum ProgramClassification {
  TOP = 'TOP',
  CIP = 'CIP',
}

export enum RenameEntityError {
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  INVALID_TARGET = 'INVALID_TARGET',
  TARGET_ALREADY_EXISTS = 'TARGET_ALREADY_EXISTS',
}

export enum DuplicateResolutionStrategy {
  HIGHEST_CCC_CONTROL_NUMBER = 'HIGHEST_CCC_CONTROL_NUMBER',
}


// Added by 'CreateInterfaceExtension' extension

export function newCourseSimilarity(value: Pick<CourseSimilarity, 'ctrlNumberMatches' | 'matchQuality' | 'subjectAndNumberSimilarity' | 'titleSimilarity'>): CourseSimilarity {
  return { '@type': 'CourseSimilarity', ... value }
}

export function newCourseSummaryForAlignment(value: Pick<CourseSummaryForAlignment, 'active' | 'cccControlNumber' | 'description' | 'subjectAndNumber' | 'title'>): CourseSummaryForAlignment {
  return { '@type': 'CourseSummaryForAlignment', ... value }
}

export function newProgramSimilarity(value: Pick<ProgramSimilarity, 'awardTypeSimilarity' | 'ctrlNumberMatches' | 'matchQuality' | 'titleSimilarity'>): ProgramSimilarity {
  return { '@type': 'ProgramSimilarity', ... value }
}

export function newProgramSummaryForAlignment(value: Pick<ProgramSummaryForAlignment, 'active' | 'awardType' | 'cccControlNumber' | 'description' | 'title'>): ProgramSummaryForAlignment {
  return { '@type': 'ProgramSummaryForAlignment', ... value }
}

export function newBadgeRowWithNumber(value: Pick<BadgeRowWithNumber, 'duplicateGroupId' | 'importNotices' | 'row' | 'rowNumber'>): BadgeRowWithNumber {
  return { '@type': 'BadgeRowWithNumber', ... value }
}

export function newCourseActiveAmendRow(value: Pick<CourseActiveAmendRow, 'active' | 'cccControlNumber' | 'subjectAndNumber' | 'title'>): CourseActiveAmendRow {
  return { '@type': 'CourseActiveAmendHandler$CourseActiveAmendRow', ... value }
}

export function newCourseDescriptionAmendRow(value: Pick<CourseDescriptionAmendRow, 'cccControlNumber' | 'description' | 'subjectAndNumber' | 'title'>): CourseDescriptionAmendRow {
  return { '@type': 'CourseDescriptionAmendHandler$CourseDescriptionAmendRow', ... value }
}

export function newCourseRequisitesAmendRow(value: Pick<CourseRequisitesAmendRow, 'cccControlNumber' | 'coreqs' | 'prereqs' | 'subjectAndNumber' | 'title'>): CourseRequisitesAmendRow {
  return { '@type': 'CourseRequisitesAmendHandler$CourseRequisitesAmendRow', ... value }
}

export function newCourseRowWithNumber(value: Pick<CourseRowWithNumber, 'duplicateGroupId' | 'importNotices' | 'row' | 'rowNumber'>): CourseRowWithNumber {
  return { '@type': 'CourseRowWithNumber', ... value }
}

export function newCourseUnitsAmendRow(value: Pick<CourseUnitsAmendRow, 'cccControlNumber' | 'maxUnits' | 'minUnits' | 'subjectAndNumber' | 'title'>): CourseUnitsAmendRow {
  return { '@type': 'CourseUnitsAmendHandler$CourseUnitsAmendRow', ... value }
}

export function newProgramActiveAmendRow(value: Pick<ProgramActiveAmendRow, 'active' | 'awardType' | 'cccControlNumber' | 'title'>): ProgramActiveAmendRow {
  return { '@type': 'ProgramActiveAmendHandler$ProgramActiveAmendRow', ... value }
}

export function newProgramBadgeClassAmendRow(value: Pick<ProgramBadgeClassAmendRow, 'awardType' | 'badgeClassUrl' | 'cccControlNumber' | 'title'>): ProgramBadgeClassAmendRow {
  return { '@type': 'ProgramBadgeClassAmendHandler$ProgramBadgeClassAmendRow', ... value }
}

export function newProgramDescriptionAmendRow(value: Pick<ProgramDescriptionAmendRow, 'awardType' | 'cccControlNumber' | 'description' | 'title'>): ProgramDescriptionAmendRow {
  return { '@type': 'ProgramDescriptionAmendHandler$ProgramDescriptionAmendRow', ... value }
}

export function newProgramOutcomesAmendRow(value: Pick<ProgramOutcomesAmendRow, 'awardType' | 'cccControlNumber' | 'learningOutcomes' | 'title'>): ProgramOutcomesAmendRow {
  return { '@type': 'ProgramLearningOutcomesAmendHandler$ProgramOutcomesAmendRow', ... value }
}

export function newProgramRowWithNumber(value: Pick<ProgramRowWithNumber, 'duplicateGroupId' | 'importNotices' | 'row' | 'rowNumber'>): ProgramRowWithNumber {
  return { '@type': 'ProgramRowWithNumber', ... value }
}

export function newProgramVideoAmendRow(value: Pick<ProgramVideoAmendRow, 'awardType' | 'cccControlNumber' | 'title' | 'youtubeVideoId'>): ProgramVideoAmendRow {
  return { '@type': 'ProgramVideoAmendHandler$ProgramVideoAmendRow', ... value }
}

export function newApiEntityRequest(value: Pick<ApiEntityRequest, 'actions' | 'currentIds' | 'requestedIds'>): ApiEntityRequest {
  return { '@type': 'ApiEntityRequest', ... value }
}

export function newApiEntityResponse(value: Pick<ApiEntityResponse, 'actionResponses' | 'entities' | 'invalidatedIds'>): ApiEntityResponse {
  return { '@type': 'ApiEntityResponse', ... value }
}

export function newAcceptAlignmentSuggestion(value: Pick<AcceptAlignmentSuggestion, 'alignToIdentifiers' | 'collegeSlug' | 'curriculumYear' | 'entityKey' | 'suggestionKey'>): AcceptAlignmentSuggestion {
  return { '@type': 'AcceptAlignmentSuggestion', ... value }
}

export function newAcceptSuggestionResult(): AcceptSuggestionResult {
  return { '@type': 'AcceptSuggestionResult' }
}

export function newAddCorrectionsAction(value: Pick<AddCorrectionsAction, 'corrections' | 'recordKey'>): AddCorrectionsAction {
  return { '@type': 'AddCorrectionsAction', ... value }
}

export function newAddLocalCourseAction(value: Pick<AddLocalCourseAction, 'curriculumEntityCorrections' | 'subjectAndNumber'>): AddLocalCourseAction {
  return { '@type': 'AddLocalCourseAction', ... value }
}

export function newAddLocalProgramAction(value: Pick<AddLocalProgramAction, 'awardType' | 'curriculumEntityCorrections' | 'title'>): AddLocalProgramAction {
  return { '@type': 'AddLocalProgramAction', ... value }
}

export function newAggregateAlignmentCounts(value: Pick<AggregateAlignmentCounts, 'collegeSlug' | 'curriculumYear' | 'entityType'>): AggregateAlignmentCounts {
  return { '@type': 'AggregateAlignmentCounts', ... value }
}

export function newAggregateCleanCounts(value: Pick<AggregateCleanCounts, 'collegeSlug' | 'curriculumYear' | 'customGroups' | 'entityType'>): AggregateCleanCounts {
  return { '@type': 'AggregateCleanCounts', ... value }
}

export function newAggregateNoticeCounts(value: Pick<AggregateNoticeCounts, 'collegeSlug' | 'curriculumYear' | 'customGroups' | 'entityType'>): AggregateNoticeCounts {
  return { '@type': 'AggregateNoticeCounts', ... value }
}

export function newAggregateSourceCounts(value: Pick<AggregateSourceCounts, 'collegeSlug' | 'curriculumYear' | 'entityType'>): AggregateSourceCounts {
  return { '@type': 'AggregateSourceCounts', ... value }
}

export function newArchiveCurriculumYearAction(value: Pick<ArchiveCurriculumYearAction, 'collegeSlug' | 'curriculumYear'>): ArchiveCurriculumYearAction {
  return { '@type': 'ArchiveCurriculumYearAction', ... value }
}

export function newBulkAmendCorrectionsAction(value: Pick<BulkAmendCorrectionsAction, 'amendType' | 'fileContents' | 'importCorrectionsByRow'>): BulkAmendCorrectionsAction {
  return { '@type': 'BulkAmendCorrectionsAction', ... value }
}

export function newBulkAmendTypeApiObject(value: Pick<BulkAmendTypeApiObject, 'bulkAmendType' | 'title'>): BulkAmendTypeApiObject {
  return { '@type': 'BulkAmendTypeApiObject', ... value }
}

export function newCleanCounts(value: Pick<CleanCounts, 'fieldCleanCounts'>): CleanCounts {
  return { '@type': 'CleanCounts', ... value }
}

export function newCollegeNotFound(): CollegeNotFound {
  return { '@type': 'CollegeNotFound' }
}

export function newCorrectMultipleRecords(value: Pick<CorrectMultipleRecords, 'correctionsByRecordKey'>): CorrectMultipleRecords {
  return { '@type': 'CorrectMultipleRecords', ... value }
}

export function newCourseApiObject(value: Pick<CourseApiObject, 'badgeClassHistory' | 'cccControlNumber' | 'corequisites' | 'corequisitesHistory' | 'description' | 'entityType' | 'id' | 'include' | 'instructionMethod' | 'labHours' | 'label' | 'lectureHours' | 'materialsFee' | 'maxUnits' | 'mergeKey' | 'minUnits' | 'notices' | 'persistentId' | 'pickedBadges' | 'prerequisiteText' | 'prerequisites' | 'prerequisitesHistory' | 'sourceRecords' | 'subjectAndNumber' | 'title' | 'transferability'>): CourseApiObject {
  return { '@type': 'CourseApiObject', ... value }
}

export function newCourseForPublishPreview(value: Pick<CourseForPublishPreview, 'label' | 'nonFieldPublishabilityNotices' | 'publishability'>): CourseForPublishPreview {
  return { '@type': 'CourseForPublishPreview', ... value }
}

export function newCourseForSearchResult(value: Pick<CourseForSearchResult, 'active' | 'clean' | 'controlNumber' | 'corequisites' | 'description' | 'hasErrors' | 'hasWarnings' | 'id' | 'isClean' | 'labHours' | 'lectureHours' | 'materialsFee' | 'maxUnits' | 'minUnits' | 'notices' | 'pickedBadges' | 'prerequisites' | 'subjectAndNumber' | 'title'>): CourseForSearchResult {
  return { '@type': 'CourseForSearchResult', ... value }
}

export function newCourseListAddRequest(value: Pick<CourseListAddRequest, 'collegeSlug' | 'curriculumYear' | 'longDescription' | 'pickedSlugs' | 'shortDescription' | 'title'>): CourseListAddRequest {
  return { '@type': 'CourseListAddRequest', ... value }
}

export function newCourseListApiObject(value: Pick<CourseListApiObject, 'id' | 'isActive' | 'lockVersion' | 'longDescription' | 'notices' | 'pickedCourses' | 'shortDescription' | 'title'>): CourseListApiObject {
  return { '@type': 'CourseListApiObject', ... value }
}

export function newCourseListByIdAction(value: Pick<CourseListByIdAction, 'collegeSlug' | 'curriculumYear' | 'id'>): CourseListByIdAction {
  return { '@type': 'CourseListByIdAction', ... value }
}

export function newCourseListForPublishPreview(value: Pick<CourseListForPublishPreview, 'label' | 'nonFieldPublishabilityNotices' | 'publishability'>): CourseListForPublishPreview {
  return { '@type': 'CourseListForPublishPreview', ... value }
}

export function newCourseListId(value: Pick<CourseListId, 'uuid'>): CourseListId {
  return { '@type': 'CourseListId', ... value }
}

export function newCourseSourceRecordSummary(value: Pick<CourseSourceRecordSummary, 'active' | 'contributing' | 'controlNumber' | 'id' | 'selected' | 'source' | 'sourceRecordKey' | 'subjectAndNumber'>): CourseSourceRecordSummary {
  return { '@type': 'CourseSourceRecordSummary', ... value }
}

export function newCreateCurriculumYearAction(value: Pick<CreateCurriculumYearAction, 'collegeSlug' | 'year' | 'yearToCopyFrom'>): CreateCurriculumYearAction {
  return { '@type': 'CreateCurriculumYearAction', ... value }
}

export function newCreateHighSchoolAction(value: Pick<CreateHighSchoolAction, 'collegeSlug' | 'curriculumYear' | 'highSchool'>): CreateHighSchoolAction {
  return { '@type': 'CreateHighSchoolAction', ... value }
}

export function newCreateHighSchoolResponse(value: Pick<CreateHighSchoolResponse, 'highSchoolId'>): CreateHighSchoolResponse {
  return { '@type': 'CreateHighSchoolResponse', ... value }
}

export function newCurriculumEntityDetailAction(value: Pick<CurriculumEntityDetailAction, 'collegeSlug' | 'curriculumYear' | 'entityId'>): CurriculumEntityDetailAction {
  return { '@type': 'CurriculumEntityDetailAction', ... value }
}

export function newCurriculumEntityDetailMissing(): CurriculumEntityDetailMissing {
  return { '@type': 'CurriculumEntityDetailMissing' }
}

export function newCurriculumEntityId(value: Pick<CurriculumEntityId, 'id'>): CurriculumEntityId {
  return { '@type': 'CurriculumEntityId', ... value }
}

export function newCurriculumEntitySummary(value: Pick<CurriculumEntitySummary, 'id' | 'label' | 'mergeKey' | 'notices' | 'persistentId' | 'sourceSystems'>): CurriculumEntitySummary {
  return { '@type': 'CurriculumEntitySummary', ... value }
}

export function newCurriculumRevisionApiObject(value: Pick<CurriculumRevisionApiObject, 'notes' | 'publishedDate' | 'revision'>): CurriculumRevisionApiObject {
  return { '@type': 'CurriculumRevisionApiObject', ... value }
}

export function newCurriculumYearCreationError(): CurriculumYearCreationError {
  return { '@type': 'CurriculumYearCreationError' }
}

export function newCurriculumYearCreationSuccess(value: Pick<CurriculumYearCreationSuccess, 'curriculumYearId'>): CurriculumYearCreationSuccess {
  return { '@type': 'CurriculumYearCreationSuccess', ... value }
}

export function newCurriculumYearHistoryResponse(value: Pick<CurriculumYearHistoryResponse, 'curriculumRevisions'>): CurriculumYearHistoryResponse {
  return { '@type': 'CurriculumYearHistoryResponse', ... value }
}

export function newCurriculumYearNotFoundError(): CurriculumYearNotFoundError {
  return { '@type': 'CurriculumYearNotFoundError' }
}

export function newCurriculumYearsForCollegeResponse(value: Pick<CurriculumYearsForCollegeResponse, 'years'>): CurriculumYearsForCollegeResponse {
  return { '@type': 'CurriculumYearsForCollegeResponse', ... value }
}

export function newDeactivateSourceSystemAction(value: Pick<DeactivateSourceSystemAction, 'sourceSystem'>): DeactivateSourceSystemAction {
  return { '@type': 'DeactivateSourceSystemAction', ... value }
}

export function newDeleteCourseListAction(value: Pick<DeleteCourseListAction, 'collegeSlug' | 'courseListUuid' | 'curriculumYear'>): DeleteCourseListAction {
  return { '@type': 'DeleteCourseListAction', ... value }
}

export function newDummyApiEntityId(): DummyApiEntityId {
  return { '@type': 'DummyApiEntityId' }
}

export function newDummyEntityAliasApiEntityId(): DummyEntityAliasApiEntityId {
  return { '@type': 'DummyEntityAliasApiEntityId' }
}

export function newDummyEntitySetApiEntityId(): DummyEntitySetApiEntityId {
  return { '@type': 'DummyEntitySetApiEntityId' }
}

export function newDuplicateImportedCoursesResponse(value: Pick<DuplicateImportedCoursesResponse, 'unresolvedDuplicatesBySubjectAndNumber'>): DuplicateImportedCoursesResponse {
  return { '@type': 'DuplicateImportedCoursesResponse', ... value }
}

export function newEditCurriculumNotesAction(value: Pick<EditCurriculumNotesAction, 'collegeSlug' | 'curriculumYear' | 'notes'>): EditCurriculumNotesAction {
  return { '@type': 'EditCurriculumNotesAction', ... value }
}

export function newEditHighSchoolAction(value: Pick<EditHighSchoolAction, 'collegeSlug' | 'curriculumYear' | 'highSchool'>): EditHighSchoolAction {
  return { '@type': 'EditHighSchoolAction', ... value }
}

export function newEditHighSchoolResponse(value: Pick<EditHighSchoolResponse, 'highSchoolId'>): EditHighSchoolResponse {
  return { '@type': 'EditHighSchoolResponse', ... value }
}

export function newEntityIsAlignedError(): EntityIsAlignedError {
  return { '@type': 'EntityIsAlignedError' }
}

export function newEntityIsMissingCriticalDataError(): EntityIsMissingCriticalDataError {
  return { '@type': 'EntityIsMissingCriticalDataError' }
}

export function newFetchAndImportSourceFileAction(value: Pick<FetchAndImportSourceFileAction, 'sourceSystem'>): FetchAndImportSourceFileAction {
  return { '@type': 'FetchAndImportSourceFileAction', ... value }
}

export function newFindCipCodesAction(value: Pick<FindCipCodesAction, 'collegeSlug' | 'curriculumYear' | 'itemsPerPage' | 'page' | 'searchTerm'>): FindCipCodesAction {
  return { '@type': 'FindCipCodesAction', ... value }
}

export function newFindCipCodesResponse(value: Pick<FindCipCodesResponse, 'paginatedResults' | 'totalResultCount'>): FindCipCodesResponse {
  return { '@type': 'FindCipCodesResponse', ... value }
}

export function newFindCollegeBySlugAction(value: Pick<FindCollegeBySlugAction, 'collegeSlug'>): FindCollegeBySlugAction {
  return { '@type': 'FindCollegeBySlugAction', ... value }
}

export function newFindCourseListsAction(value: Pick<FindCourseListsAction, 'collegeSlug' | 'criteria' | 'curriculumYear' | 'itemsPerPage' | 'page'>): FindCourseListsAction {
  return { '@type': 'FindCourseListsAction', ... value }
}

export function newFindCoursesAction(value: Pick<FindCoursesAction, 'collegeSlug' | 'criteria' | 'curriculumYear' | 'itemsPerPage' | 'page'>): FindCoursesAction {
  return { '@type': 'FindCoursesAction', ... value }
}

export function newFindCurriculumYearAction(value: Pick<FindCurriculumYearAction, 'collegeSlug' | 'curriculumYear'>): FindCurriculumYearAction {
  return { '@type': 'FindCurriculumYearAction', ... value }
}

export function newFindCurriculumYearsForCollegeAction(value: Pick<FindCurriculumYearsForCollegeAction, 'collegeSlug'>): FindCurriculumYearsForCollegeAction {
  return { '@type': 'FindCurriculumYearsForCollegeAction', ... value }
}

export function newFindGenEdPatternsAction(value: Pick<FindGenEdPatternsAction, 'collegeSlug' | 'curriculumYear'>): FindGenEdPatternsAction {
  return { '@type': 'FindGenEdPatternsAction', ... value }
}

export function newFindGenEdPatternsResponse(value: Pick<FindGenEdPatternsResponse, 'genEdPatternSummaries'>): FindGenEdPatternsResponse {
  return { '@type': 'FindGenEdPatternsResponse', ... value }
}

export function newFindImportedBadgesAction(value: Pick<FindImportedBadgesAction, 'collegeSlug' | 'curriculumYear' | 'itemsPerPage' | 'page' | 'searchTerm'>): FindImportedBadgesAction {
  return { '@type': 'FindImportedBadgesAction', ... value }
}

export function newFindImportedBadgesResponse(value: Pick<FindImportedBadgesResponse, 'paginatedResults' | 'totalResultCount'>): FindImportedBadgesResponse {
  return { '@type': 'FindImportedBadgesResponse', ... value }
}

export function newFindPickableCollegesAction(): FindPickableCollegesAction {
  return { '@type': 'FindPickableCollegesAction' }
}

export function newFindPickableCollegesResponse(value: Pick<FindPickableCollegesResponse, 'colleges'>): FindPickableCollegesResponse {
  return { '@type': 'FindPickableCollegesResponse', ... value }
}

export function newFindPickableCoursesAction(value: Pick<FindPickableCoursesAction, 'collegeSlug' | 'curriculumYear' | 'itemsPerPage' | 'page' | 'searchTerm' | 'showInactive' | 'showInvalid'>): FindPickableCoursesAction {
  return { '@type': 'FindPickableCoursesAction', ... value }
}

export function newFindPickableCoursesResponse(value: Pick<FindPickableCoursesResponse, 'paginatedResults' | 'totalResultCount'>): FindPickableCoursesResponse {
  return { '@type': 'FindPickableCoursesResponse', ... value }
}

export function newFindProgramsAction(value: Pick<FindProgramsAction, 'collegeSlug' | 'criteria' | 'curriculumYear' | 'itemsPerPage' | 'page'>): FindProgramsAction {
  return { '@type': 'FindProgramsAction', ... value }
}

export function newFindTopCodesAction(value: Pick<FindTopCodesAction, 'collegeSlug' | 'curriculumYear' | 'itemsPerPage' | 'page' | 'searchTerm'>): FindTopCodesAction {
  return { '@type': 'FindTopCodesAction', ... value }
}

export function newFindTopCodesResponse(value: Pick<FindTopCodesResponse, 'paginatedResults' | 'totalResultCount'>): FindTopCodesResponse {
  return { '@type': 'FindTopCodesResponse', ... value }
}

export function newGenEdPatternApiObject(value: Pick<GenEdPatternApiObject, 'active' | 'deprecated' | 'description' | 'id' | 'nodes' | 'notices' | 'partOfCurriculum' | 'title'>): GenEdPatternApiObject {
  return { '@type': 'GenEdPatternApiObject', ... value }
}

export function newGenEdPatternArea(value: Pick<GenEdPatternArea, 'area' | 'id' | 'longDescription' | 'pickedCourses' | 'shortDescription' | 'subAreas' | 'title'>): GenEdPatternArea {
  return { '@type': 'GenEdPatternArea', ... value }
}

export function newGenEdPatternForPublishPreview(value: Pick<GenEdPatternForPublishPreview, 'label' | 'nonFieldPublishabilityNotices' | 'publishability'>): GenEdPatternForPublishPreview {
  return { '@type': 'GenEdPatternForPublishPreview', ... value }
}

export function newGenEdPatternSubArea(value: Pick<GenEdPatternSubArea, 'area' | 'id' | 'longDescription' | 'pickedCourses' | 'shortDescription' | 'title'>): GenEdPatternSubArea {
  return { '@type': 'GenEdPatternSubArea', ... value }
}

export function newGenerateCollegeReportAction(value: Pick<GenerateCollegeReportAction, 'collegeSlug' | 'curriculumYear'>): GenerateCollegeReportAction {
  return { '@type': 'GenerateCollegeReportAction', ... value }
}

export function newGetCoursesByHighSchoolAction(value: Pick<GetCoursesByHighSchoolAction, 'collegeSlug' | 'curriculumYear' | 'highSchoolId'>): GetCoursesByHighSchoolAction {
  return { '@type': 'GetCoursesByHighSchoolAction', ... value }
}

export function newGetCoursesByHighSchoolResponse(value: Pick<GetCoursesByHighSchoolResponse, 'courses'>): GetCoursesByHighSchoolResponse {
  return { '@type': 'GetCoursesByHighSchoolResponse', ... value }
}

export function newGetCurriculumYearHistoryAction(value: Pick<GetCurriculumYearHistoryAction, 'collegeSlug' | 'curriculumYear'>): GetCurriculumYearHistoryAction {
  return { '@type': 'GetCurriculumYearHistoryAction', ... value }
}

export function newGetDuplicateImportedCoursesAction(value: Pick<GetDuplicateImportedCoursesAction, 'collegeSlug' | 'curriculumYear' | 'sourceSystem'>): GetDuplicateImportedCoursesAction {
  return { '@type': 'GetDuplicateImportedCoursesAction', ... value }
}

export function newGetGenEdPatternAction(value: Pick<GetGenEdPatternAction, 'collegeSlug' | 'curriculumYear' | 'genEdId'>): GetGenEdPatternAction {
  return { '@type': 'GetGenEdPatternAction', ... value }
}

export function newGetImportedCoursesAction(value: Pick<GetImportedCoursesAction, 'collegeSlug' | 'curriculumYear' | 'sourceSystem'>): GetImportedCoursesAction {
  return { '@type': 'GetImportedCoursesAction', ... value }
}

export function newGetImportedProgramsAction(value: Pick<GetImportedProgramsAction, 'collegeSlug' | 'curriculumYear' | 'sourceSystem'>): GetImportedProgramsAction {
  return { '@type': 'GetImportedProgramsAction', ... value }
}

export function newGetImportedProgramsMissingTitleAndAwardAction(value: Pick<GetImportedProgramsMissingTitleAndAwardAction, 'collegeSlug' | 'curriculumYear' | 'sourceSystem'>): GetImportedProgramsMissingTitleAndAwardAction {
  return { '@type': 'GetImportedProgramsMissingTitleAndAwardAction', ... value }
}

export function newHighSchoolCoursesApiObject(value: Pick<HighSchoolCoursesApiObject, 'courses'>): HighSchoolCoursesApiObject {
  return { '@type': 'HighSchoolCoursesApiObject', ... value }
}

export function newImportBadgeFileAction(value: Pick<ImportBadgeFileAction, 'fileContents'>): ImportBadgeFileAction {
  return { '@type': 'ImportBadgeFileAction', ... value }
}

export function newImportCorrections(value: Pick<ImportCorrections, 'exclude' | 'fieldCorrections' | 'row'>): ImportCorrections {
  return { '@type': 'ImportCorrections', ... value }
}

export function newImportSourceFileAction(value: Pick<ImportSourceFileAction, 'fileContents' | 'sourceSystem'>): ImportSourceFileAction {
  return { '@type': 'ImportSourceFileAction', ... value }
}

export function newImportedCoursesResponse(value: Pick<ImportedCoursesResponse, 'importedCourses'>): ImportedCoursesResponse {
  return { '@type': 'ImportedCoursesResponse', ... value }
}

export function newImportedProgramsMissingTitleAndAwardResponse(value: Pick<ImportedProgramsMissingTitleAndAwardResponse, 'missingTitleAndAward'>): ImportedProgramsMissingTitleAndAwardResponse {
  return { '@type': 'ImportedProgramsMissingTitleAndAwardResponse', ... value }
}

export function newImportedProgramsResponse(value: Pick<ImportedProgramsResponse, 'importedPrograms'>): ImportedProgramsResponse {
  return { '@type': 'ImportedProgramsResponse', ... value }
}

export function newInvalidateAllAction(): InvalidateAllAction {
  return { '@type': 'InvalidateAllAction' }
}

export function newListCoursesWithAlignmentSuggestions(value: Pick<ListCoursesWithAlignmentSuggestions, 'collegeSlug' | 'curriculumYear' | 'itemsPerPage' | 'page' | 'presentSystem' | 'searchTerm'>): ListCoursesWithAlignmentSuggestions {
  return { '@type': 'ListCoursesWithAlignmentSuggestions', ... value }
}

export function newListProgramsWithAlignmentSuggestions(value: Pick<ListProgramsWithAlignmentSuggestions, 'collegeSlug' | 'curriculumYear' | 'itemsPerPage' | 'page' | 'presentSystem' | 'searchTerm'>): ListProgramsWithAlignmentSuggestions {
  return { '@type': 'ListProgramsWithAlignmentSuggestions', ... value }
}

export function newMarkPublishedAction(value: Pick<MarkPublishedAction, 'collegeSlug' | 'curriculumYear'>): MarkPublishedAction {
  return { '@type': 'MarkPublishedAction', ... value }
}

export function newNoSuchEntityAlignmentError(): NoSuchEntityAlignmentError {
  return { '@type': 'NoSuchEntityAlignmentError' }
}

export function newNotFound(): NotFound {
  return { '@type': 'NotFound' }
}

export function newNoticeCountSummary(value: Pick<NoticeCountSummary, 'fieldNoticeCounts' | 'nonFieldNoticeCounts'>): NoticeCountSummary {
  return { '@type': 'NoticeCountSummary', ... value }
}

export function newPaginatedCourseListSearchResults(value: Pick<PaginatedCourseListSearchResults, 'paginatedResults' | 'totalResultCount'>): PaginatedCourseListSearchResults {
  return { '@type': 'PaginatedCourseListSearchResults', ... value }
}

export function newPaginatedFilteredCourseSearchResults(value: Pick<PaginatedFilteredCourseSearchResults, 'courses' | 'totalSearchResultCount' | 'unfilteredNoticeCounts'>): PaginatedFilteredCourseSearchResults {
  return { '@type': 'PaginatedFilteredCourseSearchResults', ... value }
}

export function newPaginatedFilteredProgramSearchResults(value: Pick<PaginatedFilteredProgramSearchResults, 'programs' | 'totalSearchResultCount' | 'unfilteredNoticeCounts'>): PaginatedFilteredProgramSearchResults {
  return { '@type': 'PaginatedFilteredProgramSearchResults', ... value }
}

export function newPickableCourse(value: Pick<PickableCourse, 'active' | 'label' | 'publishErrors' | 'slug' | 'title'>): PickableCourse {
  return { '@type': 'PickableCourse', ... value }
}

export function newPickableProgram(value: Pick<PickableProgram, 'active' | 'awardType' | 'label' | 'publishErrors' | 'slug' | 'title'>): PickableProgram {
  return { '@type': 'PickableProgram', ... value }
}

export function newPickedCipCode(value: Pick<PickedCipCode, 'cipCode' | 'cipCodeTitle' | 'missing' | 'standardOccupations'>): PickedCipCode {
  return { '@type': 'PickedCipCode', ... value }
}

export function newPickedCourse(value: Pick<PickedCourse, 'inActive' | 'label' | 'missing' | 'publishErrors' | 'slug' | 'title'>): PickedCourse {
  return { '@type': 'PickedCourse', ... value }
}

export function newPickedTopCode(value: Pick<PickedTopCode, 'missing' | 'standardOccupations' | 'topCode' | 'topCodeTitle'>): PickedTopCode {
  return { '@type': 'PickedTopCode', ... value }
}

export function newProgramApiObject(value: Pick<ProgramApiObject, 'additionalRequirements' | 'awardType' | 'badge' | 'badgeHistory' | 'cccControlNumber' | 'cipCode' | 'cipCodeHistory' | 'description' | 'entityType' | 'id' | 'include' | 'instructionMethod' | 'label' | 'learningOutcomes' | 'maxUnits' | 'mergeKey' | 'minUnits' | 'notices' | 'persistentId' | 'sourceRecords' | 'title' | 'topCode' | 'topCodeHistory' | 'transferability' | 'tty' | 'youtubeVideoId'>): ProgramApiObject {
  return { '@type': 'ProgramApiObject', ... value }
}

export function newProgramForPublishPreview(value: Pick<ProgramForPublishPreview, 'label' | 'nonFieldPublishabilityNotices' | 'publishability'>): ProgramForPublishPreview {
  return { '@type': 'ProgramForPublishPreview', ... value }
}

export function newProgramForSearchResult(value: Pick<ProgramForSearchResult, 'active' | 'awardType' | 'cipCode' | 'clean' | 'controlNumber' | 'description' | 'hasErrors' | 'hasWarnings' | 'id' | 'isClean' | 'learningOutcomes' | 'maxUnits' | 'minUnits' | 'notices' | 'pickedBadge' | 'title' | 'topCode' | 'youtubeVideoId'>): ProgramForSearchResult {
  return { '@type': 'ProgramForSearchResult', ... value }
}

export function newProgramSourceRecordSummary(value: Pick<ProgramSourceRecordSummary, 'active' | 'awardType' | 'contributing' | 'controlNumber' | 'id' | 'selected' | 'source' | 'sourceRecordKey' | 'title'>): ProgramSourceRecordSummary {
  return { '@type': 'ProgramSourceRecordSummary', ... value }
}

export function newPublishCurriculumAction(value: Pick<PublishCurriculumAction, 'collegeSlug' | 'curriculumYear'>): PublishCurriculumAction {
  return { '@type': 'PublishCurriculumAction', ... value }
}

export function newPublishPreview(value: Pick<PublishPreview, 'cleanCourseLists' | 'cleanCourses' | 'cleanGenEdPattern' | 'cleanPrograms' | 'errorCourseLists' | 'errorCourses' | 'errorGenEdPattern' | 'errorPrograms' | 'highSchools' | 'inactiveCourseLists' | 'inactiveCourses' | 'inactiveGenEdPattern' | 'inactivePrograms' | 'warningCourseLists' | 'warningCourses' | 'warningGenEdPattern' | 'warningPrograms'>): PublishPreview {
  return { '@type': 'PublishPreview', ... value }
}

export function newPublishPreviewAction(value: Pick<PublishPreviewAction, 'collegeSlug' | 'curriculumYear'>): PublishPreviewAction {
  return { '@type': 'PublishPreviewAction', ... value }
}

export function newRecordMutationAction(value: Pick<RecordMutationAction, 'action' | 'collegeSlug' | 'curriculumYear' | 'pipelineEntityType'>): RecordMutationAction {
  return { '@type': 'RecordMutationAction', ... value }
}

export function newRejectSuggestions(value: Pick<RejectSuggestions, 'collegeSlug' | 'curriculumYear' | 'rejectedPairs'>): RejectSuggestions {
  return { '@type': 'RejectSuggestions', ... value }
}

export function newRemapPersistentIdAction(value: Pick<RemapPersistentIdAction, 'mergeKey' | 'persistentId'>): RemapPersistentIdAction {
  return { '@type': 'RemapPersistentIdAction', ... value }
}

export function newRenameEntityAction(value: Pick<RenameEntityAction, 'recordKey' | 'target'>): RenameEntityAction {
  return { '@type': 'RenameEntityAction', ... value }
}

export function newRenameEntityErrors(value: Pick<RenameEntityErrors, 'errorsByRecordKey'>): RenameEntityErrors {
  return { '@type': 'RenameEntityErrors', ... value }
}

export function newRenameMultipleRecords(value: Pick<RenameMultipleRecords, 'targetsByRecordKey'>): RenameMultipleRecords {
  return { '@type': 'RenameMultipleRecords', ... value }
}

export function newSearchCourseAlignmentCandidates(value: Pick<SearchCourseAlignmentCandidates, 'collegeSlug' | 'curriculumYear' | 'missingSystems' | 'presentSystems' | 'searchTerm' | 'similarityBasis'>): SearchCourseAlignmentCandidates {
  return { '@type': 'SearchCourseAlignmentCandidates', ... value }
}

export function newSearchHighSchoolsByCollegeAction(value: Pick<SearchHighSchoolsByCollegeAction, 'collegeId' | 'collegeSlug' | 'curriculumYear'>): SearchHighSchoolsByCollegeAction {
  return { '@type': 'SearchHighSchoolsByCollegeAction', ... value }
}

export function newSearchHighSchoolsResponse(value: Pick<SearchHighSchoolsResponse, 'highSchools'>): SearchHighSchoolsResponse {
  return { '@type': 'SearchHighSchoolsResponse', ... value }
}

export function newSearchProgramAlignmentCandidates(value: Pick<SearchProgramAlignmentCandidates, 'collegeSlug' | 'curriculumYear' | 'missingSystems' | 'presentSystems' | 'searchTerm' | 'similarityBasis'>): SearchProgramAlignmentCandidates {
  return { '@type': 'SearchProgramAlignmentCandidates', ... value }
}

export function newSourceCountSummaries(value: Pick<SourceCountSummaries, 'summaries'>): SourceCountSummaries {
  return { '@type': 'SourceCountSummaries', ... value }
}

export function newSourceRecordDetailAction(value: Pick<SourceRecordDetailAction, 'collegeSlug' | 'curriculumEntityId' | 'curriculumYear' | 'id'>): SourceRecordDetailAction {
  return { '@type': 'SourceRecordDetailAction', ... value }
}

export function newUpdateCourseListAction(value: Pick<UpdateCourseListAction, 'collegeSlug' | 'curriculumYear' | 'id' | 'isActive' | 'lockVersion' | 'longDescription' | 'pickedCourseSlugs' | 'shortDescription' | 'title'>): UpdateCourseListAction {
  return { '@type': 'UpdateCourseListAction', ... value }
}

export function newUpdateGenEdAction(value: Pick<UpdateGenEdAction, 'collegeSlug' | 'courseSlugsByNode' | 'curriculumYear' | 'genEdPatternId'>): UpdateGenEdAction {
  return { '@type': 'UpdateGenEdAction', ... value }
}

export function newCollegeReportCourseSummary(value: Pick<CollegeReportCourseSummary, 'courseTitle' | 'fields' | 'notices' | 'subjectAndNumber'>): CollegeReportCourseSummary {
  return { '@type': 'CollegeReportCourseSummary', ... value }
}

export function newCollegeReportProgramSummary(value: Pick<CollegeReportProgramSummary, 'fields' | 'notices' | 'programAwardType' | 'programTitle'>): CollegeReportProgramSummary {
  return { '@type': 'CollegeReportProgramSummary', ... value }
}

export function newCourseListAdded(value: Pick<CourseListAdded, 'courseListId'>): CourseListAdded {
  return { '@type': 'AddCourseListApiResponse$CourseListAdded', ... value }
}

export function newYearAdded(value: Pick<YearAdded, 'curriculumUuid'>): YearAdded {
  return { '@type': 'AddCurriculumYearApiResponse$YearAdded', ... value }
}

export function newYearAlreadyExists(): YearAlreadyExists {
  return { '@type': 'AddCurriculumYearApiResponse$YearAlreadyExists' }
}

export function newBulkAmendErrors(value: Pick<BulkAmendErrors, 'duplicateRowNumbersByMergeKey' | 'errors' | 'missingFields' | 'pickableEntities' | 'unrecognizedFormat'>): BulkAmendErrors {
  return { '@type': 'BulkAmendErrors', ... value }
}

export function newBulkAmendResult(value: Pick<BulkAmendResult, 'notices'>): BulkAmendResult {
  return { '@type': 'BulkAmendResult', ... value }
}

export function newCollegeReport(value: Pick<CollegeReport, 'courseSummaries' | 'programSummaries'>): CollegeReport {
  return { '@type': 'CollegeReport', ... value }
}

export function newDuplicateRow(value: Pick<DuplicateRow, 'duplicateRowNumbers'>): DuplicateRow {
  return { '@type': 'DuplicateRow', ... value }
}

export function newInvalidCollege(value: Pick<InvalidCollege, 'message'>): InvalidCollege {
  return { '@type': 'InvalidCollege', ... value }
}

export function newMergeKeyNotFound(): MergeKeyNotFound {
  return { '@type': 'MergeKeyNotFound' }
}

export function newMergeSummary(value: Pick<MergeSummary, 'create' | 'isPreview' | 'update'>): MergeSummary {
  return { '@type': 'MergeSummary', ... value }
}

export function newNothing(): Nothing {
  return { '@type': 'Nothing' }
}

export function newPublishConflict(): PublishConflict {
  return { '@type': 'PublishCurriculumApiResponse$PublishConflict' }
}

export function newRemoteServerPublishError(value: Pick<RemoteServerPublishError, 'correlationId'>): RemoteServerPublishError {
  return { '@type': 'PublishCurriculumApiResponse$RemoteServerPublishError', ... value }
}

export function newSuccessfulPublish(): SuccessfulPublish {
  return { '@type': 'PublishCurriculumApiResponse$SuccessfulPublish' }
}

export function newEntitySaved(value: Pick<EntitySaved, 'entityId'>): EntitySaved {
  return { '@type': 'SaveEntityApiResponse$EntitySaved', ... value }
}

export function newSlugConflict(): SlugConflict {
  return { '@type': 'SaveEntityApiResponse$SlugConflict' }
}

export function newValueNotImportable(value: Pick<ValueNotImportable, 'field' | 'message'>): ValueNotImportable {
  return { '@type': 'ValueNotImportable', ... value }
}

export function newCurriculumYearMissing(): CurriculumYearMissing {
  return { '@type': 'CurriculumYearMissing' }
}

export function newAuthenticatedUser(value: Pick<AuthenticatedUser, 'email' | 'firstName' | 'lastName'>): AuthenticatedUser {
  return { '@type': 'AuthenticatedUser', ... value }
}

export function newForgotPasswordRequest(value: Pick<ForgotPasswordRequest, 'email'>): ForgotPasswordRequest {
  return { '@type': 'ForgotPasswordRequest', ... value }
}

export function newResetPasswordRequest(value: Pick<ResetPasswordRequest, 'password' | 'resetToken'>): ResetPasswordRequest {
  return { '@type': 'ResetPasswordRequest', ... value }
}

export function newUserTokenCreateRequest(value: Pick<UserTokenCreateRequest, 'password' | 'username'>): UserTokenCreateRequest {
  return { '@type': 'UserTokenCreateRequest', ... value }
}

export function newCurriculumEntitySearchCriteria(value: Pick<CurriculumEntitySearchCriteria, 'anyOfNoticeTypes' | 'anyOfPublishabilities' | 'matchingSlugs' | 'noneOfNonFieldNoticeTypes' | 'noneOfPublishabilities' | 'searchTerm' | 'showActive' | 'showInactive' | 'treatInactiveAsActiveForPublishabilityFilter'>): CurriculumEntitySearchCriteria {
  return { '@type': 'CurriculumEntitySearchCriteria', ... value }
}

export function newNoActor(): NoActor {
  return { '@type': 'NoActor' }
}

export function newPreAuthUser(): PreAuthUser {
  return { '@type': 'PreAuthUser' }
}

export function newCourseIdentifyingValues(value: Pick<CourseIdentifyingValues, 'subjectAndNumber'>): CourseIdentifyingValues {
  return { '@type': 'CourseIdentifyingValues', ... value }
}

export function newCourseRecord(value: Pick<CourseRecord, 'badgeClassUrls' | 'cccControlNumber' | 'corequisites' | 'courseId' | 'courseNumber' | 'courseSubject' | 'description' | 'highSchools' | 'include' | 'instructionMethod' | 'labHours' | 'lectureHours' | 'materialsFee' | 'maxUnits' | 'minUnits' | 'prerequisiteText' | 'prerequisites' | 'subjectAndNumber' | 'title' | 'topCode' | 'transferability'>): CourseRecord {
  return { '@type': 'CourseRecord', ... value }
}

export function newRichCourseRecord(value: Pick<RichCourseRecord, 'badgeClassUrls' | 'cccControlNumber' | 'corequisites' | 'description' | 'highSchools' | 'include' | 'instructionMethod' | 'labHours' | 'lectureHours' | 'materialsFee' | 'maxUnits' | 'minUnits' | 'prerequisiteText' | 'prerequisites' | 'restrictions' | 'subjectAndNumber' | 'title' | 'topCode' | 'transferability'>): RichCourseRecord {
  return { '@type': 'RichCourseRecord', ... value }
}

export function newBadgeSystemNotReachableError(value: Pick<BadgeSystemNotReachableError, 'urlCalled'>): BadgeSystemNotReachableError {
  return { '@type': 'ParseErrorApiObject$BadgeSystemNotReachableError', ... value }
}

export function newCociNotReachableError(value: Pick<CociNotReachableError, 'urlCalled'>): CociNotReachableError {
  return { '@type': 'ParseErrorApiObject$CociNotReachableError', ... value }
}

export function newNoSourceConfiguredError(): NoSourceConfiguredError {
  return { '@type': 'ParseErrorApiObject$NoSourceConfiguredError' }
}

export function newNotParsableError(): NotParsableError {
  return { '@type': 'ParseErrorApiObject$NotParsableError' }
}

export function newParseValidationError(value: Pick<ParseValidationError, 'minimumRequirementErrors'>): ParseValidationError {
  return { '@type': 'ParseErrorApiObject$ParseValidationError', ... value }
}

export function newSourceNotFetchableError(): SourceNotFetchableError {
  return { '@type': 'ParseErrorApiObject$SourceNotFetchableError' }
}

export function newHighSchool(value: Pick<HighSchool, 'city' | 'collegeId' | 'courses' | 'curriculumIri' | 'date' | 'id' | 'lineOne' | 'lineTwo' | 'state' | 'title' | 'url' | 'zip'>): HighSchool {
  return { '@type': 'HighSchool', ... value }
}

export function newSourceCountSummary(value: Pick<SourceCountSummary, 'distinct' | 'hasUnresolvedDuplicates' | 'missingIdentifyingAttributes' | 'unusable'>): SourceCountSummary {
  return { '@type': 'SourceCountSummary', ... value }
}

export function newStandardOccupation(value: Pick<StandardOccupation, 'socCode' | 'title'>): StandardOccupation {
  return { '@type': 'StandardOccupation', ... value }
}

export function newMasterRecordKey(value: Pick<MasterRecordKey, 'persistentId'>): MasterRecordKey {
  return { '@type': 'MasterRecordKey', ... value }
}

export function newSourceRecordKey(value: Pick<SourceRecordKey, 'sourceRecordId' | 'sourceSystem'>): SourceRecordKey {
  return { '@type': 'SourceRecordKey', ... value }
}

export function newActiveSourceRecordExcluded(value: Pick<ActiveSourceRecordExcluded, 'excludedId' | 'sourceSystem'>): ActiveSourceRecordExcluded {
  return { '@type': 'ActiveSourceRecordExcluded', ... value }
}

export function newCipCodeWithoutSOCs(): CipCodeWithoutSOCs {
  return { '@type': 'CipCodeWithoutSOCs' }
}

export function newCourseDescriptionSameAsSubjectAndNumber(): CourseDescriptionSameAsSubjectAndNumber {
  return { '@type': 'CourseDescriptionSameAsSubjectAndNumber' }
}

export function newCourseTitleSameAsSubjectAndNumber(): CourseTitleSameAsSubjectAndNumber {
  return { '@type': 'CourseTitleSameAsSubjectAndNumber' }
}

export function newCyclicCourseRequisite(value: Pick<CyclicCourseRequisite, 'requisiteCycle'>): CyclicCourseRequisite {
  return { '@type': 'CyclicCourseRequisite', ... value }
}

export function newDeprecatedPattern(): DeprecatedPattern {
  return { '@type': 'DeprecatedPattern' }
}

export function newDescriptionSameAsTitle(): DescriptionSameAsTitle {
  return { '@type': 'DescriptionSameAsTitle' }
}

export function newDuplicatesAutoResolved(value: Pick<DuplicatesAutoResolved, 'selectedId' | 'sourceIds' | 'sourceSystem' | 'strategy'>): DuplicatesAutoResolved {
  return { '@type': 'DuplicatesAutoResolved', ... value }
}

export function newHasNoPublishableCourses(): HasNoPublishableCourses {
  return { '@type': 'HasNoPublishableCourses' }
}

export function newInactiveSourceRecordIncluded(value: Pick<InactiveSourceRecordIncluded, 'includedId' | 'sourceSystem'>): InactiveSourceRecordIncluded {
  return { '@type': 'InactiveSourceRecordIncluded', ... value }
}

export function newInconsistentFields(value: Pick<InconsistentFields, 'fields'>): InconsistentFields {
  return { '@type': 'InconsistentFields', ... value }
}

export function newInvalidOptionalData(value: Pick<InvalidOptionalData, 'message'>): InvalidOptionalData {
  return { '@type': 'InvalidOptionalData', ... value }
}

export function newInvalidOptionalFields(value: Pick<InvalidOptionalFields, 'fields'>): InvalidOptionalFields {
  return { '@type': 'InvalidOptionalFields', ... value }
}

export function newInvalidRequiredData(value: Pick<InvalidRequiredData, 'message'>): InvalidRequiredData {
  return { '@type': 'InvalidRequiredData', ... value }
}

export function newInvalidRequiredFields(value: Pick<InvalidRequiredFields, 'fields'>): InvalidRequiredFields {
  return { '@type': 'InvalidRequiredFields', ... value }
}

export function newManuallyAddedFields(value: Pick<ManuallyAddedFields, 'fields'>): ManuallyAddedFields {
  return { '@type': 'ManuallyAddedFields', ... value }
}

export function newManuallyCorrectedFields(value: Pick<ManuallyCorrectedFields, 'fields'>): ManuallyCorrectedFields {
  return { '@type': 'ManuallyCorrectedFields', ... value }
}

export function newMissingOptionalData(value: Pick<MissingOptionalData, 'message'>): MissingOptionalData {
  return { '@type': 'MissingOptionalData', ... value }
}

export function newMissingOptionalFields(value: Pick<MissingOptionalFields, 'fields'>): MissingOptionalFields {
  return { '@type': 'MissingOptionalFields', ... value }
}

export function newMissingRequiredData(value: Pick<MissingRequiredData, 'message'>): MissingRequiredData {
  return { '@type': 'MissingRequiredData', ... value }
}

export function newMissingRequiredFields(value: Pick<MissingRequiredFields, 'fields'>): MissingRequiredFields {
  return { '@type': 'MissingRequiredFields', ... value }
}

export function newMissingSystems(value: Pick<MissingSystems, 'missingSystems'>): MissingSystems {
  return { '@type': 'MissingSystems', ... value }
}

export function newNonPublishableAwardType(): NonPublishableAwardType {
  return { '@type': 'NonPublishableAwardType' }
}

export function newNonPublishableRequisites(value: Pick<NonPublishableRequisites, 'empty' | 'errors' | 'inactive' | 'nonExistent'>): NonPublishableRequisites {
  return { '@type': 'NonPublishableRequisites', ... value }
}

export function newSomeInactiveCourses(value: Pick<SomeInactiveCourses, 'inactiveCourseSlugs'>): SomeInactiveCourses {
  return { '@type': 'SomeInactiveCourses', ... value }
}

export function newSomeMissingCourses(value: Pick<SomeMissingCourses, 'missingCourseSlugs'>): SomeMissingCourses {
  return { '@type': 'SomeMissingCourses', ... value }
}

export function newSomeNonPublishableCourses(value: Pick<SomeNonPublishableCourses, 'nonPublishableCourseSlugs'>): SomeNonPublishableCourses {
  return { '@type': 'SomeNonPublishableCourses', ... value }
}

export function newSomePublishableCourses(value: Pick<SomePublishableCourses, 'publishableCoursesCount'>): SomePublishableCourses {
  return { '@type': 'SomePublishableCourses', ... value }
}

export function newSourceDuplicates(value: Pick<SourceDuplicates, 'sourceIds' | 'sourceSystem'>): SourceDuplicates {
  return { '@type': 'SourceDuplicates', ... value }
}

export function newStartsWithNumber(): StartsWithNumber {
  return { '@type': 'StartsWithNumber' }
}

export function newSuspiciousDataFields(value: Pick<SuspiciousDataFields, 'fields'>): SuspiciousDataFields {
  return { '@type': 'SuspiciousDataFields', ... value }
}

export function newTopCodeWithoutSOCs(): TopCodeWithoutSOCs {
  return { '@type': 'TopCodeWithoutSOCs' }
}

export function newUnmergeableRecord(value: Pick<UnmergeableRecord, 'sourceIds'>): UnmergeableRecord {
  return { '@type': 'UnmergeableRecord', ... value }
}

export function newUnresolvedDuplicates(value: Pick<UnresolvedDuplicates, 'sourceSystem'>): UnresolvedDuplicates {
  return { '@type': 'UnresolvedDuplicates', ... value }
}

export function newUnusuallyShort(value: Pick<UnusuallyShort, 'message'>): UnusuallyShort {
  return { '@type': 'UnusuallyShort', ... value }
}

export function newProgramIdentifyingValues(value: Pick<ProgramIdentifyingValues, 'awardType' | 'title'>): ProgramIdentifyingValues {
  return { '@type': 'ProgramIdentifyingValues', ... value }
}

export function newProgramRecord(value: Pick<ProgramRecord, 'additionalRequirements' | 'areasOfEmphasis' | 'awardType' | 'badgeClassUrl' | 'cccControlNumber' | 'cipCode' | 'description' | 'include' | 'instructionMethod' | 'learningOutcomes' | 'maxUnits' | 'minUnits' | 'title' | 'topCode' | 'transferability' | 'tty' | 'youtubeVideoId'>): ProgramRecord {
  return { '@type': 'ProgramRecord', ... value }
}

export function newRichProgramRecord(value: Pick<RichProgramRecord, 'additionalRequirements' | 'awardType' | 'badgeClassUrl' | 'cccControlNumber' | 'cipCode' | 'description' | 'include' | 'instructionMethod' | 'learningOutcomes' | 'maxUnits' | 'minUnits' | 'title' | 'topCode' | 'transferability' | 'tty' | 'youtubeVideoId'>): RichProgramRecord {
  return { '@type': 'RichProgramRecord', ... value }
}

export function newAlignmentCountSummary(value: Pick<AlignmentCountSummary, 'alignedCount' | 'unalignedCountByPresentSystem'>): AlignmentCountSummary {
  return { '@type': 'AlignmentCountSummary', ... value }
}

export function newIdentifyingAttributesMissing(): IdentifyingAttributesMissing {
  return { '@type': 'IdentifyingAttributesMissing' }
}

export function newImportRowWithNumber(value: Pick<ImportRowWithNumber, 'duplicateGroupId' | 'importNotices' | 'rowNumber'>): ImportRowWithNumber {
  return { '@type': 'ImportRowWithNumber', ... value }
}

export function newCourseGroup(value: Pick<CourseGroup, 'courseSlugs' | 'longDescription' | 'shortDescription' | 'title'>): CourseGroup {
  return { '@type': 'CourseGroup', ... value }
}

export function newGenEdCurriculumBranch(value: Pick<GenEdCurriculumBranch, 'area' | 'groups' | 'id' | 'longDescription' | 'shortDescription' | 'title'>): GenEdCurriculumBranch {
  return { '@type': 'GenEdCurriculumBranch', ... value }
}

export function newGenEdCurriculumLeaf(value: Pick<GenEdCurriculumLeaf, 'area' | 'id' | 'longDescription' | 'shortDescription' | 'title'>): GenEdCurriculumLeaf {
  return { '@type': 'GenEdCurriculumLeaf', ... value }
}

export function newPaginatedFilteredCipCodeSearchResults(value: Pick<PaginatedFilteredCipCodeSearchResults, 'cipCodes' | 'totalSearchResultCount'>): PaginatedFilteredCipCodeSearchResults {
  return { '@type': 'PaginatedFilteredCipCodeSearchResults', ... value }
}

export function newPaginatedFilteredImportedBadgesSearchResults(value: Pick<PaginatedFilteredImportedBadgesSearchResults, 'importedBadges' | 'totalSearchResultCount'>): PaginatedFilteredImportedBadgesSearchResults {
  return { '@type': 'PaginatedFilteredImportedBadgesSearchResults', ... value }
}

export function newPaginatedFilteredTopCodeSearchResults(value: Pick<PaginatedFilteredTopCodeSearchResults, 'topCodes' | 'totalSearchResultCount'>): PaginatedFilteredTopCodeSearchResults {
  return { '@type': 'PaginatedFilteredTopCodeSearchResults', ... value }
}

export function newCollegeApiEntity(value: Pick<CollegeApiEntity, 'id' | 'name' | 'slug' | 'sourceSystemLabels' | 'sources'>): CollegeApiEntity {
  return { '@type': 'CollegeApiEntity', ... value }
}

export function newCurriculumYearApiObject(value: Pick<CurriculumYearApiObject, 'collegeSlug' | 'currentRevision' | 'currentRevisionNotes' | 'curriculumYear' | 'id' | 'programClassification' | 'publishabilityCounts' | 'systemsImported' | 'templateDownloadUrls'>): CurriculumYearApiObject {
  return { '@type': 'CurriculumYearApiObject', ... value }
}

export function newCOCISource(value: Pick<COCISource, 'alphaId' | 'numericalId'>): COCISource {
  return { '@type': 'COCISource', ... value }
}

export function newCSUSupplementalSource(): CSUSupplementalSource {
  return { '@type': 'CSUSupplementalSource' }
}

export function newELumenSource(): ELumenSource {
  return { '@type': 'ELumenSource' }
}

export function newGenericCollegeSource(): GenericCollegeSource {
  return { '@type': 'GenericCollegeSource' }
}

export function newInternalSource(): InternalSource {
  return { '@type': 'InternalSource' }
}

export function newPeopleSoftSource(): PeopleSoftSource {
  return { '@type': 'PeopleSoftSource' }
}

export function newUCGenericCollegeSource(): UCGenericCollegeSource {
  return { '@type': 'UCGenericCollegeSource' }
}


// Added by 'TypeGuardExtension' extension

export function isCourseSimilarity(value: any): value is CourseSimilarity {
  return value && value['@type'] === 'CourseSimilarity';
}

export function isCourseSummaryForAlignment(value: any): value is CourseSummaryForAlignment {
  return value && value['@type'] === 'CourseSummaryForAlignment';
}

export function isProgramSimilarity(value: any): value is ProgramSimilarity {
  return value && value['@type'] === 'ProgramSimilarity';
}

export function isProgramSummaryForAlignment(value: any): value is ProgramSummaryForAlignment {
  return value && value['@type'] === 'ProgramSummaryForAlignment';
}

export function isBadgeRowWithNumber(value: any): value is BadgeRowWithNumber {
  return value && value['@type'] === 'BadgeRowWithNumber';
}

export function isCourseActiveAmendRow(value: any): value is CourseActiveAmendRow {
  return value && value['@type'] === 'CourseActiveAmendHandler$CourseActiveAmendRow';
}

export function isCourseDescriptionAmendRow(value: any): value is CourseDescriptionAmendRow {
  return value && value['@type'] === 'CourseDescriptionAmendHandler$CourseDescriptionAmendRow';
}

export function isCourseRequisitesAmendRow(value: any): value is CourseRequisitesAmendRow {
  return value && value['@type'] === 'CourseRequisitesAmendHandler$CourseRequisitesAmendRow';
}

export function isCourseRowWithNumber(value: any): value is CourseRowWithNumber {
  return value && value['@type'] === 'CourseRowWithNumber';
}

export function isCourseUnitsAmendRow(value: any): value is CourseUnitsAmendRow {
  return value && value['@type'] === 'CourseUnitsAmendHandler$CourseUnitsAmendRow';
}

export function isProgramActiveAmendRow(value: any): value is ProgramActiveAmendRow {
  return value && value['@type'] === 'ProgramActiveAmendHandler$ProgramActiveAmendRow';
}

export function isProgramBadgeClassAmendRow(value: any): value is ProgramBadgeClassAmendRow {
  return value && value['@type'] === 'ProgramBadgeClassAmendHandler$ProgramBadgeClassAmendRow';
}

export function isProgramDescriptionAmendRow(value: any): value is ProgramDescriptionAmendRow {
  return value && value['@type'] === 'ProgramDescriptionAmendHandler$ProgramDescriptionAmendRow';
}

export function isProgramOutcomesAmendRow(value: any): value is ProgramOutcomesAmendRow {
  return value && value['@type'] === 'ProgramLearningOutcomesAmendHandler$ProgramOutcomesAmendRow';
}

export function isProgramRowWithNumber(value: any): value is ProgramRowWithNumber {
  return value && value['@type'] === 'ProgramRowWithNumber';
}

export function isProgramVideoAmendRow(value: any): value is ProgramVideoAmendRow {
  return value && value['@type'] === 'ProgramVideoAmendHandler$ProgramVideoAmendRow';
}

export function isApiEntityRequest(value: any): value is ApiEntityRequest {
  return value && value['@type'] === 'ApiEntityRequest';
}

export function isApiEntityResponse(value: any): value is ApiEntityResponse {
  return value && value['@type'] === 'ApiEntityResponse';
}

export function isEntityAliasApiEntity(value: any): value is EntityAliasApiEntity<any, any> {
  return value && value['@type'] === 'EntityAliasApiEntity';
}

export function isEntitySetApiEntity(value: any): value is EntitySetApiEntity<any, any> {
  return value && value['@type'] === 'EntitySetApiEntity';
}

export function isAcceptAlignmentSuggestion(value: any): value is AcceptAlignmentSuggestion {
  return value && value['@type'] === 'AcceptAlignmentSuggestion';
}

export function isAcceptSuggestionResult(value: any): value is AcceptSuggestionResult {
  return value && value['@type'] === 'AcceptSuggestionResult';
}

export function isAddCorrectionsAction(value: any): value is AddCorrectionsAction {
  return value && value['@type'] === 'AddCorrectionsAction';
}

export function isAddLocalCourseAction(value: any): value is AddLocalCourseAction {
  return value && value['@type'] === 'AddLocalCourseAction';
}

export function isAddLocalProgramAction(value: any): value is AddLocalProgramAction {
  return value && value['@type'] === 'AddLocalProgramAction';
}

export function isAggregateAlignmentCounts(value: any): value is AggregateAlignmentCounts {
  return value && value['@type'] === 'AggregateAlignmentCounts';
}

export function isAggregateCleanCounts(value: any): value is AggregateCleanCounts {
  return value && value['@type'] === 'AggregateCleanCounts';
}

export function isAggregateNoticeCounts(value: any): value is AggregateNoticeCounts {
  return value && value['@type'] === 'AggregateNoticeCounts';
}

export function isAggregateSourceCounts(value: any): value is AggregateSourceCounts {
  return value && value['@type'] === 'AggregateSourceCounts';
}

export function isArchiveCurriculumYearAction(value: any): value is ArchiveCurriculumYearAction {
  return value && value['@type'] === 'ArchiveCurriculumYearAction';
}

export function isBulkAmendCorrectionsAction(value: any): value is BulkAmendCorrectionsAction {
  return value && value['@type'] === 'BulkAmendCorrectionsAction';
}

export function isBulkAmendTypeApiObject(value: any): value is BulkAmendTypeApiObject {
  return value && value['@type'] === 'BulkAmendTypeApiObject';
}

export function isCleanCounts(value: any): value is CleanCounts {
  return value && value['@type'] === 'CleanCounts';
}

export function isCollegeNotFound(value: any): value is CollegeNotFound {
  return value && value['@type'] === 'CollegeNotFound';
}

export function isCorrectMultipleRecords(value: any): value is CorrectMultipleRecords {
  return value && value['@type'] === 'CorrectMultipleRecords';
}

export function isCourseApiObject(value: any): value is CourseApiObject {
  return value && value['@type'] === 'CourseApiObject';
}

export function isCourseForPublishPreview(value: any): value is CourseForPublishPreview {
  return value && value['@type'] === 'CourseForPublishPreview';
}

export function isCourseForSearchResult(value: any): value is CourseForSearchResult {
  return value && value['@type'] === 'CourseForSearchResult';
}

export function isCourseListAddRequest(value: any): value is CourseListAddRequest {
  return value && value['@type'] === 'CourseListAddRequest';
}

export function isCourseListApiObject(value: any): value is CourseListApiObject {
  return value && value['@type'] === 'CourseListApiObject';
}

export function isCourseListByIdAction(value: any): value is CourseListByIdAction {
  return value && value['@type'] === 'CourseListByIdAction';
}

export function isCourseListForPublishPreview(value: any): value is CourseListForPublishPreview {
  return value && value['@type'] === 'CourseListForPublishPreview';
}

export function isCourseListId(value: any): value is CourseListId {
  return value && value['@type'] === 'CourseListId';
}

export function isCourseSourceRecordSummary(value: any): value is CourseSourceRecordSummary {
  return value && value['@type'] === 'CourseSourceRecordSummary';
}

export function isCreateCurriculumYearAction(value: any): value is CreateCurriculumYearAction {
  return value && value['@type'] === 'CreateCurriculumYearAction';
}

export function isCreateHighSchoolAction(value: any): value is CreateHighSchoolAction {
  return value && value['@type'] === 'CreateHighSchoolAction';
}

export function isCreateHighSchoolResponse(value: any): value is CreateHighSchoolResponse {
  return value && value['@type'] === 'CreateHighSchoolResponse';
}

export function isCurriculumEntityDetailAction(value: any): value is CurriculumEntityDetailAction {
  return value && value['@type'] === 'CurriculumEntityDetailAction';
}

export function isCurriculumEntityDetailMissing(value: any): value is CurriculumEntityDetailMissing {
  return value && value['@type'] === 'CurriculumEntityDetailMissing';
}

export function isCurriculumEntityId(value: any): value is CurriculumEntityId {
  return value && value['@type'] === 'CurriculumEntityId';
}

export function isCurriculumEntitySummary(value: any): value is CurriculumEntitySummary {
  return value && value['@type'] === 'CurriculumEntitySummary';
}

export function isCurriculumRevisionApiObject(value: any): value is CurriculumRevisionApiObject {
  return value && value['@type'] === 'CurriculumRevisionApiObject';
}

export function isCurriculumYearCreationError(value: any): value is CurriculumYearCreationError {
  return value && value['@type'] === 'CurriculumYearCreationError';
}

export function isCurriculumYearCreationSuccess(value: any): value is CurriculumYearCreationSuccess {
  return value && value['@type'] === 'CurriculumYearCreationSuccess';
}

export function isCurriculumYearHistoryResponse(value: any): value is CurriculumYearHistoryResponse {
  return value && value['@type'] === 'CurriculumYearHistoryResponse';
}

export function isCurriculumYearNotFoundError(value: any): value is CurriculumYearNotFoundError {
  return value && value['@type'] === 'CurriculumYearNotFoundError';
}

export function isCurriculumYearsForCollegeResponse(value: any): value is CurriculumYearsForCollegeResponse {
  return value && value['@type'] === 'CurriculumYearsForCollegeResponse';
}

export function isDeactivateSourceSystemAction(value: any): value is DeactivateSourceSystemAction {
  return value && value['@type'] === 'DeactivateSourceSystemAction';
}

export function isDeleteCourseListAction(value: any): value is DeleteCourseListAction {
  return value && value['@type'] === 'DeleteCourseListAction';
}

export function isDummyApiEntityId(value: any): value is DummyApiEntityId {
  return value && value['@type'] === 'DummyApiEntityId';
}

export function isDummyEntityAliasApiEntityId(value: any): value is DummyEntityAliasApiEntityId {
  return value && value['@type'] === 'DummyEntityAliasApiEntityId';
}

export function isDummyEntitySetApiEntityId(value: any): value is DummyEntitySetApiEntityId {
  return value && value['@type'] === 'DummyEntitySetApiEntityId';
}

export function isDuplicateImportedCoursesResponse(value: any): value is DuplicateImportedCoursesResponse {
  return value && value['@type'] === 'DuplicateImportedCoursesResponse';
}

export function isEditCurriculumNotesAction(value: any): value is EditCurriculumNotesAction {
  return value && value['@type'] === 'EditCurriculumNotesAction';
}

export function isEditHighSchoolAction(value: any): value is EditHighSchoolAction {
  return value && value['@type'] === 'EditHighSchoolAction';
}

export function isEditHighSchoolResponse(value: any): value is EditHighSchoolResponse {
  return value && value['@type'] === 'EditHighSchoolResponse';
}

export function isEntityIsAlignedError(value: any): value is EntityIsAlignedError {
  return value && value['@type'] === 'EntityIsAlignedError';
}

export function isEntityIsMissingCriticalDataError(value: any): value is EntityIsMissingCriticalDataError {
  return value && value['@type'] === 'EntityIsMissingCriticalDataError';
}

export function isFetchAndImportSourceFileAction(value: any): value is FetchAndImportSourceFileAction {
  return value && value['@type'] === 'FetchAndImportSourceFileAction';
}

export function isFindCipCodesAction(value: any): value is FindCipCodesAction {
  return value && value['@type'] === 'FindCipCodesAction';
}

export function isFindCipCodesResponse(value: any): value is FindCipCodesResponse {
  return value && value['@type'] === 'FindCipCodesResponse';
}

export function isFindCollegeBySlugAction(value: any): value is FindCollegeBySlugAction {
  return value && value['@type'] === 'FindCollegeBySlugAction';
}

export function isFindCourseListsAction(value: any): value is FindCourseListsAction {
  return value && value['@type'] === 'FindCourseListsAction';
}

export function isFindCoursesAction(value: any): value is FindCoursesAction {
  return value && value['@type'] === 'FindCoursesAction';
}

export function isFindCurriculumYearAction(value: any): value is FindCurriculumYearAction {
  return value && value['@type'] === 'FindCurriculumYearAction';
}

export function isFindCurriculumYearsForCollegeAction(value: any): value is FindCurriculumYearsForCollegeAction {
  return value && value['@type'] === 'FindCurriculumYearsForCollegeAction';
}

export function isFindGenEdPatternsAction(value: any): value is FindGenEdPatternsAction {
  return value && value['@type'] === 'FindGenEdPatternsAction';
}

export function isFindGenEdPatternsResponse(value: any): value is FindGenEdPatternsResponse {
  return value && value['@type'] === 'FindGenEdPatternsResponse';
}

export function isFindImportedBadgesAction(value: any): value is FindImportedBadgesAction {
  return value && value['@type'] === 'FindImportedBadgesAction';
}

export function isFindImportedBadgesResponse(value: any): value is FindImportedBadgesResponse {
  return value && value['@type'] === 'FindImportedBadgesResponse';
}

export function isFindPickableCollegesAction(value: any): value is FindPickableCollegesAction {
  return value && value['@type'] === 'FindPickableCollegesAction';
}

export function isFindPickableCollegesResponse(value: any): value is FindPickableCollegesResponse {
  return value && value['@type'] === 'FindPickableCollegesResponse';
}

export function isFindPickableCoursesAction(value: any): value is FindPickableCoursesAction {
  return value && value['@type'] === 'FindPickableCoursesAction';
}

export function isFindPickableCoursesResponse(value: any): value is FindPickableCoursesResponse {
  return value && value['@type'] === 'FindPickableCoursesResponse';
}

export function isFindProgramsAction(value: any): value is FindProgramsAction {
  return value && value['@type'] === 'FindProgramsAction';
}

export function isFindTopCodesAction(value: any): value is FindTopCodesAction {
  return value && value['@type'] === 'FindTopCodesAction';
}

export function isFindTopCodesResponse(value: any): value is FindTopCodesResponse {
  return value && value['@type'] === 'FindTopCodesResponse';
}

export function isGenEdPatternApiObject(value: any): value is GenEdPatternApiObject {
  return value && value['@type'] === 'GenEdPatternApiObject';
}

export function isGenEdPatternArea(value: any): value is GenEdPatternArea {
  return value && value['@type'] === 'GenEdPatternArea';
}

export function isGenEdPatternForPublishPreview(value: any): value is GenEdPatternForPublishPreview {
  return value && value['@type'] === 'GenEdPatternForPublishPreview';
}

export function isGenEdPatternSubArea(value: any): value is GenEdPatternSubArea {
  return value && value['@type'] === 'GenEdPatternSubArea';
}

export function isGenerateCollegeReportAction(value: any): value is GenerateCollegeReportAction {
  return value && value['@type'] === 'GenerateCollegeReportAction';
}

export function isGetCoursesByHighSchoolAction(value: any): value is GetCoursesByHighSchoolAction {
  return value && value['@type'] === 'GetCoursesByHighSchoolAction';
}

export function isGetCoursesByHighSchoolResponse(value: any): value is GetCoursesByHighSchoolResponse {
  return value && value['@type'] === 'GetCoursesByHighSchoolResponse';
}

export function isGetCurriculumYearHistoryAction(value: any): value is GetCurriculumYearHistoryAction {
  return value && value['@type'] === 'GetCurriculumYearHistoryAction';
}

export function isGetDuplicateImportedCoursesAction(value: any): value is GetDuplicateImportedCoursesAction {
  return value && value['@type'] === 'GetDuplicateImportedCoursesAction';
}

export function isGetGenEdPatternAction(value: any): value is GetGenEdPatternAction {
  return value && value['@type'] === 'GetGenEdPatternAction';
}

export function isGetImportedCoursesAction(value: any): value is GetImportedCoursesAction {
  return value && value['@type'] === 'GetImportedCoursesAction';
}

export function isGetImportedProgramsAction(value: any): value is GetImportedProgramsAction {
  return value && value['@type'] === 'GetImportedProgramsAction';
}

export function isGetImportedProgramsMissingTitleAndAwardAction(value: any): value is GetImportedProgramsMissingTitleAndAwardAction {
  return value && value['@type'] === 'GetImportedProgramsMissingTitleAndAwardAction';
}

export function isHighSchoolCoursesApiObject(value: any): value is HighSchoolCoursesApiObject {
  return value && value['@type'] === 'HighSchoolCoursesApiObject';
}

export function isImportBadgeFileAction(value: any): value is ImportBadgeFileAction {
  return value && value['@type'] === 'ImportBadgeFileAction';
}

export function isImportCorrections(value: any): value is ImportCorrections {
  return value && value['@type'] === 'ImportCorrections';
}

export function isImportSourceFileAction(value: any): value is ImportSourceFileAction {
  return value && value['@type'] === 'ImportSourceFileAction';
}

export function isImportedCoursesResponse(value: any): value is ImportedCoursesResponse {
  return value && value['@type'] === 'ImportedCoursesResponse';
}

export function isImportedProgramsMissingTitleAndAwardResponse(value: any): value is ImportedProgramsMissingTitleAndAwardResponse {
  return value && value['@type'] === 'ImportedProgramsMissingTitleAndAwardResponse';
}

export function isImportedProgramsResponse(value: any): value is ImportedProgramsResponse {
  return value && value['@type'] === 'ImportedProgramsResponse';
}

export function isInvalidateAllAction(value: any): value is InvalidateAllAction {
  return value && value['@type'] === 'InvalidateAllAction';
}

export function isListCoursesWithAlignmentSuggestions(value: any): value is ListCoursesWithAlignmentSuggestions {
  return value && value['@type'] === 'ListCoursesWithAlignmentSuggestions';
}

export function isListProgramsWithAlignmentSuggestions(value: any): value is ListProgramsWithAlignmentSuggestions {
  return value && value['@type'] === 'ListProgramsWithAlignmentSuggestions';
}

export function isMarkPublishedAction(value: any): value is MarkPublishedAction {
  return value && value['@type'] === 'MarkPublishedAction';
}

export function isNoSuchEntityAlignmentError(value: any): value is NoSuchEntityAlignmentError {
  return value && value['@type'] === 'NoSuchEntityAlignmentError';
}

export function isNotFound(value: any): value is NotFound {
  return value && value['@type'] === 'NotFound';
}

export function isNoticeCountSummary(value: any): value is NoticeCountSummary {
  return value && value['@type'] === 'NoticeCountSummary';
}

export function isPaginatedCourseListSearchResults(value: any): value is PaginatedCourseListSearchResults {
  return value && value['@type'] === 'PaginatedCourseListSearchResults';
}

export function isPaginatedFilteredCourseSearchResults(value: any): value is PaginatedFilteredCourseSearchResults {
  return value && value['@type'] === 'PaginatedFilteredCourseSearchResults';
}

export function isPaginatedFilteredProgramSearchResults(value: any): value is PaginatedFilteredProgramSearchResults {
  return value && value['@type'] === 'PaginatedFilteredProgramSearchResults';
}

export function isPaginatedResults(value: any): value is PaginatedResults<any> {
  return value && value['@type'] === 'PaginatedResults';
}

export function isPickableCourse(value: any): value is PickableCourse {
  return value && value['@type'] === 'PickableCourse';
}

export function isPickableProgram(value: any): value is PickableProgram {
  return value && value['@type'] === 'PickableProgram';
}

export function isPickedCipCode(value: any): value is PickedCipCode {
  return value && value['@type'] === 'PickedCipCode';
}

export function isPickedCourse(value: any): value is PickedCourse {
  return value && value['@type'] === 'PickedCourse';
}

export function isPickedTopCode(value: any): value is PickedTopCode {
  return value && value['@type'] === 'PickedTopCode';
}

export function isProgramApiObject(value: any): value is ProgramApiObject {
  return value && value['@type'] === 'ProgramApiObject';
}

export function isProgramForPublishPreview(value: any): value is ProgramForPublishPreview {
  return value && value['@type'] === 'ProgramForPublishPreview';
}

export function isProgramForSearchResult(value: any): value is ProgramForSearchResult {
  return value && value['@type'] === 'ProgramForSearchResult';
}

export function isProgramSourceRecordSummary(value: any): value is ProgramSourceRecordSummary {
  return value && value['@type'] === 'ProgramSourceRecordSummary';
}

export function isPublishCurriculumAction(value: any): value is PublishCurriculumAction {
  return value && value['@type'] === 'PublishCurriculumAction';
}

export function isPublishPreview(value: any): value is PublishPreview {
  return value && value['@type'] === 'PublishPreview';
}

export function isPublishPreviewAction(value: any): value is PublishPreviewAction {
  return value && value['@type'] === 'PublishPreviewAction';
}

export function isRecordMutationAction(value: any): value is RecordMutationAction {
  return value && value['@type'] === 'RecordMutationAction';
}

export function isRejectSuggestions(value: any): value is RejectSuggestions {
  return value && value['@type'] === 'RejectSuggestions';
}

export function isRemapPersistentIdAction(value: any): value is RemapPersistentIdAction {
  return value && value['@type'] === 'RemapPersistentIdAction';
}

export function isRenameEntityAction(value: any): value is RenameEntityAction {
  return value && value['@type'] === 'RenameEntityAction';
}

export function isRenameEntityErrors(value: any): value is RenameEntityErrors {
  return value && value['@type'] === 'RenameEntityErrors';
}

export function isRenameMultipleRecords(value: any): value is RenameMultipleRecords {
  return value && value['@type'] === 'RenameMultipleRecords';
}

export function isSearchCourseAlignmentCandidates(value: any): value is SearchCourseAlignmentCandidates {
  return value && value['@type'] === 'SearchCourseAlignmentCandidates';
}

export function isSearchHighSchoolsByCollegeAction(value: any): value is SearchHighSchoolsByCollegeAction {
  return value && value['@type'] === 'SearchHighSchoolsByCollegeAction';
}

export function isSearchHighSchoolsResponse(value: any): value is SearchHighSchoolsResponse {
  return value && value['@type'] === 'SearchHighSchoolsResponse';
}

export function isSearchProgramAlignmentCandidates(value: any): value is SearchProgramAlignmentCandidates {
  return value && value['@type'] === 'SearchProgramAlignmentCandidates';
}

export function isSourceCountSummaries(value: any): value is SourceCountSummaries {
  return value && value['@type'] === 'SourceCountSummaries';
}

export function isSourceRecordDetailAction(value: any): value is SourceRecordDetailAction {
  return value && value['@type'] === 'SourceRecordDetailAction';
}

export function isSourceRecordDetailApiObject(value: any): value is SourceRecordDetailApiObject<any> {
  return value && value['@type'] === 'SourceRecordDetailApiObject';
}

export function isUpdateCourseListAction(value: any): value is UpdateCourseListAction {
  return value && value['@type'] === 'UpdateCourseListAction';
}

export function isUpdateGenEdAction(value: any): value is UpdateGenEdAction {
  return value && value['@type'] === 'UpdateGenEdAction';
}

export function isCollegeReportCourseSummary(value: any): value is CollegeReportCourseSummary {
  return value && value['@type'] === 'CollegeReportCourseSummary';
}

export function isCollegeReportProgramSummary(value: any): value is CollegeReportProgramSummary {
  return value && value['@type'] === 'CollegeReportProgramSummary';
}

export function isReportField(value: any): value is ReportField<any> {
  return value && value['@type'] === 'ReportField';
}

export function isCourseListAdded(value: any): value is CourseListAdded {
  return value && value['@type'] === 'AddCourseListApiResponse$CourseListAdded';
}

export function isYearAdded(value: any): value is YearAdded {
  return value && value['@type'] === 'AddCurriculumYearApiResponse$YearAdded';
}

export function isYearAlreadyExists(value: any): value is YearAlreadyExists {
  return value && value['@type'] === 'AddCurriculumYearApiResponse$YearAlreadyExists';
}

export function isEnumWrapper(value: any): value is EnumWrapper<any> {
  return value && value['@type'] === 'ApiEither$EnumWrapper';
}

export function isFailure(value: any): value is Failure<any, any> {
  return value && value['@type'] === 'ApiEither$Failure';
}

export function isSuccess(value: any): value is Success<any, any> {
  return value && value['@type'] === 'ApiEither$Success';
}

export function isBulkAmendErrors(value: any): value is BulkAmendErrors {
  return value && value['@type'] === 'BulkAmendErrors';
}

export function isBulkAmendResult(value: any): value is BulkAmendResult {
  return value && value['@type'] === 'BulkAmendResult';
}

export function isCollegeReport(value: any): value is CollegeReport {
  return value && value['@type'] === 'CollegeReport';
}

export function isDuplicateRow(value: any): value is DuplicateRow {
  return value && value['@type'] === 'DuplicateRow';
}

export function isInvalidCollege(value: any): value is InvalidCollege {
  return value && value['@type'] === 'InvalidCollege';
}

export function isMergeKeyNotFound(value: any): value is MergeKeyNotFound {
  return value && value['@type'] === 'MergeKeyNotFound';
}

export function isMergeSummary(value: any): value is MergeSummary {
  return value && value['@type'] === 'MergeSummary';
}

export function isNothing(value: any): value is Nothing {
  return value && value['@type'] === 'Nothing';
}

export function isPublishConflict(value: any): value is PublishConflict {
  return value && value['@type'] === 'PublishCurriculumApiResponse$PublishConflict';
}

export function isRemoteServerPublishError(value: any): value is RemoteServerPublishError {
  return value && value['@type'] === 'PublishCurriculumApiResponse$RemoteServerPublishError';
}

export function isSuccessfulPublish(value: any): value is SuccessfulPublish {
  return value && value['@type'] === 'PublishCurriculumApiResponse$SuccessfulPublish';
}

export function isEntitySaved(value: any): value is EntitySaved {
  return value && value['@type'] === 'SaveEntityApiResponse$EntitySaved';
}

export function isSlugConflict(value: any): value is SlugConflict {
  return value && value['@type'] === 'SaveEntityApiResponse$SlugConflict';
}

export function isValueNotImportable(value: any): value is ValueNotImportable {
  return value && value['@type'] === 'ValueNotImportable';
}

export function isCurriculumYearMissing(value: any): value is CurriculumYearMissing {
  return value && value['@type'] === 'CurriculumYearMissing';
}

export function isAuthenticatedUser(value: any): value is AuthenticatedUser {
  return value && value['@type'] === 'AuthenticatedUser';
}

export function isForgotPasswordRequest(value: any): value is ForgotPasswordRequest {
  return value && value['@type'] === 'ForgotPasswordRequest';
}

export function isResetPasswordRequest(value: any): value is ResetPasswordRequest {
  return value && value['@type'] === 'ResetPasswordRequest';
}

export function isUserTokenCreateRequest(value: any): value is UserTokenCreateRequest {
  return value && value['@type'] === 'UserTokenCreateRequest';
}

export function isCurriculumEntitySearchCriteria(value: any): value is CurriculumEntitySearchCriteria {
  return value && value['@type'] === 'CurriculumEntitySearchCriteria';
}

export function isNoActor(value: any): value is NoActor {
  return value && value['@type'] === 'NoActor';
}

export function isPreAuthUser(value: any): value is PreAuthUser {
  return value && value['@type'] === 'PreAuthUser';
}

export function isCourseIdentifyingValues(value: any): value is CourseIdentifyingValues {
  return value && value['@type'] === 'CourseIdentifyingValues';
}

export function isCourseRecord(value: any): value is CourseRecord {
  return value && value['@type'] === 'CourseRecord';
}

export function isRichCourseRecord(value: any): value is RichCourseRecord {
  return value && value['@type'] === 'RichCourseRecord';
}

export function isBadgeSystemNotReachableError(value: any): value is BadgeSystemNotReachableError {
  return value && value['@type'] === 'ParseErrorApiObject$BadgeSystemNotReachableError';
}

export function isCociNotReachableError(value: any): value is CociNotReachableError {
  return value && value['@type'] === 'ParseErrorApiObject$CociNotReachableError';
}

export function isNoSourceConfiguredError(value: any): value is NoSourceConfiguredError {
  return value && value['@type'] === 'ParseErrorApiObject$NoSourceConfiguredError';
}

export function isNotParsableError(value: any): value is NotParsableError {
  return value && value['@type'] === 'ParseErrorApiObject$NotParsableError';
}

export function isParseValidationError(value: any): value is ParseValidationError {
  return value && value['@type'] === 'ParseErrorApiObject$ParseValidationError';
}

export function isSourceNotFetchableError(value: any): value is SourceNotFetchableError {
  return value && value['@type'] === 'ParseErrorApiObject$SourceNotFetchableError';
}

export function isAbsentValue(value: any): value is AbsentValue<any> {
  return value && value['@type'] === 'AbsentValue';
}

export function isMergedValue(value: any): value is MergedValue<any> {
  return value && value['@type'] === 'MergedValue';
}

export function isPatchedValue(value: any): value is PatchedValue<any> {
  return value && value['@type'] === 'PatchedValue';
}

export function isSourceValue(value: any): value is SourceValue<any> {
  return value && value['@type'] === 'SourceValue';
}

export function isHighSchool(value: any): value is HighSchool {
  return value && value['@type'] === 'HighSchool';
}

export function isAlignmentSuggestion(value: any): value is AlignmentSuggestion<any, any> {
  return value && value['@type'] === 'AlignmentSuggestion';
}

export function isAlignmentSuggestionsForEntity(value: any): value is AlignmentSuggestionsForEntity<any, any> {
  return value && value['@type'] === 'AlignmentSuggestionsForEntity';
}

export function isSearchAlignmentCandidatesResults(value: any): value is SearchAlignmentCandidatesResults<any, any> {
  return value && value['@type'] === 'SearchAlignmentCandidatesResults';
}

export function isSourceCountSummary(value: any): value is SourceCountSummary {
  return value && value['@type'] === 'SourceCountSummary';
}

export function isStandardOccupation(value: any): value is StandardOccupation {
  return value && value['@type'] === 'StandardOccupation';
}

export function isMasterRecordKey(value: any): value is MasterRecordKey {
  return value && value['@type'] === 'MasterRecordKey';
}

export function isSourceRecordKey(value: any): value is SourceRecordKey {
  return value && value['@type'] === 'SourceRecordKey';
}

export function isActiveSourceRecordExcluded(value: any): value is ActiveSourceRecordExcluded {
  return value && value['@type'] === 'ActiveSourceRecordExcluded';
}

export function isCipCodeWithoutSOCs(value: any): value is CipCodeWithoutSOCs {
  return value && value['@type'] === 'CipCodeWithoutSOCs';
}

export function isCourseDescriptionSameAsSubjectAndNumber(value: any): value is CourseDescriptionSameAsSubjectAndNumber {
  return value && value['@type'] === 'CourseDescriptionSameAsSubjectAndNumber';
}

export function isCourseTitleSameAsSubjectAndNumber(value: any): value is CourseTitleSameAsSubjectAndNumber {
  return value && value['@type'] === 'CourseTitleSameAsSubjectAndNumber';
}

export function isCyclicCourseRequisite(value: any): value is CyclicCourseRequisite {
  return value && value['@type'] === 'CyclicCourseRequisite';
}

export function isDataAddedManually(value: any): value is DataAddedManually<any, any> {
  return value && value['@type'] === 'DataAddedManually';
}

export function isDataCorrectedManually(value: any): value is DataCorrectedManually<any, any> {
  return value && value['@type'] === 'DataCorrectedManually';
}

export function isDeprecatedPattern(value: any): value is DeprecatedPattern {
  return value && value['@type'] === 'DeprecatedPattern';
}

export function isDescriptionSameAsTitle(value: any): value is DescriptionSameAsTitle {
  return value && value['@type'] === 'DescriptionSameAsTitle';
}

export function isDuplicatesAutoResolved(value: any): value is DuplicatesAutoResolved {
  return value && value['@type'] === 'DuplicatesAutoResolved';
}

export function isHasNoPublishableCourses(value: any): value is HasNoPublishableCourses {
  return value && value['@type'] === 'HasNoPublishableCourses';
}

export function isInactiveSourceRecordIncluded(value: any): value is InactiveSourceRecordIncluded {
  return value && value['@type'] === 'InactiveSourceRecordIncluded';
}

export function isInconsistentDataFromSource(value: any): value is InconsistentDataFromSource<any, any> {
  return value && value['@type'] === 'InconsistentDataFromSource';
}

export function isInconsistentFields(value: any): value is InconsistentFields {
  return value && value['@type'] === 'InconsistentFields';
}

export function isInvalidOptionalData(value: any): value is InvalidOptionalData {
  return value && value['@type'] === 'InvalidOptionalData';
}

export function isInvalidOptionalFields(value: any): value is InvalidOptionalFields {
  return value && value['@type'] === 'InvalidOptionalFields';
}

export function isInvalidRequiredData(value: any): value is InvalidRequiredData {
  return value && value['@type'] === 'InvalidRequiredData';
}

export function isInvalidRequiredFields(value: any): value is InvalidRequiredFields {
  return value && value['@type'] === 'InvalidRequiredFields';
}

export function isManuallyAddedFields(value: any): value is ManuallyAddedFields {
  return value && value['@type'] === 'ManuallyAddedFields';
}

export function isManuallyCorrectedFields(value: any): value is ManuallyCorrectedFields {
  return value && value['@type'] === 'ManuallyCorrectedFields';
}

export function isMissingDataFromSource(value: any): value is MissingDataFromSource<any, any> {
  return value && value['@type'] === 'MissingDataFromSource';
}

export function isMissingOptionalData(value: any): value is MissingOptionalData {
  return value && value['@type'] === 'MissingOptionalData';
}

export function isMissingOptionalFields(value: any): value is MissingOptionalFields {
  return value && value['@type'] === 'MissingOptionalFields';
}

export function isMissingRequiredData(value: any): value is MissingRequiredData {
  return value && value['@type'] === 'MissingRequiredData';
}

export function isMissingRequiredFields(value: any): value is MissingRequiredFields {
  return value && value['@type'] === 'MissingRequiredFields';
}

export function isMissingSystems(value: any): value is MissingSystems {
  return value && value['@type'] === 'MissingSystems';
}

export function isNonPublishableAwardType(value: any): value is NonPublishableAwardType {
  return value && value['@type'] === 'NonPublishableAwardType';
}

export function isNonPublishableRequisites(value: any): value is NonPublishableRequisites {
  return value && value['@type'] === 'NonPublishableRequisites';
}

export function isSomeInactiveCourses(value: any): value is SomeInactiveCourses {
  return value && value['@type'] === 'SomeInactiveCourses';
}

export function isSomeMissingCourses(value: any): value is SomeMissingCourses {
  return value && value['@type'] === 'SomeMissingCourses';
}

export function isSomeNonPublishableCourses(value: any): value is SomeNonPublishableCourses {
  return value && value['@type'] === 'SomeNonPublishableCourses';
}

export function isSomePublishableCourses(value: any): value is SomePublishableCourses {
  return value && value['@type'] === 'SomePublishableCourses';
}

export function isSourceDuplicates(value: any): value is SourceDuplicates {
  return value && value['@type'] === 'SourceDuplicates';
}

export function isSpellingWarning(value: any): value is SpellingWarning<any> {
  return value && value['@type'] === 'SpellingWarning';
}

export function isStartsWithNumber(value: any): value is StartsWithNumber {
  return value && value['@type'] === 'StartsWithNumber';
}

export function isSuspiciousDataFields(value: any): value is SuspiciousDataFields {
  return value && value['@type'] === 'SuspiciousDataFields';
}

export function isTopCodeWithoutSOCs(value: any): value is TopCodeWithoutSOCs {
  return value && value['@type'] === 'TopCodeWithoutSOCs';
}

export function isUnmergeableRecord(value: any): value is UnmergeableRecord {
  return value && value['@type'] === 'UnmergeableRecord';
}

export function isUnresolvedDuplicates(value: any): value is UnresolvedDuplicates {
  return value && value['@type'] === 'UnresolvedDuplicates';
}

export function isUnusuallyShort(value: any): value is UnusuallyShort {
  return value && value['@type'] === 'UnusuallyShort';
}

export function isProgramIdentifyingValues(value: any): value is ProgramIdentifyingValues {
  return value && value['@type'] === 'ProgramIdentifyingValues';
}

export function isProgramRecord(value: any): value is ProgramRecord {
  return value && value['@type'] === 'ProgramRecord';
}

export function isRichProgramRecord(value: any): value is RichProgramRecord {
  return value && value['@type'] === 'RichProgramRecord';
}

export function isAlignmentCountSummary(value: any): value is AlignmentCountSummary {
  return value && value['@type'] === 'AlignmentCountSummary';
}

export function isIdentifyingAttributesMissing(value: any): value is IdentifyingAttributesMissing {
  return value && value['@type'] === 'IdentifyingAttributesMissing';
}

export function isImportRowWithNumber(value: any): value is ImportRowWithNumber {
  return value && value['@type'] === 'ImportRowWithNumber';
}

export function isSetValue(value: any): value is SetValue<any, any> {
  return value && value['@type'] === 'SetValue';
}

export function isSourceRecordDetail(value: any): value is SourceRecordDetail<any> {
  return value && value['@type'] === 'SourceRecordDetail';
}

export function isCourseGroup(value: any): value is CourseGroup {
  return value && value['@type'] === 'CourseGroup';
}

export function isGenEdCurriculumBranch(value: any): value is GenEdCurriculumBranch {
  return value && value['@type'] === 'GenEdCurriculumBranch';
}

export function isGenEdCurriculumLeaf(value: any): value is GenEdCurriculumLeaf {
  return value && value['@type'] === 'GenEdCurriculumLeaf';
}

export function isPaginatedFilteredCipCodeSearchResults(value: any): value is PaginatedFilteredCipCodeSearchResults {
  return value && value['@type'] === 'PaginatedFilteredCipCodeSearchResults';
}

export function isPaginatedFilteredImportedBadgesSearchResults(value: any): value is PaginatedFilteredImportedBadgesSearchResults {
  return value && value['@type'] === 'PaginatedFilteredImportedBadgesSearchResults';
}

export function isPaginatedFilteredTopCodeSearchResults(value: any): value is PaginatedFilteredTopCodeSearchResults {
  return value && value['@type'] === 'PaginatedFilteredTopCodeSearchResults';
}

export function isCollegeApiEntity(value: any): value is CollegeApiEntity {
  return value && value['@type'] === 'CollegeApiEntity';
}

export function isCurriculumYearApiObject(value: any): value is CurriculumYearApiObject {
  return value && value['@type'] === 'CurriculumYearApiObject';
}

export function isCOCISource(value: any): value is COCISource {
  return value && value['@type'] === 'COCISource';
}

export function isCSUSupplementalSource(value: any): value is CSUSupplementalSource {
  return value && value['@type'] === 'CSUSupplementalSource';
}

export function isELumenSource(value: any): value is ELumenSource {
  return value && value['@type'] === 'ELumenSource';
}

export function isGenericCollegeSource(value: any): value is GenericCollegeSource {
  return value && value['@type'] === 'GenericCollegeSource';
}

export function isInternalSource(value: any): value is InternalSource {
  return value && value['@type'] === 'InternalSource';
}

export function isPeopleSoftSource(value: any): value is PeopleSoftSource {
  return value && value['@type'] === 'PeopleSoftSource';
}

export function isUCGenericCollegeSource(value: any): value is UCGenericCollegeSource {
  return value && value['@type'] === 'UCGenericCollegeSource';
}
